<template>
  <div
    class="container productDetail"
    :style="posterShow ? { overflow: 'hidden' } : {}"
    v-wechat-title="title"
  >
    <follow v-if="minipath" @follow="followFn" :path="minipath"></follow>
    <header
      v-if="!changebuytype"
      :class="{ ceiling: ceil }"
      :style="[zIndex ? { 'z-index': '-1' } : {}, follow ? { top: '0.5rem' } : { top: '0' }]"
    >
      <ul>
        <li
          @click="navClick(index)"
          :class="{ colorLis: navId == index }"
          v-for="(item, index) in nav"
          :key="index"
        >
          {{ item }}
        </li>
      </ul>
    </header>
    <div id="cup">
      <div class="maininfo d_jump" id="Glide">
        <div ref="ifscroll" class="swiper-container" id="pro_pic" style="height: auto">
          <div
            :style="[!playShow ? { 'z-index': -1 } : {}]"
            v-show="productDateils.video_play_url != ''"
          >
            <div class="swiper-slide" style="background: #333; height: 100%">
              <div
                style="width: 100%; height: 100%"
                v-if="productDateils.video_img_url != null && productDateils.video_img_url != ''"
              >
                <img :src="productDateils.video_img_url" @load="loadvideo" style="display: none" />
                <div class="zy_media">
                  <video
                    id="banner_video"
                    :poster="productDateils.video_img_url"
                    data-config="创客村"
                    webkit-playsinline="true"
                    playsinline="true"
                    x5-playsinline="true"
                    x-webkit-airplay="allow"
                    preload="true"
                  >
                    <source :src="productDateils.video_play_url" type="video/mp4" />
                    <source :src="productDateils.video_play_url" type="video/m3u8" />
                    您的浏览器不支持HTML5视频
                  </video>
                </div>
              </div>
              <div
                class="play_false"
                style="
                  position: absolute;
                  left: 0;
                  top: 0;
                  background: #f5f5f5;
                  width: 100%;
                  height: 100%;
                "
                v-if="!playShow"
              ></div>
            </div>
          </div>
          <div
            :style="[
              !imgShow ? { 'z-index': -1 } : {},
              !productDateils.video_play_url != '' ? { position: 'relative' } : {}
            ]"
            class="swiper-wrapper swiper_banner"
          >
            <div class="swiper-slide pos-r" v-for="(item, index) in bannerList" :key="index">
              <img
                class="pos-a l0 r0 t0 w-100"
                v-if="index == 0 && productDateils.grouptimeimg"
                :src="productDateils.grouptimeimg"
                style="height: auto"
                alt=""
              />
              <img
                :style="{
                  height: productDateils.img_path_height / 200 + 'rem'
                }"
                v-lazy="item"
                @click="preview(item, index, 'banner')"
              />
              <goods-float-img
                v-if="index == 0 && fullNFreeN && fullNFreeN.bgimg"
                :generat-canvas="true"
                class="pos-a l0 r0 b0"
                :full-n-free-n="fullNFreeN"
                ref="fullNFreeN"
                @img-created="imgCreatedHandler"
              ></goods-float-img>
            </div>
          </div>
          <div
            id="proSwiperPagination"
            v-show="imgShow"
            class="swiper-pagination swiper-pagination-fraction"
            v-if="bannerList && bannerList.length > 0"
          >
            <div class="pro_page">{{ activeIndex + 1 }} / {{ bannerList.length }}</div>
          </div>
          <div class="playTab" v-if="productDateils.video_play_url != ''">
            <span
              @click="playTab(0)"
              :style="
                playShow
                  ? {
                      background:
                        'linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(246,58,102,1) 100%)',
                      border: '0.01rem solid transparent',
                      color: '#FFFFFF'
                    }
                  : {}
              "
            >
              <van-icon :color="playShow ? '#ffffff' : '#353535'" size="0.11rem" :name="icon" />
              <b>视频</b>
            </span>
            <span
              @click="playTab(1)"
              :style="
                imgShow
                  ? {
                      background:
                        'linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(246,58,102,1) 100%)',
                      border: '0.01rem solid transparent',
                      color: '#FFFFFF'
                    }
                  : {}
              "
            >
              <b>图片</b>
            </span>
          </div>
        </div>
        <img v-if="blindBoxImg" style="width: 100%" :src="blindBoxImg" alt="" />
        <div>
          <div
            class="fullMinusInfo activityUI"
            v-if="activityUI && activityUITime == 0 && !changebuytype"
            style="height: 0.67rem"
          >
            <div
              class="depositWrap dai fullMinus"
              :style="{
                background: activityUI.bgImg
                  ? 'url(' + activityUI.bgImg + ') no-repeat center'
                  : '#FB0023',
                'background-size': '100% 100%'
              }"
            >
              <div>
                <van-tag
                  class="radius-10px pl6 pr6"
                  type="primary"
                  size="medium"
                  color="rgba(0, 0, 0, .2)"
                  text-color="#FFFFFF"
                >
                  <div class="pro_price flex-ae mt0">
                    <div class="xian flex-ae">
                      <span
                        class="smallprice flex-ae lh17"
                        v-if="productDateils.sales_bottom_price"
                      >
                        <sub class="f13 lh17">¥</sub>
                        <b class="f13 lh17">
                          {{
                            productDateils.sales_bottom_price
                              ? String(
                                  (
                                    parseFloat(productDateils.sales_bottom_price) +
                                    parseFloat(directReduction.directReductionPrice)
                                  ).toFixed(2)
                                ).slice(
                                  0,
                                  String(
                                    (
                                      parseFloat(productDateils.sales_bottom_price) +
                                      parseFloat(directReduction.directReductionPrice)
                                    ).toFixed(2)
                                  ).indexOf('.')
                                )
                              : '0'
                          }}
                        </b>
                        <sup class="f11" style="line-height: 0.16rem">
                          {{
                            productDateils.sales_bottom_price
                              ? String(
                                  (
                                    parseFloat(productDateils.sales_bottom_price) +
                                    parseFloat(directReduction.directReductionPrice)
                                  ).toFixed(2)
                                ).slice(
                                  String(
                                    (
                                      parseFloat(productDateils.sales_bottom_price) +
                                      parseFloat(directReduction.directReductionPrice)
                                    ).toFixed(2)
                                  ).indexOf('.'),
                                  String(
                                    (
                                      parseFloat(productDateils.sales_bottom_price) +
                                      parseFloat(directReduction.directReductionPrice)
                                    ).toFixed(2)
                                  ).length
                                )
                              : '.00'
                          }}
                        </sup>
                      </span>
                      <span
                        class="f11"
                        v-if="
                          productDateils.sales_bottom_price &&
                          parseFloat(productDateils.sales_bottom_price) !=
                            parseFloat(productDateils.sales_top_price)
                        "
                      >
                        -
                      </span>
                      <span
                        class="bigprice flex-ae"
                        v-if="
                          parseFloat(productDateils.sales_bottom_price) !=
                          parseFloat(productDateils.sales_top_price)
                        "
                      >
                        <b class="f13">
                          {{
                            productDateils.sales_top_price
                              ? String(
                                  (
                                    parseFloat(productDateils.sales_top_price) +
                                    parseFloat(directReduction.directReductionPrice)
                                  ).toFixed(2)
                                ).slice(
                                  0,
                                  String(
                                    (
                                      parseFloat(productDateils.sales_top_price) +
                                      parseFloat(directReduction.directReductionPrice)
                                    ).toFixed(2)
                                  ).indexOf('.')
                                )
                              : '0'
                          }}
                        </b>
                        <sup class="f11">
                          {{
                            productDateils.sales_top_price
                              ? String(
                                  (
                                    parseFloat(productDateils.sales_top_price) +
                                    parseFloat(directReduction.directReductionPrice)
                                  ).toFixed(2)
                                ).slice(
                                  String(
                                    (
                                      parseFloat(productDateils.sales_top_price) +
                                      parseFloat(directReduction.directReductionPrice)
                                    ).toFixed(2)
                                  ).indexOf('.'),
                                  String(
                                    (
                                      parseFloat(productDateils.sales_top_price) +
                                      parseFloat(directReduction.directReductionPrice)
                                    ).toFixed(2)
                                  ).length
                                )
                              : '.00'
                          }}
                        </sup>
                      </span>
                    </div>
                    <div
                      class="yuan"
                      v-if="
                        !productDateils.sales_bottom_price ||
                        productDateils.sales_bottom_price == productDateils.sales_top_price
                      "
                    >
                      <span class="smallprice f11 lh17" v-if="productDateils.cost_bottom_price">
                        ¥{{
                          productDateils.cost_bottom_price
                            ? parseFloat(productDateils.cost_bottom_price).toFixed(2)
                            : '0'
                        }}
                      </span>
                      <span
                        class="f11"
                        v-if="
                          productDateils.cost_bottom_price &&
                          parseFloat(productDateils.cost_bottom_price) !=
                            parseFloat(productDateils.cost_top_price)
                        "
                      >
                        -
                      </span>
                      <span
                        class="bigprice flex-ae f11"
                        v-if="
                          parseFloat(productDateils.cost_bottom_price) !=
                          parseFloat(productDateils.cost_top_price)
                        "
                      >
                        {{
                          productDateils.cost_top_price
                            ? parseFloat(productDateils.cost_top_price).toFixed(2)
                            : '.00'
                        }}
                      </span>
                    </div>
                  </div>
                </van-tag>
                <div v-if="activityUI.actDesc" class="f16 fw-b mt5" style="color: #feeae1">
                  {{ activityUI.actDesc }}
                </div>
              </div>
              <div>
                <div class="endTime" style="position: relative; top: 0.05rem">
                  <van-count-down
                    style="font-size: 0"
                    v-if="activityUI.time > 0"
                    :time="activityUI.time"
                    @finish="finish"
                  >
                    <!--                    <template #default="timeData">-->
                    <!--                      {{timeData.days+'天' + (timeData.hours >= 10 ? timeData.hours : ('0' + timeData.hours)) + ':' + (timeData.minutes >= 10 ? timeData.minutes : ('0' + timeData.minutes))}}-->
                    <!--                    </template>-->
                    <template #default="timeData">
                      <span class="colon" style="color: #ffffff">{{ activityUI.timeStr }}</span>
                      <span class="timeData" style="background: #000000">{{ timeData.days }}</span>
                      <span class="colon" style="color: #ffffff">天</span>
                      <span class="timeData" style="background: #000000">
                        {{ timeData.hours }}
                      </span>
                      <span class="colon" style="color: #ffffff">时</span>
                      <span class="timeData" style="background: #000000">
                        {{ timeData.minutes }}
                      </span>
                      <span class="colon" style="color: #ffffff">分</span>
                    </template>
                  </van-count-down>
                </div>
                <p>{{ activityUI.actName }}</p>
              </div>
            </div>
          </div>
          <div
            class="fullMinusInfo activityUI"
            v-if="activityUI && activityUITime == 1 && !changebuytype"
            style="height: 0.67rem"
          >
            <div
              class="depositWrap dai fullMinus"
              :style="{
                background: activityUI.bgImg
                  ? 'url(' + activityUI.bgImg + ') no-repeat center'
                  : '#fc0324',
                'background-size': '100% 100%'
              }"
            >
              <div>
                <van-tag
                  type="primary"
                  size="medium"
                  color="rgba(0, 0, 0, .2)"
                  text-color="#FFFFFF"
                >
                  {{ activityUI.actDesc }}
                </van-tag>
                <div class="pro_price flex-ae">
                  <div class="xian flex-ae">
                    <span class="smallprice flex-ae" v-if="productDateils.sales_bottom_price">
                      <sub>¥</sub>
                      <b>
                        {{
                          productDateils.sales_bottom_price
                            ? String(
                                (
                                  parseFloat(productDateils.sales_bottom_price) +
                                  parseFloat(directReduction.directReductionPrice)
                                ).toFixed(2)
                              ).slice(
                                0,
                                String(
                                  (
                                    parseFloat(productDateils.sales_bottom_price) +
                                    parseFloat(directReduction.directReductionPrice)
                                  ).toFixed(2)
                                ).indexOf('.')
                              )
                            : '0'
                        }}
                      </b>
                      <sup>
                        {{
                          productDateils.sales_bottom_price
                            ? String(
                                (
                                  parseFloat(productDateils.sales_bottom_price) +
                                  parseFloat(directReduction.directReductionPrice)
                                ).toFixed(2)
                              ).slice(
                                String(
                                  (
                                    parseFloat(productDateils.sales_bottom_price) +
                                    parseFloat(directReduction.directReductionPrice)
                                  ).toFixed(2)
                                ).indexOf('.'),
                                String(
                                  (
                                    parseFloat(productDateils.sales_bottom_price) +
                                    parseFloat(directReduction.directReductionPrice)
                                  ).toFixed(2)
                                ).length
                              )
                            : '.00'
                        }}
                      </sup>
                    </span>
                    <span
                      v-if="
                        productDateils.sales_bottom_price &&
                        parseFloat(productDateils.sales_bottom_price) !=
                          parseFloat(productDateils.sales_top_price)
                      "
                    >
                      -
                    </span>
                    <span
                      class="bigprice flex-ae"
                      v-if="
                        parseFloat(productDateils.sales_bottom_price) !=
                        parseFloat(productDateils.sales_top_price)
                      "
                    >
                      <b>
                        {{
                          productDateils.sales_top_price
                            ? String(
                                (
                                  parseFloat(productDateils.sales_top_price) +
                                  parseFloat(directReduction.directReductionPrice)
                                ).toFixed(2)
                              ).slice(
                                0,
                                String(
                                  (
                                    parseFloat(productDateils.sales_top_price) +
                                    parseFloat(directReduction.directReductionPrice)
                                  ).toFixed(2)
                                ).indexOf('.')
                              )
                            : '0'
                        }}
                      </b>
                      <sup>
                        {{
                          productDateils.sales_top_price
                            ? String(
                                (
                                  parseFloat(productDateils.sales_top_price) +
                                  parseFloat(directReduction.directReductionPrice)
                                ).toFixed(2)
                              ).slice(
                                String(
                                  (
                                    parseFloat(productDateils.sales_top_price) +
                                    parseFloat(directReduction.directReductionPrice)
                                  ).toFixed(2)
                                ).indexOf('.'),
                                String(
                                  (
                                    parseFloat(productDateils.sales_top_price) +
                                    parseFloat(directReduction.directReductionPrice)
                                  ).toFixed(2)
                                ).length
                              )
                            : '.00'
                        }}
                      </sup>
                    </span>
                  </div>
                  <div
                    class="yuan"
                    v-if="
                      !productDateils.sales_bottom_price ||
                      productDateils.sales_bottom_price == productDateils.sales_top_price
                    "
                  >
                    <span class="smallprice" v-if="productDateils.cost_bottom_price">
                      ¥{{
                        productDateils.cost_bottom_price
                          ? parseFloat(productDateils.cost_bottom_price).toFixed(2)
                          : '0'
                      }}
                    </span>
                    <span
                      v-if="
                        productDateils.cost_bottom_price &&
                        parseFloat(productDateils.cost_bottom_price) !=
                          parseFloat(productDateils.cost_top_price)
                      "
                    >
                      -
                    </span>
                    <span
                      class="bigprice flex-ae"
                      v-if="
                        parseFloat(productDateils.cost_bottom_price) !=
                        parseFloat(productDateils.cost_top_price)
                      "
                    >
                      {{
                        productDateils.cost_top_price
                          ? parseFloat(productDateils.cost_top_price).toFixed(2)
                          : '.00'
                      }}
                    </span>
                  </div>
                </div>
              </div>
              <div>
                <p>{{ activityUI.actName }}</p>
                <div class="endTime" style="position: relative; top: 0.05rem">
                  <van-count-down
                    style="font-size: 0"
                    v-if="activityUI.time > 0"
                    :time="activityUI.time"
                    @finish="finish"
                  >
                    <!--                    <template #default="timeData">-->
                    <!--                      {{timeData.days+'天' + (timeData.hours >= 10 ? timeData.hours : ('0' + timeData.hours)) + ':' + (timeData.minutes >= 10 ? timeData.minutes : ('0' + timeData.minutes))}}-->
                    <!--                    </template>-->
                    <template #default="timeData">
                      <span class="colon" style="color: #ffffff">{{ activityUI.timeStr }}</span>
                      <span class="timeData" style="background: #000000">{{ timeData.days }}</span>
                      <span class="colon" style="color: #ffffff">天</span>
                      <span class="timeData" style="background: #000000">
                        {{ timeData.hours }}
                      </span>
                      <span class="colon" style="color: #ffffff">时</span>
                      <span class="timeData" style="background: #000000">
                        {{ timeData.minutes }}
                      </span>
                      <span class="colon" style="color: #ffffff">分</span>
                    </template>
                  </van-count-down>
                </div>
              </div>
            </div>
          </div>

          <div
            class="fullMinusInfo activityUI"
            v-if="updatesaletime > 0 && onSaleStatus == 1 && !changebuytype"
            style="height: 0.67rem"
          >
            <div
              class="depositWrap dai fullMinus"
              :style="{
                background: 'url(/static/images/removedbg.png) no-repeat center',
                'background-size': '100% 100%'
              }"
            >
              <div>
                <div class="pro_price flex-ae mt0">
                  <div class="xian flex-ae">
                    <span class="smallprice flex-ae" v-if="productDateils.sales_bottom_price">
                      <sub>¥</sub>
                      <b>
                        {{
                          productDateils.sales_bottom_price
                            ? String(
                                parseFloat(productDateils.sales_bottom_price).toFixed(2)
                              ).slice(
                                0,
                                String(
                                  parseFloat(productDateils.sales_bottom_price).toFixed(2)
                                ).indexOf('.')
                              )
                            : '0'
                        }}
                      </b>
                      <sup>
                        {{
                          productDateils.sales_bottom_price
                            ? String(
                                parseFloat(productDateils.sales_bottom_price).toFixed(2)
                              ).slice(
                                String(
                                  parseFloat(productDateils.sales_bottom_price).toFixed(2)
                                ).indexOf('.'),
                                String(parseFloat(productDateils.sales_bottom_price).toFixed(2))
                                  .length
                              )
                            : '.00'
                        }}
                      </sup>
                    </span>
                    <span
                      v-if="
                        productDateils.sales_bottom_price &&
                        parseFloat(productDateils.sales_bottom_price) !=
                          parseFloat(productDateils.sales_top_price)
                      "
                    >
                      -
                    </span>
                    <span
                      class="bigprice flex-ae"
                      v-if="
                        parseFloat(productDateils.sales_bottom_price) !=
                        parseFloat(productDateils.sales_top_price)
                      "
                    >
                      <b>
                        {{
                          productDateils.sales_top_price
                            ? String(parseFloat(productDateils.sales_top_price).toFixed(2)).slice(
                                0,
                                String(
                                  parseFloat(productDateils.sales_top_price).toFixed(2)
                                ).indexOf('.')
                              )
                            : '0'
                        }}
                      </b>
                      <sup>
                        {{
                          productDateils.sales_top_price
                            ? String(parseFloat(productDateils.sales_top_price).toFixed(2)).slice(
                                String(
                                  parseFloat(productDateils.sales_top_price).toFixed(2)
                                ).indexOf('.'),
                                String(parseFloat(productDateils.sales_top_price).toFixed(2)).length
                              )
                            : '.00'
                        }}
                      </sup>
                    </span>
                  </div>
                  <div
                    class="yuan radius-8px color-FC0324 pl5 pr5"
                    style="background: #ffffff"
                    v-if="
                      !productDateils.sales_bottom_price ||
                      productDateils.sales_bottom_price == productDateils.sales_top_price
                    "
                  >
                    <span class="smallprice" v-if="productDateils.cost_bottom_price">
                      ¥{{
                        productDateils.cost_bottom_price
                          ? parseFloat(productDateils.cost_bottom_price).toFixed(2)
                          : '0'
                      }}
                    </span>
                    <span
                      v-if="
                        productDateils.cost_bottom_price &&
                        parseFloat(productDateils.cost_bottom_price) !=
                          parseFloat(productDateils.cost_top_price)
                      "
                    >
                      -
                    </span>
                    <span
                      class="bigprice flex-ae"
                      v-if="
                        parseFloat(productDateils.cost_bottom_price) !=
                        parseFloat(productDateils.cost_top_price)
                      "
                    >
                      {{
                        productDateils.cost_top_price
                          ? parseFloat(productDateils.cost_top_price).toFixed(2)
                          : '.00'
                      }}
                    </span>
                  </div>
                </div>
                <div class="color-F f12 mt7">
                  已售{{
                    parseFloat(productDateils.sales_num) / 10000 >= 1
                      ? (parseInt(parseInt(productDateils.sales_num) / 100) / 100).toFixed(2) + 'w'
                      : productDateils.sales_num
                  }}
                </div>
              </div>
              <div>
                <p class="f12 ta-c color-FC0324 font_w-n">距下架还剩</p>
                <div class="endTime" style="position: relative; top: 0.05rem">
                  <van-count-down
                    style="font-size: 0"
                    v-if="updatesaletime > 0"
                    :time="updatesaletime"
                    @finish="finish"
                  >
                    <template #default="timeData">
                      <span v-if="timeData.days >= 1" class="timeData" style="background: #fc0324">
                        {{ timeData.days }}
                      </span>
                      <span v-if="timeData.days >= 1" class="colon" style="color: #fc0324">天</span>
                      <span class="timeData" style="background: #fc0324">
                        {{ timeData.hours }}
                      </span>
                      <span class="colon" style="color: #fc0324">时</span>
                      <span class="timeData" style="background: #fc0324">
                        {{ timeData.minutes }}
                      </span>
                      <span class="colon" style="color: #fc0324">分</span>
                      <span v-if="timeData.days == 0" class="timeData" style="background: #fc0324">
                        {{ timeData.seconds }}
                      </span>
                      <span v-if="timeData.days == 0" class="colon" style="color: #fc0324">秒</span>
                    </template>
                  </van-count-down>
                </div>
              </div>
            </div>
          </div>
          <div
            class="noactdesc f13"
            v-if="productDateils.noactdesc"
            :style="productDateils.backcolor ? { background: productDateils.backcolor + '4D' } : {}"
          >
            {{ productDateils.noactdesc }}
          </div>
        </div>
        <van-skeleton title :row="3" :loading="loading">
          <div class="box-m" v-if="depositObj.isdeposit == 1 || $route.query.useintegral">
            <div
              class="depositWrap"
              :style="$route.query.useintegral ? { background: '#fff', color: '#FC0324' } : {}"
            >
              <div class="priceWrap">
                <div class="label">
                  <span v-if="!$route.query.useintegral">定金</span>
                  <span v-if="!$route.query.useintegral">¥</span>
                  <span class="integer">
                    {{
                      $route.query.useintegral ? $route.query.useintegral : depositObj.depositmoney
                    }}
                  </span>
                  <span v-if="$route.query.useintegral">积分</span>
                  <!--                 <span>.00</span>-->
                </div>
                <div class="oldPrice" v-if="!$route.query.useintegral">
                  {{ depositObj.sales_price }}
                </div>
              </div>
              <div class="endTime" v-if="!$route.query.useintegral">
                {{ depositObj.statusdesc }}
              </div>
            </div>
            <div class="productNameWrap">{{ productDateils.name }}</div>
          </div>
          <div class="box-m" v-else>
            <div v-if="directReduction.isDirectReduction && !changebuytype" style="height: 0.25rem">
              <div class="depositWrap dai">
                <div class="pro_price flex-ae">
                  <div class="xian flex-ae">
                    <span class="smallprice flex-ae" v-if="productDateils.sales_bottom_price">
                      <sub>日常价¥</sub>
                      <b>
                        {{
                          productDateils.sales_bottom_price
                            ? String(
                                (
                                  parseFloat(productDateils.sales_bottom_price) +
                                  parseFloat(directReduction.directReductionPrice)
                                ).toFixed(2)
                              ).slice(
                                0,
                                String(
                                  (
                                    parseFloat(productDateils.sales_bottom_price) +
                                    parseFloat(directReduction.directReductionPrice)
                                  ).toFixed(2)
                                ).indexOf('.')
                              )
                            : '0'
                        }}
                      </b>
                      <sup>
                        {{
                          productDateils.sales_bottom_price
                            ? String(
                                (
                                  parseFloat(productDateils.sales_bottom_price) +
                                  parseFloat(directReduction.directReductionPrice)
                                ).toFixed(2)
                              ).slice(
                                String(
                                  (
                                    parseFloat(productDateils.sales_bottom_price) +
                                    parseFloat(directReduction.directReductionPrice)
                                  ).toFixed(2)
                                ).indexOf('.'),
                                String(
                                  (
                                    parseFloat(productDateils.sales_bottom_price) +
                                    parseFloat(directReduction.directReductionPrice)
                                  ).toFixed(2)
                                ).length
                              )
                            : '.00'
                        }}
                      </sup>
                    </span>
                    <span
                      v-if="
                        productDateils.sales_bottom_price &&
                        parseFloat(productDateils.sales_bottom_price) !=
                          parseFloat(productDateils.sales_top_price)
                      "
                    >
                      -
                    </span>
                    <span
                      class="bigprice flex-ae"
                      v-if="
                        parseFloat(productDateils.sales_bottom_price) !=
                        parseFloat(productDateils.sales_top_price)
                      "
                    >
                      <b>
                        {{
                          productDateils.sales_top_price
                            ? String(
                                (
                                  parseFloat(productDateils.sales_top_price) +
                                  parseFloat(directReduction.directReductionPrice)
                                ).toFixed(2)
                              ).slice(
                                0,
                                String(
                                  (
                                    parseFloat(productDateils.sales_top_price) +
                                    parseFloat(directReduction.directReductionPrice)
                                  ).toFixed(2)
                                ).indexOf('.')
                              )
                            : '0'
                        }}
                      </b>
                      <sup>
                        {{
                          productDateils.sales_top_price
                            ? String(
                                (
                                  parseFloat(productDateils.sales_top_price) +
                                  parseFloat(directReduction.directReductionPrice)
                                ).toFixed(2)
                              ).slice(
                                String(
                                  (
                                    parseFloat(productDateils.sales_top_price) +
                                    parseFloat(directReduction.directReductionPrice)
                                  ).toFixed(2)
                                ).indexOf('.'),
                                String(
                                  (
                                    parseFloat(productDateils.sales_top_price) +
                                    parseFloat(directReduction.directReductionPrice)
                                  ).toFixed(2)
                                ).length
                              )
                            : '.00'
                        }}
                      </sup>
                    </span>
                  </div>
                  <div
                    class="yuan"
                    v-if="
                      !productDateils.sales_bottom_price ||
                      productDateils.sales_bottom_price == productDateils.sales_top_price
                    "
                  >
                    <span class="smallprice" v-if="productDateils.cost_bottom_price">
                      ¥{{
                        productDateils.cost_bottom_price
                          ? parseFloat(productDateils.cost_bottom_price).toFixed(2)
                          : '0'
                      }}
                    </span>
                    <span
                      v-if="
                        productDateils.cost_bottom_price &&
                        parseFloat(productDateils.cost_bottom_price) !=
                          parseFloat(productDateils.cost_top_price)
                      "
                    >
                      -
                    </span>
                    <span
                      class="bigprice flex-ae"
                      v-if="
                        parseFloat(productDateils.cost_bottom_price) !=
                        parseFloat(productDateils.cost_top_price)
                      "
                    >
                      {{
                        productDateils.cost_top_price
                          ? parseFloat(productDateils.cost_top_price).toFixed(2)
                          : '.00'
                      }}
                    </span>
                  </div>
                </div>
                <div class="endTime">
                  距离结束
                  <van-count-down
                    :time="directReduction.directReductionRemainingTime"
                    @finish="finish"
                  >
                    <template #default="timeData">
                      <span class="timeData">
                        {{
                          timeData.days * 24 + timeData.hours < 10
                            ? '0' + timeData.hours
                            : timeData.days * 24 + timeData.hours
                        }}
                      </span>
                      <span class="colon">:</span>
                      <span class="timeData">
                        {{ timeData.minutes < 10 ? '0' + timeData.minutes : timeData.minutes }}
                      </span>
                      <span class="colon">:</span>
                      <span class="timeData">
                        {{ timeData.seconds < 10 ? '0' + timeData.seconds : timeData.seconds }}
                      </span>
                    </template>
                  </van-count-down>
                </div>
              </div>
            </div>
            <div
              v-else-if="updatesaletime > 0 && onSaleStatus == 2 && !changebuytype"
              style="height: 0.25rem"
            >
              <div class="depositWrap dai">
                <div class="pro_price flex-ae">
                  <div class="xian flex-ae" v-if="!changebuytype">
                    <span class="smallprice flex-ae" v-if="productDateils.sales_bottom_price">
                      <sub>¥</sub>
                      <b>
                        {{
                          productDateils.sales_bottom_price
                            ? String(
                                parseFloat(productDateils.sales_bottom_price).toFixed(2)
                              ).slice(
                                0,
                                String(
                                  parseFloat(productDateils.sales_bottom_price).toFixed(2)
                                ).indexOf('.')
                              )
                            : '0'
                        }}
                      </b>
                      <sup>
                        {{
                          productDateils.sales_bottom_price
                            ? String(
                                parseFloat(productDateils.sales_bottom_price).toFixed(2)
                              ).slice(
                                String(
                                  parseFloat(productDateils.sales_bottom_price).toFixed(2)
                                ).indexOf('.'),
                                String(parseFloat(productDateils.sales_bottom_price).toFixed(2))
                                  .length
                              )
                            : '.00'
                        }}
                      </sup>
                    </span>
                    <span
                      v-if="
                        productDateils.sales_bottom_price &&
                        parseFloat(productDateils.sales_bottom_price) !=
                          parseFloat(productDateils.sales_top_price)
                      "
                    >
                      -
                    </span>
                    <span
                      class="bigprice flex-ae"
                      v-if="
                        parseFloat(productDateils.sales_bottom_price) !=
                        parseFloat(productDateils.sales_top_price)
                      "
                    >
                      <b>
                        {{
                          productDateils.sales_top_price
                            ? String(parseFloat(productDateils.sales_top_price).toFixed(2)).slice(
                                0,
                                String(
                                  parseFloat(productDateils.sales_top_price).toFixed(2)
                                ).indexOf('.')
                              )
                            : '0'
                        }}
                      </b>
                      <sup>
                        {{
                          productDateils.sales_top_price
                            ? String(parseFloat(productDateils.sales_top_price).toFixed(2)).slice(
                                String(
                                  parseFloat(productDateils.sales_top_price).toFixed(2)
                                ).indexOf('.'),
                                String(parseFloat(productDateils.sales_top_price).toFixed(2)).length
                              )
                            : '.00'
                        }}
                      </sup>
                    </span>
                  </div>
                  <div class="yuan" v-if="!changebuytype">
                    <span class="smallprice" v-if="productDateils.cost_bottom_price">
                      ¥{{
                        productDateils.cost_bottom_price
                          ? parseFloat(productDateils.cost_bottom_price).toFixed(2)
                          : '0'
                      }}
                    </span>
                    <span
                      v-if="
                        productDateils.cost_bottom_price &&
                        parseFloat(productDateils.cost_bottom_price) !=
                          parseFloat(productDateils.cost_top_price)
                      "
                    >
                      -
                    </span>
                    <span
                      class="bigprice flex-ae"
                      v-if="
                        parseFloat(productDateils.cost_bottom_price) !=
                        parseFloat(productDateils.cost_top_price)
                      "
                    >
                      {{
                        productDateils.cost_top_price
                          ? parseFloat(productDateils.cost_top_price).toFixed(2)
                          : '.00'
                      }}
                    </span>
                  </div>
                </div>
                <div class="endTime">
                  距开售还剩
                  <van-count-down :time="updatesaletime" @finish="finish">
                    <template #default="timeData">
                      <span class="timeData">
                        {{
                          timeData.days * 24 + timeData.hours < 10
                            ? '0' + timeData.hours
                            : timeData.days * 24 + timeData.hours
                        }}
                      </span>
                      <span class="colon">:</span>
                      <span class="timeData">
                        {{ timeData.minutes < 10 ? '0' + timeData.minutes : timeData.minutes }}
                      </span>
                      <span class="colon">:</span>
                      <span class="timeData">
                        {{ timeData.seconds < 10 ? '0' + timeData.seconds : timeData.seconds }}
                      </span>
                    </template>
                  </van-count-down>
                </div>
              </div>
            </div>
            <div
              v-if="!activityUI && !$route.query.useintegral"
              class="pro_price flex-ae flex-w"
              style="font-size: 0"
            >
              <div
                class="xian flex-ae"
                v-if="
                  updatesaletime <= 0 &&
                  !directReduction.isDirectReduction &&
                  (!changebuytype || defectivegood == 1 || nocartshow == 1)
                "
              >
                <span class="smallprice flex-ae" v-if="productDateils.sales_bottom_price">
                  <sub>¥</sub>
                  <b>
                    {{
                      productDateils.sales_bottom_price
                        ? String(parseFloat(productDateils.sales_bottom_price).toFixed(2)).slice(
                            0,
                            String(
                              parseFloat(productDateils.sales_bottom_price).toFixed(2)
                            ).indexOf('.')
                          )
                        : '0'
                    }}
                  </b>
                  <sup>
                    {{
                      productDateils.sales_bottom_price
                        ? String(parseFloat(productDateils.sales_bottom_price).toFixed(2)).slice(
                            String(
                              parseFloat(productDateils.sales_bottom_price).toFixed(2)
                            ).indexOf('.'),
                            String(parseFloat(productDateils.sales_bottom_price).toFixed(2)).length
                          )
                        : '.00'
                    }}
                  </sup>
                </span>
                <span
                  v-if="
                    productDateils.sales_bottom_price &&
                    parseFloat(productDateils.sales_bottom_price) !=
                      parseFloat(productDateils.sales_top_price)
                  "
                >
                  -
                </span>
                <span
                  class="bigprice flex-ae"
                  v-if="
                    parseFloat(productDateils.sales_bottom_price) !=
                    parseFloat(productDateils.sales_top_price)
                  "
                >
                  <b>
                    {{
                      productDateils.sales_top_price
                        ? String(parseFloat(productDateils.sales_top_price).toFixed(2)).slice(
                            0,
                            String(parseFloat(productDateils.sales_top_price).toFixed(2)).indexOf(
                              '.'
                            )
                          )
                        : '0'
                    }}
                  </b>
                  <sup>
                    {{
                      productDateils.sales_top_price
                        ? String(parseFloat(productDateils.sales_top_price).toFixed(2)).slice(
                            String(parseFloat(productDateils.sales_top_price).toFixed(2)).indexOf(
                              '.'
                            ),
                            String(parseFloat(productDateils.sales_top_price).toFixed(2)).length
                          )
                        : '.00'
                    }}
                  </sup>
                </span>
              </div>
              <div
                class="yuan"
                v-if="
                  updatesaletime <= 0 &&
                  !directReduction.isDirectReduction &&
                  (!changebuytype || defectivegood == 1 || nocartshow == 1)
                "
              >
                <span class="smallprice" v-if="productDateils.cost_bottom_price">
                  ¥{{
                    productDateils.cost_bottom_price
                      ? parseFloat(productDateils.cost_bottom_price).toFixed(2)
                      : '0'
                  }}
                </span>
                <span
                  v-if="
                    productDateils.cost_bottom_price &&
                    parseFloat(productDateils.cost_bottom_price) !=
                      parseFloat(productDateils.cost_top_price)
                  "
                >
                  -
                </span>
                <span
                  class="bigprice flex-ae"
                  v-if="
                    parseFloat(productDateils.cost_bottom_price) !=
                    parseFloat(productDateils.cost_top_price)
                  "
                >
                  {{
                    productDateils.cost_top_price
                      ? parseFloat(productDateils.cost_top_price).toFixed(2)
                      : '.00'
                  }}
                </span>
              </div>
              <div
                class="xian flex-ae"
                style="display: inline-block"
                v-if="
                  updatesaletime <= 0 &&
                  !directReduction.isDirectReduction &&
                  changebuytype == 'changebuyproductdetail' &&
                  defectivegood != 1
                "
              >
                <span class="smallprice flex-ae" v-if="productDateils.changebuy_price">
                  <sub>活动价¥</sub>
                  <b>
                    {{
                      productDateils.changebuy_price
                        ? String(parseFloat(productDateils.changebuy_price).toFixed(2)).slice(
                            0,
                            String(parseFloat(productDateils.changebuy_price).toFixed(2)).indexOf(
                              '.'
                            )
                          )
                        : '0'
                    }}
                  </b>
                  <sup>
                    {{
                      productDateils.changebuy_price
                        ? String(parseFloat(productDateils.changebuy_price).toFixed(2)).slice(
                            String(parseFloat(productDateils.changebuy_price).toFixed(2)).indexOf(
                              '.'
                            ),
                            String(parseFloat(productDateils.changebuy_price).toFixed(2)).length
                          )
                        : '.00'
                    }}
                  </sup>
                </span>
              </div>
              <div
                class="yuan"
                style="display: inline-block; text-decoration: initial; margin-left: 0.12rem"
                v-if="
                  updatesaletime <= 0 &&
                  !directReduction.isDirectReduction &&
                  changebuytype == 'changebuyproductdetail' &&
                  defectivegood != 1
                "
              >
                <span class="smallprice flex-ae" v-if="productDateils.cost_price">
                  原价¥{{
                    productDateils.cost_price
                      ? parseFloat(productDateils.cost_price).toFixed(2)
                      : '0'
                  }}
                </span>
              </div>
              <div
                class="directReduction"
                v-if="directReduction.isDirectReduction && !changebuytype"
              >
                下单直降{{ directReduction.directReductionPrice }}元
              </div>
              <div
                class="tags"
                v-else-if="
                  updatesaletime <= 0 &&
                  !directReduction.isDirectReduction &&
                  !changebuytype &&
                  halfprice.halfpricestatus == 1 &&
                  halfprice.ishalf == 1
                "
              >
                {{
                  halfprice.isbirthday == 1
                    ? '生日' + halfprice.halfactlabel
                    : halfprice.halfactlabel + '狂欢价'
                }}
              </div>
              <div
                class="tags"
                v-if="
                  updatesaletime <= 0 &&
                  !directReduction.isDirectReduction &&
                  !changebuytype &&
                  fullDiscountRule &&
                  fullDiscountRule.actlabel
                "
              >
                {{ fullDiscountRule.actlabel }}
              </div>
              <div
                class="tags"
                v-if="
                  updatesaletime <= 0 &&
                  !directReduction.isDirectReduction &&
                  !changebuytype &&
                  morediscounts.discountenable == 1 &&
                  morediscounts.actlabel
                "
              >
                {{ morediscounts.actlabel }}
              </div>
            </div>
            <div class="limit" v-if="limitinfo">{{ limitinfo }}</div>
            <div
              class="pro_actinfo getcoupon_info"
              :class="{
                getcoupon_info_border: !(msglist && msglist.length == 1 && !changebuytype)
              }"
              v-if="
                ((integralrule && integralrule.integraldescArr.length) ||
                  coupontags.length ||
                  couponslist.length) &&
                !changebuytype
              "
              @click="couponslistFn"
            >
              <div
                class="headers flex-js-ac"
                :style="{ 'padding-top': activityUI ? '0' : '0.12rem' }"
              >
                <div class="title" style="width: 75%; line-height: 0.24rem">
                  <van-tag
                    class="big12"
                    color="#FFE6E6"
                    text-color="#FC0324"
                    v-if="integralrule && integralrule.integraldescArr[0]"
                  >
                    {{ integralrule.integraldescArr[0] }}
                  </van-tag>
                  <van-tag
                    class="big12"
                    color="#FFE6E6"
                    text-color="#FC0324"
                    v-if="integralrule && integralrule.integraldescArr[1]"
                  >
                    {{ integralrule.integraldescArr[1] }}
                  </van-tag>
                  <van-tag
                    class="big12"
                    color="#FFE6E6"
                    text-color="#FC0324"
                    v-if="coupontags.length && coupontags[0]"
                  >
                    {{ coupontags[0] }}
                  </van-tag>
                  <van-tag
                    class="big12"
                    color="#FFE6E6"
                    text-color="#FC0324"
                    v-if="coupontags.length && coupontags[1]"
                  >
                    {{ coupontags[1] }}
                  </van-tag>
                  <!--            {{msglist[0].name}}{{msglist[0].desc}}-->
                </div>
                <div class="getcoupon f12" v-if="couponslist.length">
                  领券
                  <van-icon color="#ffffff" name="arrow" size="0.12rem" />
                </div>
              </div>
            </div>
            <div class="pro_tit">
              <van-tag
                class="f12"
                color="#FFE6E6"
                text-color="#FC0324"
                v-if="actopen.is_pre_item == 1"
              >
                预售
              </van-tag>
              {{ productDateils.name }}
              <img
                v-if="productDateils.property === 'overseas'"
                src="../../assets/images/overseas.png"
                class="overseas"
              />
            </div>
            <div class="btn-1 flex-js-ac" v-if="productDateils.isStreetGoods != 1">
              <button
                class="f12 flex-jc-ac"
                @click="posterFn"
                v-if="
                  actopen.is_ck_community_item != 1 &&
                  productDateils.isaddcart != 0 &&
                  !changebuytype &&
                  halfprice.ishalfprice != 1 &&
                  !fold
                "
              >
                <img src="/static/images/poster@2x.png" />
                海报
              </button>
              <button
                class="f12 flex-jc-ac"
                @click="share"
                v-if="!changebuytype && halfprice.ishalfprice != 1 && !fold && isShare"
              >
                <img src="/static/images/share@2x.png" />
                分享
              </button>
              <button class="f12 flex-jc-ac" v-if="!changebuytype && isShare">
                <img src="/static/images/book@2x.png" />
                产品手册
                <div
                  class="slide_cl_xcx"
                  :path="'/pages/info/info?itemid=' + productDateils.itemid"
                  :username="'gh_778878b1a2ae'"
                ></div>
              </button>
            </div>
          </div>
        </van-skeleton>
      </div>
      <div
        style="margin: 0.1rem 0.11rem"
        v-if="productInfo && productInfo.showcouponurl && !changebuytype"
      >
        <img @click="goUrl" :src="productInfo.showcouponImg" style="width: 100%" />
      </div>
      <div style="margin: 0.1rem 0.11rem" v-if="ndo_url != '' && !changebuytype">
        <img :src="ndo_img_path" @click="goUrl(ndo_url)" style="width: 100%" />
      </div>
      <div
        style="margin: 0.1rem 0.11rem"
        v-if="
          productInfo &&
          productInfo.shareCoupon &&
          productInfo.shareCoupon.imgPath &&
          (!changebuytype || newuserzone)
        "
      >
        <img
          @click="goUrl(productInfo.shareCoupon.jumpUrl)"
          :src="productInfo.shareCoupon.imgPath"
          style="width: 100%"
        />
      </div>
      <div
        class="pro_certifical box-m flex-js-ac"
        v-if="certificationrule.isshow == 1"
        @click="showcertifical = true"
      >
        <p class="f11 flex-ac">
          <b class="flex-ac" style="margin-right: 0.05rem; white-space: nowrap">
            <van-icon size="14" :name="certificationrule.icon" />
            &nbsp;{{ certificationrule.label }}
          </b>
          <span class="over-ell-1">{{ certificationrule.desc }}</span>
        </p>
        <van-icon name="arrow" color="#FB6E38" size="0.12rem"></van-icon>
      </div>
      <div class="pro_actinfo box-m pt0">
        <div
          class="headers flex-js-as line-a line-a-1px pt11 pb11"
          v-if="msglist && msglist.length > 0 && !changebuytype"
          @click="showaction = true"
        >
          <div class="tag flex-s" style="width: auto">活动</div>
          <div class="flex-1">
            <div
              class="title act flex-1 flex-ac"
              style="clear: both"
              v-for="(item, index) in msglist"
            >
              <div class="msgitem over-ell-1 flex-1" v-if="!item.islink">
                <van-tag color="#FFE6E6" text-color="#FC0324" v-if="item.actlabel">
                  {{ item.actlabel }}
                </van-tag>
                {{ item.name }}&nbsp;{{ item.desc }}
              </div>
              <div class="msgitem group flex-1 flex-js-ac" v-if="item.islink" @click.stop="goGroup">
                <div class="over-ell-1 flex-1">
                  <van-tag color="#FFE6E6" text-color="#FC0324" v-if="item.actlabel">
                    {{ item.actlabel }}
                  </van-tag>
                  {{ item.name }}&nbsp;{{ item.desc }}
                </div>
                <div class="f12 color-FC0324 flex-ac">
                  去看看
                  <van-icon name="arrow" color="#FC0324" size="0.12rem"></van-icon>
                </div>
              </div>
              <van-icon
                v-if="!item.islink"
                name="arrow"
                :color="index == 0 ? '#909090' : 'transparent'"
                size="0.12rem"
              ></van-icon>
            </div>
          </div>
        </div>
        <div v-if="popularScience.healthKnowledge" class="headers line-a line-a-1px pt11 pb11" @click="popularScienceSwitchHandle">
          <div class="flex-js-as">
            <div class="tag flex-s mb10" style="width: auto">科普</div>
            <van-icon
              name="arrow"
              color="#909090"
              size="0.12rem"
            ></van-icon>
          </div>
          <div class="flex fw-n scroll-x scrollbar-none">
            <div class="flex-s vertical-line over-h pos-r pr10 mr10">
              <p class="f13 color-FC0324 ws-n">{{ popularScience.healthKnowledge }}</p>
              <p class="f13 color-6 ws-n">成分知识</p>
            </div>
            <div class="flex-s vertical-line over-h pos-r pr10 mr10" style="max-width: 60%;">
              <p class="f13 color-FC0324 over-ell-1">{{ popularScience.document }}</p>
              <p class="f13 color-6 ws-n">相关文献</p>
            </div>
            <div class="flex-s over-h">
              <p class="f13 color-3 ws-n">{{ popularScience.documentNum }}篇</p>
              <p class="f13 color-6 ws-n">文献数量</p>
            </div>
          </div>
        </div>
        <div class="pt11 headers flex-js-as" @click="showparam = true">
          <van-skeleton title :row="2" :loading="loading">
            <div class="tag" style="width: auto">参数</div>
            <div class="title flex-1">
              <div class="msgitem over-ell-1" v-if="specification">
                {{ specification }}
              </div>
              <div class="msgitem over-ell-1" v-if="productDateils.trialscopeParams">
                {{ productDateils.trialscopeParams }}
              </div>
              <div class="msgitem over-ell-1" v-else-if="productDateils.item_character">
                {{ productDateils.item_character }}
              </div>
            </div>
          </van-skeleton>
          <van-icon name="arrow" color="#909090" size="0.12rem"></van-icon>
        </div>
      </div>
      <div style="margin: 0 0.11rem 0" class="productbanner" v-if="!changebuytype">
        <div v-for="item of privatesphere" @click="productBannerFn(item)">
          <img style="width: 100%" v-lazy="item.img_path" />
        </div>
      </div>
      <div
        class="pro_comment d_jump box-m"
        style="border-top: 0"
        v-if="(!changebuytype || (changebuytype && newpersondetail == 1)) && productDateils.isStreetGoods != 1"
      >
        <div class="pro_comment_tit flex-js-ac">
          <div class="flex-ac ht">
            {{
              productEvaluate.list && productEvaluate.list.length > 0
                ? '产品评价(' + productEvaluate.comment_nums + ')'
                : '暂无评价'
            }}
            <div class="hp ht">好评{{ productEvaluate.comment_rate }}</div>
          </div>
          <div
            class="pro_comment_more"
            @click="goCommentList"
            v-if="productEvaluate.list && productEvaluate.list.length > 0"
          >
            <div class="hp nobold">查看更多</div>
            <van-icon name="arrow" color="#FC0324" size="0.12rem"></van-icon>
          </div>
        </div>
        <div
          class="tags"
          v-if="tagslist && tagslist.length && productEvaluate.list && productEvaluate.list.length"
        >
          <ul>
            <li v-if="item" v-for="(item, index) of tagslist" :key="index">
              {{ item }}
            </li>
          </ul>
        </div>
        <div
          v-if="productEvaluate.list && productEvaluate.list.length > 0"
          class="pro_comment_list"
        >
          <div class="pro_comment_item" v-for="(item, index) of productEvaluate.list" :key="index">
            <div class="comment_head_info" @click="commentDetail(item)">
              <div class="sj">
                <van-rate
                  v-model="item.itemscore"
                  :size="15"
                  void-color="#eeeeee"
                  void-icon="star"
                  color="#FFCD07"
                  readonly
                />
              </div>
              <div class="img">
                <img
                  :src="item.head"
                  @error="$errorHeadImgFunc(event, errorHeadImg)"
                  v-if="item.head"
                />
                <img v-if="!item.head" :src="errorHeadImg" />
              </div>
              <div class="info">
                <div class="name">
                  {{ item.smallname }}
                  <img
                    v-if="item.vip_level"
                    :src="`/static/images/vipIcon/l${item.vip_level}.png`"
                  />
                </div>
                <div class="time">{{ item.time }} 规格：{{ item.spec }}</div>
              </div>
            </div>
            <div class="comment_content_info">
              <div class="comment_txt" @click="commentDetail(item)">
                <span class="color-FC0324 f10 isfeedback" v-if="item.isfeedback">
                  &nbsp;试用反馈&nbsp;
                </span>
                {{ item.content }}
              </div>
              <div class="comment_pic">
                <!-- Swiper -->
                <div class="swiper-container">
                  <swiper :options="swiperOption" ref="mySwiper">
                    <swiper-slide style="position: relative" v-if="item.isvideo == 1">
                      <div style="width: 100%; height: 100%">
                        <video
                          style="width: 100%; height: 100%; object-fit: cover"
                          class="videofile"
                          id="videofile"
                          :poster="item.coverimg"
                          :src="item.videourl"
                          webkit-playsinline="true"
                          playsinline="true"
                          x5-playsinline="true"
                          x-webkit-airplay="allow"
                          preload="true"
                        >
                          <source :src="item.videourl" type="video/mp4" />
                          您的浏览器不支持 video 标签。
                        </video>
                        <img
                          style="
                            position: absolute;
                            left: 30%;
                            top: 30%;
                            width: 0.28rem;
                            height: 0.28rem;
                          "
                          @click="playFn(item.videourl)"
                          v-if="!isfullscreen"
                          src="/static/images/community/video.png"
                        />
                      </div>
                    </swiper-slide>
                    <swiper-slide v-if="item.path1">
                      <img v-lazy="item.path1" @click="preview(item, 0, 'comment')" />
                    </swiper-slide>
                    <swiper-slide v-if="item.path2">
                      <img v-lazy="item.path2" @click="preview(item, 1, 'comment')" />
                    </swiper-slide>
                    <swiper-slide v-if="item.path3">
                      <img v-lazy="item.path3" @click="preview(item, 2, 'comment')" />
                    </swiper-slide>
                    <swiper-slide v-if="item.path4">
                      <img v-lazy="item.path4" @click="preview(item, 3, 'comment')" />
                    </swiper-slide>
                    <swiper-slide v-if="item.path5">
                      <img v-lazy="item.path5" @click="preview(item, 4, 'comment')" />
                    </swiper-slide>
                    <swiper-slide v-if="item.path6">
                      <img v-lazy="item.path6" @click="preview(item, 5, 'comment')" />
                    </swiper-slide>
                  </swiper>
                  <!-- Add Pagination -->
                  <div class="swiper-pagination"></div>
                </div>
              </div>
            </div>
            <div class="comment_oper">
              <div class="button" @click="commentLike(item)">
                <img
                  :src="
                    item.islike == 0
                      ? require('../../assets/images/zan.png')
                      : require('../../assets/images/zan1.png')
                  "
                />
                {{ parseInt(item.like_nums) > 0 ? item.like_nums : '点赞' }}
              </div>
              <div class="button" @click="commentDetail(item)">
                <img src="../../assets/images/ly.png" />
                {{ parseInt(item.leave_nums) > 0 ? item.leave_nums : '留言' }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="goodcomments pro_comment_list"
          v-if="goodcommentsnum > 0"
          @click="
            $router.push({
              path: '/fansShow',
              query: {
                ...$route.query,
                itemid: productDateils.itemid,
                showbuy: newpersondetail == 1 || groupbuyid ? '0' : ''
              }
            })
          "
        >
          <div class="pro_comment_tit flex-js-ac">
            <div class="flex-ac ht">金粉秀({{ goodcommentsnum }})</div>
            <div class="pro_comment_more">
              <div class="hp nobold">查看更多</div>
              <van-icon name="arrow" color="#FC0324" size="0.12rem"></van-icon>
            </div>
          </div>
          <div class="pro_comment_item">
            <div class="comment_content_info">
              <div class="comment_pic">
                <!-- Swiper -->
                <div class="swiper-container">
                  <swiper :options="swiperOption" ref="mySwiper">
                    <swiper-slide v-for="(item, index) of goodcomments" :key="index">
                      <img
                        :src="item.path"
                        @click.stop="
                          $router.push({
                            path: '/commentDetail',
                            query: {
                              ...$route.query,
                              goodcomment: 1,
                              commentid: item.commentid,
                              isofficia: item.isofficia,
                              showbuy: newpersondetail == 1 || groupbuyid ? '0' : ''
                            }
                          })
                        "
                      />
                      <img
                        v-if="item.isvideo == 1"
                        @click.stop="
                          $router.push({
                            path: '/commentDetail',
                            query: {
                              ...$route.query,
                              goodcomment: 1,
                              commentid: item.commentid,
                              isofficia: item.isofficia,
                              showbuy: newpersondetail == 1 || groupbuyid ? '0' : ''
                            }
                          })
                        "
                        style="
                          position: absolute;
                          left: 32%;
                          top: 30%;
                          width: 0.28rem;
                          height: 0.28rem;
                        "
                        src="/static/images/community/video.png"
                      />
                    </swiper-slide>
                  </swiper>
                  <!-- Add Pagination -->
                  <div class="swiper-pagination"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="problems goodcomments pro_comment_list"
          v-if="problemsnum >= 0"
          @click="
            $router.push({
              path: '/askEveryone',
              query: {
                ...$route.query,
                itemid: productDateils.itemid,
                showbuy: newpersondetail == 1 || groupbuyid ? '0' : ''
              }
            })
          "
        >
          <div class="pro_comment_tit flex-js-ac">
            <div class="flex-ac ht">问大家({{ problemsnum }})</div>
            <div class="pro_comment_more" v-if="problems.length">
              <div class="hp nobold">查看更多</div>
              <van-icon name="arrow" color="#FC0324" size="0.12rem"></van-icon>
            </div>
          </div>
          <div class="problemslist">
            <div class="flex-js-ac" v-if="!problems.length">
              <p class="f12 color-9 over-ell-1">商品好不好，问问已买过的人哦</p>
              <button class="f12 color-FC0324">去提问</button>
            </div>
            <div
              class="flex-js-ac"
              v-for="(item, index) of problems"
              :key="index"
              @click.stop="goProblemDetails(item)"
            >
              <p class="f12 over-ell-1">{{ item.question }}</p>
              <span class="f12 color-9 flex-s">{{ item.answernum }}个回答</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="pro_comment box-m"
        style="border-top: 0"
        v-if="
          (!changebuytype || (changebuytype && newpersondetail == 1)) &&
          hotSalesGoodsList.length > 0 && productDateils.isStreetGoods != 1
        "
      >
        <div class="pro_comment_tit flex-js-ac">
          <div class="flex-ac ht">热销好评</div>
          <div class="pro_comment_more" @click="goHotSalesGoods">
            <div class="hp nobold">查看更多</div>
            <van-icon name="arrow" color="#FC0324" size="0.12rem"></van-icon>
          </div>
        </div>
        <HotSalesGoods
          class="mt11"
          :initList="hotSalesGoodsList"
          :list="hotSalesGoodsListTd"
          @itemid="itemId"
          :markPointData="{
            scenepoint: 'itemhot-' + productDateils.itemid,
            scenedesc: '热销好评'
          }"
        ></HotSalesGoods>
      </div>

      <div class="pro_details d_jump">
        <div class="pro_details_tit">商品详情</div>
        <div class="pro_details_con" v-if="productDateils.actinfo">
          <img
            v-for="(item, index) of productDateils.actinfo"
            v-lazy="item.actpath"
            @click="productBannerFn(item, 'ad')"
          />
        </div>
        <div class="pro_details_con">
          <img
            v-for="(item, index) of productDateils.descriptions"
            v-lazy="item.path"
            @click="preview(item, index, 'description')"
          />
        </div>
      </div>
      <div class="d_jump" v-if="!changebuytype && productDateils.isStreetGoods != 1">
        <div class="pro_related_goods" v-if="productlist && productlist.length > 0">
          <div class="pro_related_goods_tit">
            <van-divider
              :style="{
                color: '#222222',
                borderColor: '#DBDBDB',
                padding: '0.14rem 0 0.05rem',
                margin: '0',
                fontSize: '.14rem'
              }"
            >
              相关推荐
            </van-divider>
          </div>
          <div style="margin: 0 0.11rem 0" class="productbanner">
            <div v-for="item of productBannerList" @click="productBannerFn(item, 'recomad')">
              <img style="width: 100%" v-lazy="item.img_path" />
            </div>
          </div>
          <div class="pro_related_list footerIOS" style="padding-top: 0.1rem">
            <product-item
              v-for="(item, index) of productlist"
              @itemid="itemId"
              :prolistItem="item"
              :key="index"
              :markPointData="{
                scenepoint: 'PRODDETAIL',
                scenedesc: 'recomitem'
              }"
            ></product-item>
          </div>
        </div>
      </div>
    </div>
    <div class="pro_goods_menu footbtn flex-ac footerIOS" v-if="depositObj.isdeposit == 1">
      <div class="iconbtn flex-js-ac">
        <div class="kefu" @click="keFu">
          <img src="../../assets/images/service.png" />
          <div class="txt">客服</div>
        </div>
        <div class="cart" @click="gocart">
          <i v-if="cartnum > 0">{{ cartnum > 0 && cartnum <= 99 ? cartnum : '99+' }}</i>
          <img src="../../assets/images/goshopping.png" />
          <div class="txt">购物车</div>
        </div>
      </div>
      <div
        :class="[depositObj.actstatus == 1 ? 'active' : '', 'button payDeposit']"
        @click="buy(1)"
      >
        {{
          depositObj.actstatus == 0
            ? '活动未开始'
            : depositObj.actstatus == 1
            ? '立即付定金¥' + depositObj.depositmoney
            : '活动已结束'
        }}
      </div>
    </div>
    <div class="pro_goods_menu flex-ac footerIOS" v-else-if="!changebuytype">
      <div
        class="iconbtn"
        v-if="!groupbuyid"
        :class="
          actopen.is_ck_community_item == 1 ||
          productDateils.isaddcart == 0 ||
          halfprice.ishalfprice == 1 ||
          fold
            ? 'flex-ac'
            : 'flex-js-ac'
        "
      >
        <div class="kefu" @click="keFu">
          <img src="../../assets/images/service.png" />
          <div class="txt">客服</div>
        </div>
        <div
          class="cart"
          @click="gocart"
          v-if="actopen.is_ck_community_item != 1 && productDateils.isaddcart != 0"
        >
          <i v-if="cartnum > 0">{{ cartnum > 0 && cartnum <= 99 ? cartnum : '99+' }}</i>
          <img src="../../assets/images/goshopping.png" />
          <div class="txt">购物车</div>
        </div>
        <div
          class="cart comment"
          @click="love"
          v-if="
            actopen.is_ck_community_item != 1 &&
            productDateils.isaddcart != 0 &&
            halfprice.ishalfprice != 1 &&
            !fold
          "
        >
          <img
            :src="
              islove === true
                ? require('../../assets/images/loved.png')
                : require('../../assets/images/love.png')
            "
          />
          <div class="txt">{{ islove === true ? '已收藏' : '收藏' }}</div>
        </div>
      </div>
      <div class="iconbtn" style="width: auto" v-else-if="groupbuyid">
        <div class="kefu" @click="share" style="margin-right: 0">
          <img
            style="width: 0.34rem; height: 0.34rem"
            src="/static/images/newproducttrial/share@2x.png?v=1"
          />
          <!--          <div class="txt">首页</div>-->
        </div>
      </div>
      <div
        class="button shopcart"
        v-if="
          !fold &&
          actopen.is_ck_community_item != 1 &&
          productDateils.isaddcart != 0 &&
          !groupbuyid &&
          productDateils.isAddSpecialCart != 1
        "
        :style="zcIndex > 0 ? {} : daiIndex > 0 ? {} : { background: '#e3e3e3' }"
        @click="shopcart(0)"
      >
        加入购物车
      </div>
      <!--      <div class="button shopcart" v-else-if="groupbuyid" @click="share">分享好友</div>-->
      <div
        class="button buy"
        :class="{
          daiBtn: daiIndex > 0 && updatesaleendtime,
          buyBtnWidth:
            (fold ||
              actopen.is_ck_community_item == 1 ||
              productDateils.isaddcart == 0 ||
              productDateils.isAddSpecialCart == 1) &&
            !groupbuyid,
          buyBtnWidth1: groupbuyid
        }"
        :style="
          zcIndex > 0 || (daiIndex > 0 && updatesaleendtime) || (wuIndex > 0 && subscribeShow != 0)
            ? {}
            : { background: '#e3e3e3' }
        "
        @click="buy(1)"
      >
        {{
          zcIndex > 0
            ? updatesaleendtime
              ? '待售'
              : '立即购买'
            : daiIndex > 0 && wuIndex <= 0
            ? '待售'
            : daiIndex <= 0 && wuIndex > 0
            ? subscribeShow != 0
              ? subScribeTime
                ? '预计' + subScribeTime + '月到货'
                : '到货提醒'
              : '已售罄'
            : '立即购买'
        }}
        <p v-if="daiIndex > 0 && updatesaleendtime">{{ updatesaleendtime }}开始</p>
      </div>
    </div>
    <div
      class="pro_goods_menu footbtn flex-js-ac footerIOS"
      v-else-if="defectivegood == 1 || nocartshow == 1"
    >
      <div class="iconbtn"></div>
      <div
        class="button buy buyBtnWidth"
        :style="$route.query.isbuy == 0 ? { background: '#e3e3e3' } : {}"
        @click="buy(1)"
      >
        立即购买
      </div>
    </div>
    <div class="floatBtn_new">
      <img
        v-if="isnewpersontask && !changebuytype"
        @click="newpersontask"
        src="/static/images/new-person/newpersontask@2x.png"
      />
      <img src="/static/images/homebtn1.png" class="home" @click="homeClick" />
    </div>
    <div
      class="homeBtn"
      v-if="!changebuytype"
      :style="{ width: priareainfo.width / 200 + 'rem' }"
      style="height: auto; bottom: 2rem; right: 0; background: transparent; box-shadow: none"
      @click="goUrl(priareainfo.url)"
    >
      <img style="width: 100%; height: auto" :src="priareainfo.img_path" />
    </div>
    <van-marquee v-if="zcIndex > 0" :itemid="productDateils.itemid"></van-marquee>
    <van-overlay :show="showshare" z-index="99"></van-overlay>
    <div class="sharecontainer" v-if="showshare === true && !changebuytype">
      <img src="../../assets/images/sharemc.png" />
      <van-button round plain type="danger" class="know" @click="showshare = false">
        我知道了
      </van-button>
    </div>
    <van-sku
      close-on-click-overlay
      hide-quota-text
      v-model="showsku"
      :sku="sku"
      :goods="goods"
      :quota="quota"
      :quota-used="quotaUsed"
      :goods-id="productDateils.itemid"
      :initial-sku="initialSku"
      :hide-stock="sku.hide_stock"
      :custom-stepper-config="customStepperConfig"
      @stepper-change="stepChange"
      class="good_sku"
      ref="sku"
      @sku-selected="checkedSku"
    >
      <template slot="sku-header" slot-scope="props">
        <div class="van-sku-header van-hairline--bottom">
          <div class="van-sku-header__img-wrap">
            <img v-lazy="goods.picture" @click="openPreview" />
          </div>
          <div class="van-sku-header__goods-info">
            <div class="van-sku-name">{{ goods.title }}</div>
            <div class="van-sku-header-item">
              {{ skuname === '' ? '请选择商品规格' : '已选 ' + skuname }}
            </div>
            <div class="van-sku__goods-price">
              <span class="van-sku__price-symbol">¥</span>
              <span class="van-sku__price-num">{{ skuprice }}</span>
              <span v-if="skucostprice" class="van-sku__costprice-symbol">¥</span>
              <span v-if="skucostprice" class="van-sku__costprice-num">{{ skucostprice }}</span>
            </div>
          </div>
        </div>
      </template>

      <template slot="sku-actions" slot-scope="props">
        <div class="depositTime" v-if="depositObj.isdeposit == 1">
          {{ depositObj.statusdesc }}
        </div>
        <div class="van-sku-actions">
          <van-button
            :class="[goods.ispresale == 1 ? 'sure' : 'sure1', sureGray ? 'sureGray' : '']"
            @click="onConfirmClicked"
            size="large"
            square
            type="danger"
            v-if="!buyType || !updatesaleendtimeitem"
          >
            {{
              depositObj.isdeposit
                ? '立即付定金' + depositObj.totalPrice
                : goods.ispresale == 1
                ? '预售购买'
                : subscribeShowitem && buyType
                ? goods.subScribeTime
                  ? '预计' + goods.subScribeTime + '月到货'
                  : '到货提醒'
                : '确定'
            }}
            <div class="parsetime" v-if="goods.ispresale == 1">
              {{ goods.presaletime }}
            </div>
          </van-button>
          <van-button
            @click="onConfirmClicked"
            class="sure"
            size="large"
            square
            type="danger"
            v-else
          >
            待售
            <div class="parsetime">{{ updatesaleendtimeitem }}开始</div>
          </van-button>
        </div>
      </template>
    </van-sku>

    <!--海报-->
    <transition name="fade">
      <div class="poster_shadow" v-show="posterShow">
        <div class="poster_shadow_swiper">
          <div class="poster_swiper">
            <div
              class="poster-container gallery-top gallery poster_height"
              :style="postImgData != '' ? { 'z-index': '10' } : { 'z-index': '-1' }"
            >
              <div class="swiper-slide" id="posterbox">
                <!-- <img style="margin-top: -1rem;" id="posterimg" crossOrigin="Anonymous"> -->
                <img style="margin-top: -1rem" id="posterimg" :src="postImgData" />
              </div>
              <!-- Add Arrows -->
            </div>
            <div class="poster-container gallery-top poster_height">
              <div class="swiper-slide" ref="poster" id="poster" style="margin-top: -1rem">
                <div style="height: 1rem; background: #fff">
                  <img
                    id="posterlogo"
                    @load="posterlogoFn"
                    style="width: 100%; height: auto; margin: 0 auto"
                    src="../../assets/images/posterLogo.jpg"
                  />
                </div>
                <div
                  :style="{ height: posterImgHeight + 'px' }"
                  style="overflow: hidden; position: relative"
                >
                  <img class="imgCls posterurl" @load="posterurlFn" :src="posterUrl[posterIndex]" />
                  <img
                    class="w-100 pos-a l0 r0 b0"
                    id="fullNFreeN"
                    v-if="imgCreated_1"
                    :src="imgCreated_1"
                  />
                </div>
                <div
                  v-if="blindBoxImgBase"
                  style="overflow: hidden; position: relative; height: 0.52rem"
                >
                  <img class="imgCls blindBoxImg" id="blindBoxImg" :src="blindBoxImgBase" />
                </div>
                <div class="qrcode">
                  <!--<div style="width: 0.93rem;height: 0.93rem;margin-right: 0.18rem;" :style="{background: 'url(' + productDateils.qrcode + ') no-repeat 0', backgroundSize: '100% 100%'}"></div>-->
                  <div style="padding-right: 0.21rem; max-width: 70%; position: relative">
                    <p style="font-size: 0.17rem; color: #888888">
                      <span
                        style="
                          height: 0.305rem;
                          font-size: 0.13rem;
                          font-weight: 600;
                          color: #333333;
                          display: block;
                          line-height: 0.175rem;
                          white-space: normal;
                        "
                      >
                        {{
                          productDateils.name && productDateils.name.length > 20
                            ? productDateils.name.slice(0, 19) + '...'
                            : productDateils.name
                        }}
                      </span>
                      <b
                        style="
                          font-size: 0.1rem;
                          color: #999999;
                          margin-top: 0.05rem;
                          display: block;
                        "
                        v-if="productDateils.tags"
                      >
                        {{ productDateils.tags.join('\n') }}
                      </b>
                    </p>
                    <p class="poster-p" style="position: absolute">
                      <b>
                        {{
                          productDateils.sales_bottom_price
                            ? parseFloat(productDateils.sales_bottom_price).toFixed(2)
                            : '.00'
                        }}
                      </b>
                      <b>
                        ¥{{
                          productDateils.cost_bottom_price
                            ? parseFloat(productDateils.cost_bottom_price).toFixed(2)
                            : '.00'
                        }}
                      </b>
                    </p>
                  </div>
                  <div style="max-width: 35%; margin-top: -0.02rem">
                    <div id="img">
                      <img
                        id="qrcode"
                        @load="qrcodeFn"
                        style="width: 0.7rem; height: 0.7rem; margin: 0 auto"
                        :src="productDateils.qrcode"
                      />
                      <img
                        id="posterlogoewm"
                        @load="posterlogoewmFn"
                        src="../../assets/images/posterLogoewm.png"
                      />
                    </div>
                    <p
                      style="
                        font-size: 0.1rem;
                        font-weight: normal;
                        color: #888888;
                        white-space: nowrap;
                        margin-top: 0.02rem;
                      "
                    >
                      长按二维码购买
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="gallery-thumbs" v-if="1 === 2">
              <swiper class="swiper-wrapper" :options="posterSwiperOption">
                <swiper-slide
                  :style="posterIndex == index ? { border: '0.02rem solid #BB9773' } : {}"
                  v-for="(item, index) of productDateils.poster"
                  :key="index"
                >
                  <img v-lazy="item.posterurl" @click="posterClick($event, item, index)" />
                </swiper-slide>
              </swiper>
            </div>
            <div class="botton" v-if="postImgData == ''" @click="createPoster">
              <img src="../../assets/images/poster.png" />
              生成海报
            </div>
            <div class="botton" v-if="postImgData != ''">
              <img src="../../assets/images/poster.png" />
              长按图片保存
            </div>
          </div>
          <van-icon name="close" color="#E8E8E8" size="0.22rem" @click="close" />
        </div>
      </div>
    </transition>
    <!--放心购服务-->
    <van-action-sheet v-model="showcertifical" :title="certificationrule.label + '服务'">
      <div class="van-action_model certifical">
        <div class="pro_arg">
          <div class="pro_arg_list">
            <div class="pro_mess">
              <div
                class="pro_arg_item certifical_arg_item"
                v-for="item of certificationrule.detailList"
              >
                <span class="certifical_title flex-ac">
                  <van-icon size="14" :name="item.icon" />
                  &nbsp;{{ item.title }}
                </span>
                <span class="certifical_desc">{{ item.desc }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>
    <!--活动服务-->
    <div class="presale_info_dialog" v-if="showPresale == true && !changebuytype">
      <div class="dialog">
        <div class="header">
          <div class="van-divider">预售购买</div>
        </div>
        <div class="content">
          {{ presaledescpt }}
        </div>
        <div class="btn" @click="presell">我知道了</div>
      </div>
    </div>
    <!--活动服务-->
    <van-action-sheet v-model="showaction" v-if="!changebuytype" title="活动介绍">
      <div class="van-action_model">
        <div class="van-item" v-for="(item, index) in msglist" :key="index">
          <div v-if="item.isintegral == 1">
            <div class="tit" v-if="item.desc1">
              <van-tag color="#FC0213" plain text-color="#FC0324" type="primary">
                {{ item.actlabel }}
              </van-tag>
              {{ item.desc1 }}
            </div>
            <div class="tit con" v-if="item.desc2">
              <van-tag color="#FC0213" plain text-color="#FC0324" type="primary">
                {{ item.actlabel }}
              </van-tag>
              {{ item.desc2 }}
            </div>
          </div>
          <div v-else>
            <div class="tit">
              <van-tag color="#FEE9E6" text-color="#F12A0E">{{ item.actlabel }}</van-tag>
              {{ item.name }}
            </div>
            <div class="con" v-if="item.isdeposit">
              <div class="shortdesc" v-for="(itemB, index) in item.isdepositDesc" :key="index">
                {{ itemB }}
              </div>
            </div>
            <div class="con" v-else-if="item.desc" v-html="item.desc.replace(/\n/g, '<br/>')"></div>
          </div>
        </div>
        <div class="btn footerIOS">
          <van-button round type="danger" class="vanbtn" @click="showaction = false">
            确定
          </van-button>
        </div>
      </div>
    </van-action-sheet>
    <!--产品参数-->
    <van-action-sheet v-model="showparam" title="产品参数">
      <div class="van-action_model">
        <div class="pro_arg">
          <div class="pro_arg_list">
            <div class="pro_mess" v-if="productDateils.goodsParamsList && productDateils.goodsParamsList.length">
              <div class="pro_arg_item" v-for="item of productDateils.goodsParamsList">
                <span class="w-100px over-ell-1">{{ item.title }}</span>
                <span class="ml0" v-html="item.value.replace(/\n/g, '<br/>')"></span>
              </div>
              <div class="pro_arg_item" v-if="specification_html">
                <span class="w-100px over-ell-1">产品规格</span>
                <span class="ml0" v-html="specification_html"></span>
              </div>
            </div>
            <div class="pro_mess" v-else>
              <div class="pro_arg_item" v-if="productDateils.brand">
                <span>产品品牌</span>
                <span>{{ productDateils.brand }}</span>
              </div>
              <div class="pro_arg_item" v-if="specification_html">
                <span>产品规格</span>
                <span v-html="specification_html"></span>
              </div>
              <div class="pro_arg_item" v-if="productDateils.usescope">
                <span>适用范围</span>
                <span>{{ productDateils.usescope }}</span>
              </div>
              <div class="pro_arg_item" v-if="productDateils.item_character">
                <span>商品特性</span>
                <span>{{ productDateils.item_character }}</span>
              </div>
              <div class="pro_arg_item" v-if="productDateils.usemethod">
                <span>使用方法</span>
                <span>{{ productDateils.usemethod }}</span>
              </div>
              <div class="pro_arg_item" v-if="productDateils.useyear">
                <span>使用年限</span>
                <span>{{ productDateils.useyear }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="btn footerIOS bg-F">
          <van-button round type="danger" class="vanbtn d-b mb10" @click="showparam = false">
            完成
          </van-button>
        </div>
      </div>
    </van-action-sheet>
    <van-action-sheet
      class="coupon_list_action_sheet"
      title="优惠券"
      v-if="!changebuytype"
      v-model="showcoupon"
    >
      <div class="coupon_list">
        <ul>
          <li v-for="item of couponslist">
            <div class="couponContent">
              <img src="/static/images/coupon.png" />
              <div
                :class="[{ coupon: item.isShow }, { coupon2: item.isShow }]"
                class="couponBottom"
                v-if="item.isShow"
              >
                <p>{{ item.details }}</p>
              </div>
              <div class="couponCon" style="height: 1.08rem">
                <div style="overflow: hidden; height: 100%">
                  <div class="couponLeft couponLeftOne" style="height: 100%">
                    <div class="goods_price">
                      <span class="smallprice">
                        <sub>¥</sub>
                        <b
                          v-text="
                            String(parseFloat(item.price).toFixed(2)).slice(
                              0,
                              String(parseFloat(item.price).toFixed(2)).indexOf('.')
                            )
                          "
                        ></b>
                        <sup
                          v-text="
                            String(parseFloat(item.price).toFixed(2)).slice(
                              String(parseFloat(item.price).toFixed(2)).indexOf('.'),
                              String(parseFloat(item.price).toFixed(2)).length
                            )
                          "
                        ></sup>
                      </span>
                    </div>
                    <p>{{ item.couponname }}</p>
                  </div>
                  <div class="couponRight" style="height: 100%">
                    <p style="line-height: 0.2rem">
                      <img
                        src="/static/images/coupontag1.png"
                        style="width: 0.38rem; float: left"
                        v-if="item.coupontype == 2"
                      />
                      <img
                        src="/static/images/coupontag2.png"
                        style="width: 0.48rem; float: left"
                        v-if="item.coupontype == 1"
                      />
                      &nbsp;{{ item.gettype }}
                    </p>
                    <b>{{ item.starttime }}{{ item.invalidtime ? '-' + item.invalidtime : '' }}</b>
                    <div
                      class="couponfooter"
                      style="position: absolute; bottom: 0.05rem; left: 0; right: 0"
                    >
                      <span v-if="item.details">
                        详细信息
                        <van-icon
                          @click.stop="couponDetailClick(item, index)"
                          color="#B7B7B7"
                          name="arrow-down"
                          v-if="!item.isShow"
                        />
                        <van-icon
                          @click.stop="couponDetailClick(item, index)"
                          color="#B7B7B7"
                          name="arrow-up"
                          v-if="item.isShow"
                        />
                      </span>
                      <div class="btnBox">
                        <button
                          @click="receive(item)"
                          class="btn redBtn redBorBtn"
                          v-if="item.isreceive == 0"
                        >
                          领取
                        </button>
                        <button
                          @click="goCouponproduct(item)"
                          class="btn redBtn"
                          v-if="item.isreceive == 1"
                        >
                          可用商品
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </van-action-sheet>
    <div class="liveWrap" v-if="liveFlag && !changebuytype && live_count && live_count == 1">
      <div class="titleWrap">
        <img class="titleImg" src="/static/images/other/see-now.gif" />
        <span class="number">直播中</span>
      </div>
      <div class="closeWrap" @click.stop="closeLive">
        <img class="close-btn" src="../../assets/images/close-live.png" />
      </div>
      <div class="mainImg">
        <img :src="live_cover_img" />
        <div
          class="slide_cl_xcx"
          @click.stop="goliveInfo"
          :path="live_ad_url + '&sorce=4'"
          :username="'gh_5d4bb8e18b8b'"
        ></div>
      </div>
    </div>
    <div class="liveWrap live" v-if="liveFlag && !changebuytype && live_count && live_count > 1">
      <div class="mainImg">
        <img src="/static/images/other/see-now1.gif" />
        <div
          class="slide_cl_xcx"
          @click.stop="goliveInfo"
          path="/pages/personalcenter/pages/livelist/main.html?sorce=4"
          :username="'gh_5d4bb8e18b8b'"
        ></div>
      </div>
    </div>
    <div v-if="recommend" class="f13 color-FC0324 goback recommend" @click="$router.go(-1)">
      返回下单页
    </div>
    <div v-if="showsVideo" class="van-uploader__wrapper">
      <div
        class="van-uploader__upload"
        :class="{ fullscreen: isfullscreen }"
        style="position: relative; width: 1.05rem; height: 1.05rem; background: #333333"
      >
        <video
          @click="playFn2"
          class="videofile"
          id="videofile2"
          :src="fullVideoUrl"
          webkit-playsinline="true"
          playsinline="true"
          x5-playsinline="true"
          x-webkit-airplay="allow"
          preload="true"
        >
          <source :src="fullVideoUrl" />
          您的浏览器不支持 video 标签。
        </video>
      </div>
    </div>
    <sku-preview
      v-if="productDateils.sku_rule_list"
      :hide-add-cart-button="
        !(
          !fold &&
          actopen.is_ck_community_item != 1 &&
          productDateils.isaddcart != 0 &&
          !groupbuyid
        ) ||
        (changeSkuIndex >= 0 &&
          (productDateils.sku_rule_list[changeSkuIndex].canbuycnt == 0 ||
            productDateils.sku_rule_list[changeSkuIndex].issale == 0 ||
            productDateils.sku_rule_list[changeSkuIndex].islimit == 2 ||
            productDateils.sku_rule_list[changeSkuIndex].is_can_buy == 0))
      "
      :hide-buy-button="
        changeSkuIndex >= 0 &&
        (productDateils.sku_rule_list[changeSkuIndex].canbuycnt == 0 ||
          productDateils.sku_rule_list[changeSkuIndex].issale == 0 ||
          (productDateils.sku_rule_list[changeSkuIndex].autochangetime <= 0 &&
            productDateils.sku_rule_list[changeSkuIndex].islimit == 1) ||
          (productDateils.sku_rule_list[changeSkuIndex].islimit == 2 &&
            productDateils.sku_rule_list[changeSkuIndex].subscribeShow == 0) ||
          productDateils.sku_rule_list[changeSkuIndex].is_can_buy == 0)
      "
      :show-sell-out-button="
        changeSkuIndex >= 0 &&
        (productDateils.sku_rule_list[changeSkuIndex].canbuycnt == 0 ||
          productDateils.sku_rule_list[changeSkuIndex].issale == 0 ||
          (productDateils.sku_rule_list[changeSkuIndex].autochangetime <= 0 &&
            productDateils.sku_rule_list[changeSkuIndex].islimit == 1) ||
          (productDateils.sku_rule_list[changeSkuIndex].islimit == 2 &&
            productDateils.sku_rule_list[changeSkuIndex].subscribeShow == 0) ||
          productDateils.sku_rule_list[changeSkuIndex].is_can_buy == 0)
      "
      ref="skuPreview"
      :sku-list="productDateils.sku_rule_list"
      @close="closePreview"
      @change="changePreview"
      @previewAddToCart="previewAddToCart"
      @previewBuyNow="previewBuyNow"
    />
    <van-overlay :show="is_pop" v-if="is_pop && popup_ads && popup_ads.img_path" z-index="99999">
      <div class="wrapper">
        <div class="block" @click.stop>
          <div style="position: relative">
            <img :src="popup_ads.img_path" @click="goAct('itemprop')" />
            <div
              :path="
                popup_ads.ad_target +
                (popup_ads.ad_target.indexOf('?') >= 0 ? '&' : '?') +
                'sorce=9'
              "
              class="slide_cl_xcx"
              :username="'gh_5d4bb8e18b8b'"
              v-if="isWx && (popup_ads.ad_type == 7 || popup_ads.ad_type == 8)"
            ></div>
          </div>
          <van-icon name="close" @click="is_pop = false" />
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="actQrcodeShow" z-index="2001">
      <div class="wrapper" @click.stop>
        <div
          class="block w-87"
          v-if="productDateils.privatePopup && productDateils.privatePopup.qrcode"
        >
          <div
            class="radius-8px pb15 pt25"
            :style="{
              'background-image':
                'url(' +
                (productDateils.privatePopup.bgimg || imgpath1 + 'static/images/qrcode_bg.png') +
                ')'
            }"
            style="background: url() no-repeat center; background-size: 100% 100%"
          >
            <p
              class="f18 color-3 fw-b mt0 mb18"
              style="min-height: 0.45rem"
              v-html="productDateils.privatePopup.desc.replace(/\n/g, '<br/>')"
            ></p>
            <img class="pl50 pr50 pt22 pb10" :src="productDateils.privatePopup.qrcode" alt="" />
            <p class="f11 color-3 mt0 mb25">长按保存二维码图片-用注册微信扫码添加</p>
            <van-button
              class="mt15 f14"
              style="height: 0.36rem; width: 1.45rem"
              type="primary"
              round
              color="linear-gradient(90deg, #F66E0A 0%, #EC3A31 100%)"
              @click="buy(1)"
            >
              直接购买
            </van-button>
          </div>
          <van-icon
            name="close"
            @click="
              actQrcodeShow = false
              itemId()
            "
          />
        </div>
      </div>
    </van-overlay>
    <!--2025-8-28 新增红包雨弹窗-->
    <red-packets-rain-pop ref="redPacketsRainPop"></red-packets-rain-pop>
    <van-popup v-if="popularScience.documentUrlList && popularScience.documentUrlList.length > 0" round v-model="popularScienceShow" position="bottom" :style="{ height: '75%' }" style="border-radius: 0.08rem !important;" >
      <div class="pos-r h-100">
        <div class="popular-science-bg pos-a l0 t0 w-100" :style="{opacity: popularScienceOpacity}"></div>
        <img class="w-100 pos-a t0 l0 zi-66" src="/static/images/popular-science-title.png" alt="">
        <van-icon class="pos-a r0 t0 mt20 mr15 zi-66" size="0.2rem" name="/static/images/closex.png" @click="popularScienceSwitchHandle" />
        <div class="h-100 pos-r" style="padding-top: 0.6rem;">
          <div class="h-100 scroll-y pos-r" ref="popularScienceBoxRef" @scroll="popularScienceScrollHandle">
            <img v-for="item of popularScience.documentUrlList" class="w-100 d-b pos-r zi-1" :src="item.imgPath" alt="">
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import '../../assets/css/zy.media.css'
import { Rate, Divider, Overlay, Sku, Loading, ImagePreview, Tag, Skeleton } from 'vant'
import productItem from '../../components/common/productItem'
import follow from '../common/follow'
import vanMarquee from '../common/vanMarquee'
import zymedia from '../../assets/js/zy.media'
import {
  isWeixin,
  kefu,
  qrcodeKefuLimits,
  fenxiang,
  Base64,
  appid,
  isApp,
  dateFn,
  requestSubscribeMessage,
  exclusiveidFn,
  pointParams,
  popType,
  clearPopCache,
  bannerClick,
  goXcxCreateBtnFn,
  isWx,
  cartNum,
  getServerDate
} from '../../assets/common/js/config'
import actCoupon from '../common/coupon'
import Vue from 'vue'
import wx from 'weixin-js-sdk'
import skufunc from '../../assets/common/js/sku_func'
import skuPreview from '../common/skuPreview.vue'
import HotSalesGoods from './components/hotSalesGoods.vue'
import redPacketsRainPop from '../common/redPacketsRainPop.vue'
import goodsFloatImg from '../common/goodsFloatImg'
Vue.use(VueAwesomeSwiper /* { default global options } */)
Vue.use(ImagePreview)
Vue.config.ignoredElements = ['wx-open-launch-weapp']
export default {
  name: 'productDetail',
  components: {
    [Rate.name]: Rate,
    [Divider.name]: Divider,
    [Overlay.name]: Overlay,
    [Sku.name]: Sku,
    [Loading.name]: Loading,
    [Tag.name]: Tag,
    [Skeleton.name]: Skeleton,
    productItem,
    follow,
    actCoupon,
    vanMarquee,
    skuPreview,
    HotSalesGoods,
    redPacketsRainPop,
    goodsFloatImg
  },
  data() {
    var that = this
    return {
      icon: 'play',
      follow: null,
      recCount: 0,
      communityid: this.$route.query.communityid ? this.$route.query.communityid : '',
      loading: true,
      sureGray: true,
      showaction: false,
      showparam: false,
      showcoupon: false,
      msglist: [],
      showPresale: false,
      presaledescpt: '',
      actopen: {},
      isShare: false,
      posterShow: false,
      playShow: false,
      imgShow: false,
      posterList: [],
      posterUrlBase: '',
      posterUrl: [],
      posterImgHeight: '',
      qrcode: '',
      posterIndex: 0,
      postImgData: '',
      posterDataLoading: false,
      title: '',
      posterSwiperOption: {
        spaceBetween: 10,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true
      },
      showsku: false,
      showshare: false,
      activeIndex: 0,
      bannerSwiper: null,
      galleryThumbs: null,
      islove: false,
      isoverseas: false, // 判断该商品是不是海外商品
      value: 5,
      propic: null,
      bannerList: [],
      show: false,
      skuname: '',
      skuprice: '197.00-218.90',
      skucostprice: '',
      specification: '',
      specification_html: '',
      ceil: false,
      zIndex: false,
      wuIndex: 0,
      daiIndex: 0,
      zcIndex: 0,
      navId: 0,
      skuId: null, // 总规格id 注： 传给后端的参数
      itemnum: null, // 购买数量 注：传给后端的参数
      buyType: null, // 判断点击‘加入购物袋’或‘立即购买’，0加入购物袋  1立即购买,
      tempType: null, // 临时存储buyType
      productlist: [],
      productBannerList: [],
      skuValueToast: null,
      nav: ['商品', '评论', '详情', '推荐'],
      productEvaluate: {},
      quota: 0,
      quotaUsed: 0,
      sku: {
        tree: [],
        list: [],
        price: '1.00',
        stock_num: 0
      },
      goods: {
        title: '',
        picture: ''
      },
      initialSku: {},
      i: 0,
      customStepperConfig: {
        quotaText: '每次限购xxx件',
        handleOverLimit: (data) => {
          const { action, limitType, quota, quotaUsed } = data

          if (action === 'minus') {
            this.$toast('至少选择一件商品')
          } else if (action === 'plus') {
            // let msg = `单次限购${quota}件`
            // if (quotaUsed > 0) msg += `，你已购买${quotaUsed}`
            let msg = `数量超出范围~`
            this.$toast(msg)
          }
        },
        handleStepperChange: (currentValue) => {},
        stockNum: 0,
        stockFormatter: (stockNum) => {}
      },
      productDateils: {},
      post_sale_price: '',
      post_cost_price: '',
      tagslist: [],
      swiperOption: {
        slidesPerView: 3.8,
        spaceBetween: 7,
        observer: true,
        observeParents: true
      },
      discountrule: {},
      productInfo: null,
      live_ad_url: null, // 直播链接
      live_count: null,
      live_cover_img: null, // 直播小窗图
      liveFlag: false, // 直播小窗：默认不显示
      changebuytype: this.$route.query.type || '', // type=changebuyproductdetail 换购商品标记，屏蔽交互按钮也可以用
      defectivegood: this.$route.query.defectivegood || '', // 残次品专区商品标记
      newpersondetail: this.$route.query.newpersondetail || '', // 新人有礼商品标记
      groupbuyid: this.$route.query.groupbuyid || '', // 自提团购id标记
      giftType: this.$route.query.gift || '',
      depositObj: {
        // 预售付定金
        isdeposit: null, // 是否为预售付定金商品 0：否 1：是
        actstatus: null, // 活动状态：0活动未开始 1开始付定金 2付定金结
        statusdesc: null, // 活动状态描述（5个阶段）
        depositmoney: null, // 价格
        sales_price: null, // 销售价
        totalPrice: 0
      },
      halfprice: {},
      integralrule: null,
      couponslist: [],
      coupontags: [],
      onSaleStatus: 0, // 商品上下架状态 0默认 1开售 2未开售
      updatesaletime: 0,
      updatesaleendtime: '',
      updatesaletimeitem: 0,
      updatesaleendtimeitem: '',
      pushmsgId: [],
      skuids: [],
      subscribeShow: 0,
      subscribeShowitem: 0,
      subScribeTime: '', // 到货提醒月份
      fold: this.$route.query.fold, // 5折券商品详情页相关按钮屏蔽开关
      ndo_img_path: '',
      ndo_url: '',
      directReduction: {
        // 直降活动
        isDirectReduction: 0,
        directReductionPrice: 0,
        directReductionRemainingTime: 0
      },
      limitinfo: '', // 限购标记
      fullDiscountRule: {}, // 限时折扣
      recommend: this.$route.query.recommend || 0,
      minipath: '',
      goodcommentsnum: 0,
      goodcomments: [],
      problemsnum: 0,
      problems: [],
      isfullscreen: false,
      showsVideo: false,
      fullVideoUrl: '',
      morediscounts: {}, // n件立减
      pathfrom: this.$route.query.from || '', // 用于地铁投放埋点判断
      activityUI: null, // 活动样式 【满减、n件立减、限时折扣】
      activityUITime: 1, // 活动样式倒计时【仅限限时折扣】0显示临时样式 1显示日常样式
      fullMinusInfo: null, // 满减活动
      priareainfo: {},
      certificationrule: {},
      showcertifical: false,
      privatesphere: [], // 私域入口广告
      nocartshow: this.$route.query.nocartshow || '', // 是否显示加入购物车按钮 0否 1是
      newuserzone: this.$route.query.newuserzone || '', // 是否是新人有礼专区跳转而来 0否 1是
      ord_popup_ads: {},
      is_pop: false,
      popup_ads: {},
      isWx: isWeixin() ? 1 : 0,
      isnewpersontask: 0,
      newpersonjump: '',
      cartnum: 0,
      selectedSkuIndex: -1,
      changeSkuIndex: -1,
      isActHandleBuy: 0 /*618引流裂变活动-临时调整 是否已获取商品详情接口 0否 1是 */,
      actQrcodeShow: false /*618引流裂变活动-临时调整 二维码弹窗显示 */,
      serverDate: '', // 当前时间
      hotSalesGoodsList: [], // 热销商品
      hotSalesGoodsListTd: [], // 热销商品
      blindBoxImg: '', // 盲盒图片
      blindBoxImgBase: '', // 盲盒图片base
      fullNFreeN: {}, // 满N件免N件
      imgCreated: '',
      imgCreated_1: '',
      popularScienceShow: false,
      popularScienceOpacity: 1,
      popularScience: {}
    }
  },
  beforeMount: function () {
    if (this.$route.query.itemid == '679') this.$router.replace('/productdetail?itemid=758')
    if (this.$route.query.itemid == '2978')
      this.$router.replace(
        '/productdetail?itemid=2671&exclusiveid=' + exclusiveidFn() + pointParams('&')
      )
    if (this.$route.query.itemid == '2777')
      this.$router.replace(
        '/productdetail?itemid=3313&exclusiveid=' + exclusiveidFn() + pointParams('&')
      )
    if (this.$route.query.pt == 'xcx' && this.$route.query.type != 'changebuyproductdetail')
      wx.miniProgram.redirectTo({
        url:
          '/pages/product/main?itemid=' +
          this.$route.query.itemid +
          '&exclusiveid=' +
          exclusiveidFn() +
          pointParams('&')
      })
  },
  mounted: function () {
    let that = this
    if (isWeixin()) {
      that.isShare = true
      var query = window.location.href.split('?')
      that.minipath = '/pages/product/main.html?' + query[1]
    }
    window.scrollTo(0, 0)
    if (
      this.$route.query.itemid == '2535' ||
      this.$route.query.itemid == '2533' ||
      this.$route.query.itemid == '2685'
    ) {
      this.identity()
    }
    if (that.fold) {
      that.homeFn(function () {
        that.getData()
      })
    } else {
      // 校验是否跳转新的商品详情
      that
        .$customRequestAjax(this.$ajax.checkStock_URL + '?itemid=' + this.$route.query.itemid)
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.itemid) {
              that.$router.replace(
                '/productdetail?itemid=' +
                  res.data.itemid +
                  (exclusiveidFn() ? '&exclusiveid=' + exclusiveidFn() : '') +
                  pointParams('&')
              )
            }
          }
          that.getData(() => {
            that.getCoupon()
          })
        })
        .catch((err) => {
          that.getData(() => {
            that.getCoupon()
          })
        })
    }
    that.$newuserFn((data) => {
      if (data.code == 200) {
        that.isnewpersontask = data.isnewpersontask
        that.newpersonjump = data.newpersonjump ? data.newpersonjump : ''
      }
    })
    that.$nextTick(function () {
      that.bannerSwiper = new Swiper('#pro_pic', {
        autoplay: false,
        observer: true,
        observeParents: true,
        on: {
          slideChangeTransitionStart: function () {
            that.activeIndex = this.activeIndex
          }
        }
      })
      that.propic = new Swiper('.comment_pic .swiper-container', {
        slidesPerView: 3.3,
        spaceBetween: 7,
        observer: true,
        observeParents: true
      })
      window.addEventListener('scroll', that.scrollWatch)
      var videoBar = $('#Glide .swiper-slide')
      var video = videoBar.find('video')
      let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (!isiOS) {
        setTimeout(() => {
          let videoContexts = document.querySelectorAll('.zy_media video')
          videoContexts.forEach((videoContext) => {
            let imgElement = document.createElement('img')
            imgElement.style.display = 'block'
            imgElement.style.width = '100%'
            imgElement.src = that.productDateils.video_img_url
            videoContext.parentNode.style.display = 'block'
            videoContext.parentNode.append(imgElement)
            videoContext.addEventListener('play', () => {
              imgElement.style.display = 'none'
              videoContext.style.display = 'block'
              videoContext.parentNode.style.display = 'block'
              that.bannerSwiper.autoplay.stop()
            })
            videoContext.addEventListener('pause', () => {
              imgElement.style.display = 'block'
              videoContext.style.display = 'none'
              // videoContext.parentNode.style.display = "none";
              that.bannerSwiper.autoplay.start()
            })
          })
        }, 500)
      } else {
        video.on('play', function () {
          that.bannerSwiper.autoplay.stop()
        })
        video.on('pause', function () {
          that.bannerSwiper.autoplay.start()
        })
      }
    })
    // // 挂载完成后，判断浏览器是否支持popstate
    // if (window.history && window.history.pushState) {
    //   history.pushState(null, null, document.URL);
    //   window.addEventListener('popstate', this.goBack, false)
    // }
    cartNum((num) => (this.cartnum = num))
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.scrollWatch)
    // window.removeEventListener('popstate', this.goBack, false);
    this.$toast.clear()
    this.$dialog.close()
    sessionStorage.removeItem('choose_coupon')
    sessionStorage.removeItem('choose_product')
  },
  beforeRouteEnter(to, from, next) {
    next()
  },
  computed: {
    currentdiscount() {
      var that = this
      let currentdiscount = 1,
        discountlist = []
      if (that.fullDiscountRule && that.fullDiscountRule.actstatus == 1) {
        discountlist = that.fullDiscountRule.rulelist
        discountFn()
      } else if (that.discountrule && that.discountrule.discountenable == 1) {
        discountlist = that.discountrule.discountlist
        discountFn()
      }
      function discountFn() {
        try {
          discountlist.forEach(function (item, index) {
            if (parseInt(that.itemnum) >= parseInt(item.itemnum)) {
              let discount1 = item.discount
              currentdiscount = discount1
              throw new Error()
            }
          })
        } catch (e) {
          return currentdiscount
        }
      }
      return currentdiscount
    }
  },
  methods: {
    imgCreatedHandler(img) {
      this.imgCreated = img
      if (!this.imgCreated_1) this.imgCreated_1 = img
    },
    // 2025-06-12 专属优惠券弹窗-浏览商品送券
    async getCouponPopups() {
      let { data } = await this.$customRequestAjax(this.$ajax.getCouponPopupSet_URL)
      if (data.pop_up.img_path) {
        this.is_pop = true
        this.popup_ads = data.pop_up
      }
      if (!this.is_pop) {
        let nowDay = new Date(new Date().toLocaleDateString()).getTime(),
          type = 'ordPop' // 首页普通弹窗标识
        let oldDay = localStorage.getItem(type + 'normalPopIsShow')
        if (oldDay != nowDay) {
          this.getOrdPop()
        }
      }
    },
    /**红包雨弹窗 */
    redPacketPop() {
      this.$refs.redPacketsRainPop.open()
    },
    // 首页普通弹窗
    getOrdPop: function () {
      this.$customRequestAjax(this.$ajax.getPublicPopup_URL).then((res) => {
        if (res.data.code == 200) {
          this.ord_popup_ads = res.data.popup_ads
          this.ordPopFn()
        }
      })
    },

    // 首页普通弹窗
    ordPopFn: function () {
      // that.currentPopType => 当前接口返回的是那种弹框类型 0-普通弹框 1-vip礼包弹框
      // 如果是普通弹框，每天弹1次
      // console.log('日常活动弹框')
      console.log(new Date().getHours(), new Date().getMinutes())
      let curTime = new Date().getTime(),
        type = 'ordPopProduct',
        that = this

      if (this.ord_popup_ads.dateConfig) {
        this.ord_popup_ads.dateConfig.map((item) => {
          let time0 = new Date(item.date[0].replace(/-/g, '/')).getTime(),
            time1 = new Date(item.date[1].replace(/-/g, '/')).getTime()
          if (time0 < curTime && curTime <= time1) {
            if (!localStorage.getItem(type + time0)) {
              clearPopCache(type)
              localStorage.setItem(type + time0, 1)
            }
            popType(item.times, this.ord_popup_ads, type, function () {
              that.is_pop = true
              that.popup_ads = that.ord_popup_ads
            }) // 设为100 意为 需求：不限制次数
          } else {
            localStorage.removeItem(type + time0)
          }
        })
      } else {
        popType(3, this.ord_popup_ads, type, function () {
          that.is_pop = true
          that.popup_ads = that.ord_popup_ads
        }) // 设为100 意为 需求：不限制次数
      }
      setTimeout(() => {
        goXcxCreateBtnFn(this)
      }, 500)
    },
    goAct: function (flowArea) {
      this.is_pop = false
      bannerClick(this.popup_ads, 0, flowArea, this, () => {
        this.dataCollection_advertise(this.popup_ads, 0, flowArea)
      })
    },
    dataCollection_advertise(items, index, flowArea) {
      let params = {
        flowArea_var: flowArea, // 区域
        position_var: index, // 坑位
        flowName_var: flowArea == '热门直播' ? items.name : items.ad_title || '', // 流量位名称
        productName_var: flowArea == '热门直播' ? '' : items.name || '' // 商品名称
      }

      // 首页-流量位-埋点事件
      gio('track', 'flowLocationClick', params)
      // 首页-流量位-区域-转化变量
      gio('evar.set', 'flowArea_evar', flowArea)
      // 首页-流量位-区域-坑位-转化变量
      let value = flowArea == '热门直播' ? items.name : items.ad_title || ''
      gio('evar.set', 'flowName_evar', value)
    },
    async identity() {
      var url = this.$ajax.getUserIdentity_URL
      var res = await this.$customRequestAjax(url)
      if (res.data.code == 200) {
        if (res.data.data.viplevel != 2 && res.data.data.viplevel != 3) {
          window.location.replace('/')
        }
      }
    },
    setNameTool(nameVal) {
      let name_f,
        name_l,
        newName = ''
      if (nameVal.length > 2) {
        name_f = nameVal.substring(0, 1)
        name_l = nameVal.substr(nameVal.length - 1, 1)
        newName = name_f + '***' + name_l
      } else {
        newName = nameVal + '***'
      }
      return newName
    },
    playFn(url) {
      this.showsVideo = !this.showsVideo
      this.isfullscreen = !this.isfullscreen
      this.fullVideoUrl = url
      this.$nextTick(() => {
        if (this.isfullscreen) {
          document.getElementById('videofile2').play()
        } else {
          document.getElementById('videofile2').pause()
        }
      })
    },
    playFn2() {
      this.showsVideo = !this.showsVideo
      this.isfullscreen = !this.isfullscreen
      if (this.isfullscreen) {
        document.getElementById('videofile2').play()
      } else {
        document.getElementById('videofile2').pause()
      }
    },
    // 关闭直播小窗
    closeLive() {
      this.liveFlag = false
    },
    // 跳转至直播详情页
    goliveInfo() {
      if (!isWeixin()) {
        this.$toast('请前往微信搜索小程序「创客云商可丽金官方」')
      }
    },
    newpersontask() {
      window.location = this.newpersonjump
    },
    invaliditytime(fn) {
      if (this.$route.query.time) {
        this.serverDate = new Date(getServerDate()).getTime()
        if (this.$route.query.time <= this.serverDate) {
          this.$dialog
            .alert({
              message: '链接商品已失效，去看看\n其他商品吧',
              className: 'percen_button_alert integral_button_alert',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '去逛逛',
              closeOnPopstate: false
            })
            .then(() => {
              // on confirm
              this.$router.replace('/')
            })
        } else if (typeof fn == 'function') {
          fn()
        }
      } else if (typeof fn == 'function') {
        fn()
      }
    },
    invalidDialog() {
      this.$dialog
        .alert({
          message: '链接已失效，请您去首页转转',
          className: 'percen_button_alert integral_button_alert',
          confirmButtonColor: '#FFFCFC',
          confirmButtonText: '去首页',
          closeOnPopstate: false
        })
        .then(() => {
          // on confirm
          this.$router.replace('/')
        })
    },
    getData: function (fn) {
      var base = new Base64()
      var that = this
      var isinvalid = false
      var url
      if (this.$route.query.live_id) {
        url =
          this.$ajax.getItemInfo_URL +
          '?fullDiscountRuleNew=1&itemid=' +
          this.$route.query.itemid +
          '&liveid=' +
          this.$route.query.live_id
      } else if (
        this.changebuytype == 'changebuyproductdetail' &&
        this.defectivegood != 1 &&
        this.nocartshow != 1
      ) {
        if (this.$route.query.issale == 1) {
          // 线下会议营销礼包下架商品详情接口
          url = this.$ajax.getLiveItemInfo_URL + '?itembaseid=' + this.$route.query.itemid
        } else {
          url = this.$ajax.getExchangeItemInfo_URL + '?itemid=' + this.$route.query.itemid
        }
      } else {
        url =
          this.$ajax.getItemInfo_URL + '?fullDiscountRuleNew=1&itemid=' + this.$route.query.itemid
      }
      if (this.$route.query.actgroupid) {
        url += '&actgroupid=' + this.$route.query.actgroupid
        if (sessionStorage.getItem('ck_utoken')) {
          url += '&ck_utoken=' + sessionStorage.getItem('ck_utoken')
        }
      }
      that.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      that
        .$customRequestAjax(url)
        .then((res) => {
          isinvalid = true
          that.$toast.clear()
          that.$dialog.close()
          if (res.data.code === 200) {
            /**活动调整，活动名称：【50私域活动】50专属购买链接 */
            if (res.data.isShowGoods == 0) {
              that.$app.goIndex()
            } else {
              if (res.data.is_invalid == 1) {
                // 无效
                that.invaliditytime(() => {
                  that.invalidDialog()
                })
              } else {
                that.invaliditytime()
                that.productInfo = res.data
                that.dataCollection('productClick')
                that.dataCollection('productDetailPageView')
                f(res.data)
                g(res.data)
                getItemNewRecommend()
                checkActStatus()
              }
            }
          } else {
            that.invaliditytime()
          }
          if (typeof fn == 'function') fn()
        })
        .catch((err) => {
          setTimeout(function () {
            if (!isinvalid) {
              that.$toast.clear()
              that.$dialog.close()
              that.invaliditytime(() => {
                that.invalidDialog()
              })
            }
          }, 3000)
          if (typeof fn == 'function') fn()
        })
      function f(data) {
        if (data.vipLevelLimitMsg) {
          that.$dialog
            .alert({
              message: data.vipLevelLimitMsg,
              className: 'percen_button_alert',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '去查看',
              closeOnPopstate: false
            })
            .then(() => {
              // on close
              that.$app.argLink({ path: '/vipcenter' })
            })
        } else {
          if (data.isRedPacketPop == 1 && !sessionStorage.getItem('isRedPacketPop_product')) {
            sessionStorage.setItem('isRedPacketPop_product', 1)
            that.redPacketPop()
          } else {
            that.getCouponPopups()
          }
        }
        try {
          that.depositObj = {
            isdeposit: data.isdeposit,
            actstatus: data.actstatus,
            statusdesc: data.statusdesc,
            depositmoney: data.iteminfo.depositmoney,
            sales_price: data.iteminfo.sku_rule_list[0].sales_price,
            totalPrice: data.iteminfo.depositmoney
          }
          if (data.integralrule && data.integralrule.integralenable == 1) {
            that.integralrule = data.integralrule
            that.integralrule.integraldescArr = that.integralrule.integraldesc
              ? that.integralrule.integraldesc.split('，')
              : []
            console.log(that.integralrule)
          }
        } catch (e) {
          console.log(e)
        }
        try {
          that.directReduction = {
            isDirectReduction: data.isDirectReduction ? data.isDirectReduction : 0,
            directReductionPrice: data.directReductionPrice ? data.directReductionPrice : 0,
            directReductionRemainingTime: data.directReductionRemainingTime
              ? data.directReductionRemainingTime * 1000
              : 0
          }
        } catch (e) {
          console.log(e)
        }
        that.ndo_img_path = data.iteminfo.ndo_img_path ? data.iteminfo.ndo_img_path : ''
        that.ndo_url = data.iteminfo.ndo_url ? data.iteminfo.ndo_url : ''

        if (data.iteminfo.video_img_url != '' || data.iteminfo.video_play_url != '') {
          that.playShow = true
          that.imgShow = false
        } else {
          that.playShow = false
          that.imgShow = true
        }
        if (data.iteminfo.iscollection === '0') {
          that.islove = false
        } else {
          that.islove = true
        }
        if (data.certificationrule && data.certificationrule.isshow == 1) {
          that.certificationrule = data.certificationrule
        }
        that.goods.title = data.iteminfo.name
        that.goods.picture = data.iteminfo.img_path
        if (data.iteminfo.sku_rule_list && data.iteminfo.sku_rule_list.length <= 1) {
          that.skuname = data.iteminfo.sku_rule_list[0].sku_name
        }
        if (!(that.changebuytype && that.defectivegood != 1)) {
          if (
            data.iteminfo &&
            parseFloat(data.iteminfo.sales_bottom_price) !=
              parseFloat(data.iteminfo.sales_top_price)
          ) {
            that.skuprice =
              (
                parseFloat(data.iteminfo.sales_bottom_price) +
                parseFloat(that.directReduction.directReductionPrice)
              ).toFixed(2) +
              '-' +
              (
                parseFloat(data.iteminfo.sales_top_price) +
                parseFloat(that.directReduction.directReductionPrice)
              ).toFixed(2)
          } else {
            that.skuprice = (
              parseFloat(data.iteminfo.sales_bottom_price) +
              parseFloat(that.directReduction.directReductionPrice)
            ).toFixed(2)
          }
          that.skucostprice = ''
        }
        that.bannerList = data.iteminfo.img_paths
        that.productDateils = data.iteminfo || {}
        that.post_sale_price = data.post_sale_price ? data.post_sale_price : ''
        that.post_cost_price = data.post_cost_price ? data.post_cost_price : ''
        that.isoverseas = that.productDateils.property == 'overseas'
        that.popularScience = that.productDateils.popularScience || {}
        that.blindBoxImg = data.blindBoxImg || ''
        if (that.productDateils.isStreetGoods == 1) {
          that.nav = ['商品', '详情']
        }
        that.priareainfo =
          data.priareainfo && Object.keys(data.priareainfo).length ? data.priareainfo : {}
        that.privatesphere = data.privatesphere ? data.privatesphere : []
        that.halfprice = {
          ishalfprice: that.productDateils.ishalfprice,
          halfactlabel: data.halfactlabel,
          halfpricestatus: data.halfpricestatus,
          ishalf: data.ishalf,
          isbirthday: data.isbirthday
        }
        try {
          that.morediscounts = {
            discountenable: data.morediscounts.discountenable,
            name: data.morediscounts.name,
            discountdesc: data.morediscounts.discountdesc,
            actlabel: data.morediscounts.actlabel
          }
        } catch (e) {
          that.morediscounts = {}
          console.log(e)
        }
        if (data.fullMinusInfo && Object.keys(data.fullMinusInfo).length) {
          that.activityUIHandle({ info: data.fullMinusInfo, actType: 'fullMinus' })
        } else if (
          (data.fullDiscountRule && data.fullDiscountRule.actstatus == 1) ||
          that.productDateils.sku_rule_list[0].actType == 3
        ) {
          let tempTime = new Date('2025/09/21 23:59:59').getTime()
          let curTime = new Date().getTime()
          // 09.21日之前处理
          if (tempTime >= curTime) {
            that.activityUITime = 0
          }

          that.activityUIHandle({
            info: {
              ...data.fullDiscountRule,
              startTime: that.productDateils.sku_rule_list[0].actStartTime || 0,
              endTime: that.productDateils.sku_rule_list[0].actEndTime || 0,
              is24hourClock: that.productDateils.sku_rule_list[0].is24hourClock,
              actLabel: that.productDateils.sku_rule_list[0].actLabel,
              actName: that.productDateils.sku_rule_list[0].actName
            },
            actType: 'fullDiscount'
          })
        } else if (
          (data.morediscounts && data.morediscounts.discountenable == 1) ||
          that.productDateils.sku_rule_list[0].actType == 2
        ) {
          that.activityUIHandle({
            info: {
              ...data.morediscounts,
              startTime: that.productDateils.sku_rule_list[0].actStartTime || 0,
              endTime: that.productDateils.sku_rule_list[0].actEndTime || 0,
              actLabel: that.productDateils.sku_rule_list[0].actLabel,
              actName: that.productDateils.sku_rule_list[0].actName
            },
            actType: 'moreDiscounts'
          })
        }
        if (that.productDateils.poster && that.productDateils.poster.length <= 0) {
          that.productDateils.poster.push({
            posterurl: that.productDateils.img_main_path
          })
        }
        if (
          !(that.changebuytype && that.defectivegood != 1) ||
          that.nocartshow == 1 ||
          that.$route.query.issale == 1
        ) {
          that.specification = ''
          that.specification_html = ''
          var len = that.productDateils.sku_rule_list
          for (var i = 0; i < len.length; i++) {
            if (len[i].sku_name) {
              that.specification += len[i].sku_name + ''
              that.specification_html += len[i].sku_name + '<br/>'
            }
          }
          that.sku.tree = []
          that.productDateils.normlist.map(function (item, index) {
            that.sku.tree.push({
              k: item.spec_classify_name,
              v: [],
              k_s: 's' + (index + 1)
            })
            item.speclist.map(function (itemSon) {
              that.sku.tree[index].v.push({
                id: itemSon.spec_id,
                name: itemSon.spec_name
              })
            })
          })
          that.unitPriceHandle({
            price: that.productDateils.sku_rule_list[0].sales_price,
            costPrice: that.productDateils.sku_rule_list[0].cost_price,
            actLabel: that.productDateils.sku_rule_list[0].actLabel || '',
            actType: that.productDateils.sku_rule_list[0].actType || 0,
            item: that.productDateils.sku_rule_list[0]
          })
          that.wuIndex = 0
          that.daiIndex = 0
          that.zcIndex = 0
          that.pushmsgId = []
          if (that.productDateils.islimit == 1) {
            that.wuIndex = 0
            that.daiIndex = 1
            that.zcIndex = 0
            that.goodsCountDownFn({ item: that.productDateils.sku_rule_list[0] })
          } else if (that.productDateils.islimit == 2) {
            that.wuIndex = 1
            that.daiIndex = 0
            that.zcIndex = 0
            let temp = 0
            that.productDateils.sku_rule_list.map(function (item) {
              if (temp == 0 && item.subscribeShow != 0) {
                temp = 1
                that.subscribeShow = item.subscribeShow
                that.subScribeTime = item.subScribeTime
              }
              if (item.pushmsgId && temp == 1) {
                that.pushmsgId.push(item.pushmsgId)
                that.skuids.push(item.skuid)
              }
            })
          } else {
            var istime = 0,
              istemp = true
            that.productDateils.sku_rule_list.map(function (item) {
              if ((item.issale == 0 || item.canbuycnt <= 0) && item.is_can_buy == 0) {
                that.wuIndex++
                let temp = 0
                if (temp == 0 && item.subscribeShow != 0) {
                  temp = 1
                  that.subscribeShow = item.subscribeShow
                  that.subScribeTime = item.subScribeTime
                }
                if (item.pushmsgId && temp == 1) {
                  that.pushmsgId.push(item.pushmsgId)
                  that.skuids.push(item.skuid)
                }
              } else if (item.issale == 1 && item.canbuycnt > 0) {
                if (item.islimit == 2 || item.is_can_buy == 0) {
                  // 已售罄
                  that.wuIndex++
                  let temp = 0
                  if (temp == 0 && item.subscribeShow != 0) {
                    temp = 1
                    that.subscribeShow = item.subscribeShow
                    that.subScribeTime = item.subScribeTime
                  }
                  if (item.pushmsgId && temp == 1) {
                    that.pushmsgId.push(item.pushmsgId)
                    that.skuids.push(item.skuid)
                  }
                } else if (item.islimit == 1) {
                  // 待售
                  that.daiIndex++
                  if (istime == 0) {
                    istime = 1
                    that.goodsCountDownFn({ item })
                  }
                } else if (item.islimit == 0) {
                  istime = 1
                  that.zcIndex++
                  if (istemp) {
                    istemp = false
                    that.limitinfo = item.limitinfo ? item.limitinfo : ''
                    that.goodsCountDownFn({ item })
                  }
                }
              } else if (istemp) {
                istemp = false
                that.limitinfo = item.limitinfo ? item.limitinfo : ''
                that.goodsCountDownFn({ item })
              }
            })
            console.log(that.subscribeShow, that.subScribeTime)
            if (that.wuIndex == 0 && that.zcIndex == 0 && that.daiIndex > 0) {
              that.goodsCountDownFn({ item: that.productDateils.sku_rule_list[0] })
            }
          }
          that.live_cover_img = data.live_cover_img
          that.live_ad_url = data.live_ad_url
          that.live_count = data.live_count
          if (that.live_cover_img && that.live_ad_url) {
            that.liveFlag = true
          }
          if (that.isShare) {
            setTimeout(function () {
              goXcxCreateBtnFn(that)
            }, 500)
          }
        }
        if (data.isdiscount) {
          that.actopen.isdiscount = data.isdiscount
        }

        if (data.isfullgift) {
          that.actopen.isfullgift = data.isfullgift
        }

        if (data.ispresale) {
          that.actopen.ispresale = data.ispresale
        }
        if (data.is_pre_item) {
          that.actopen.is_pre_item = data.is_pre_item
        }

        if (data.is_pre_item) {
          that.actopen.is_pre_item = data.is_pre_item
        }
        if (data.is_ck_community_item) {
          that.actopen.is_ck_community_item = data.is_ck_community_item
        }
        that.discountrule = data.discountrule
        that.fullDiscountRule = data.fullDiscountRule
        that.msglist = []

        if (that.morediscounts.discountenable == 1) {
          that.msglist.push({
            enable: that.morediscounts.discountenable,
            shortdesc: that.morediscounts.name,
            desc: that.morediscounts.discountdesc,
            name: that.morediscounts.name,
            actlabel: that.morediscounts.actlabel,
            islink: 0
          })
        }
        if (data.isdeposit == 1) {
          let actdesc = data.presalerule.actdesc.replace(/[\r\n]/g, '&')
          actdesc = actdesc.split('&')
          that.msglist.push({
            name: data.presalerule.actlabel,
            actlabel: data.presalerule.actname,
            shortdesc: data.presalerule.actdesc,
            desc: data.presalerule.actdesc,
            isdepositDesc: actdesc,
            isdeposit: 1,
            islink: 0
          })
        }

        if (
          data.discountrule &&
          data.discountrule.discountenable == 1 &&
          data.discountrule.discountlist &&
          data.isdiscount == 1
        ) {
          var msg = []
          data.discountrule.discountlist.forEach(function (item, index) {
            var txt =
              (item.discount * 100) % 10 == 0 ? (item.discount * 100) / 10 : item.discount * 100
            msg.push(item.itemnum + '件' + txt + '折')
          })
          var discountruledesc = '满' + msg.join(',')
          that.msglist.push({
            enable: data.discountrule.discountenable,
            shortdesc: discountruledesc,
            desc: data.discountrule.discountdesc,
            name: data.discountrule.name,
            actlabel: data.discountrule.actlabel,
            islink: 0
          })
        }

        if (
          data.fullgiftrule &&
          data.fullgiftrule.actstatus == 1 &&
          data.fullgiftrule.rulelist &&
          data.isfullgift == 1
        ) {
          that.msglist.push({
            enable: data.fullgiftrule.actstatus,
            shortdesc: data.fullgiftrule.actname,
            desc: data.fullgiftrule.actdesc,
            name: data.fullgiftrule.actname,
            actlabel: data.fullgiftrule.actlabel,
            islink: 0
          })
        }
        if (data.halfpricestatus == 1 && data.ishalf == 1) {
          that.msglist.push({
            enable: data.halfpricestatus,
            shortdesc: data.halfactname,
            desc: data.halfactdesc,
            name: data.halfactlabel,
            actlabel: data.halfactlabel,
            islink: 0
          })
        }
        if (that.productDateils.ishalfprice == 1) {
          that.msglist.push({
            enable: that.productDateils.ishalfprice,
            shortdesc: '',
            desc: '',
            name: '5折专区商品',
            actlabel: '5折',
            islink: 0
          })
        }
        // if (data.integralrule && data.integralrule.integralenable == 1) {
        //   var obj = {
        //     isintegral: 1,
        //     enable: data.integralrule.integralenable,
        //     shortdesc: data.integralrule.integraldesc,
        //     desc: data.integralrule.integraldesc,
        //     desc1: '',
        //     desc2: '',
        //     name: data.integralrule.name,
        //     actlabel: '金币'
        //   }
        //   if (data.integralrule.integraldetail.money) {
        //     obj.desc1 = '金币可抵' + parseFloat(data.integralrule.integraldetail.money) + '元'
        //   }
        //   if (data.integralrule.integraldetail.integralnum) {
        //     obj.desc2 = '购买可得' + parseInt(data.integralrule.integraldetail.integralnum) + '金币/' + parseInt(data.integralrule.integraldetail.itemnum) + '件'
        //   }
        //   that.msglist.push(obj)
        // }
        if (
          data.fullDiscountRule &&
          data.fullDiscountRule.actstatus == 1 &&
          data.fullDiscountRule.actlabel
        ) {
          that.msglist.push({
            enable: data.fullDiscountRule.actstatus,
            shortdesc: data.fullDiscountRule.actname,
            desc: data.fullDiscountRule.actdesc,
            name: '',
            actlabel: data.fullDiscountRule.actname,
            islink: 0
          })
        }
        if (data.grouprule && data.grouprule.groupstatus == 1 && data.grouprule.actlabel) {
          that.msglist.push({
            enable: data.grouprule.actstatus,
            shortdesc: data.grouprule.actdesc,
            desc: data.grouprule.actdesc,
            name: '',
            actlabel: data.grouprule.actlabel,
            islink: 1
          })
        }

        if (data.presaledescpt) {
          that.presaledescpt = data.presaledescpt
        }
        that.loading = false
      }
      function g(data) {
        if (!!that.changebuytype) {
          data.isshare = 0
        }
        that.title = that.$route.meta.title = data.iteminfo.name
        if (that.productDateils.itemid) {
          // AI测肤推荐商品分享
          var item_character = data.iteminfo.item_character
          var img = data.iteminfo.img_main_path
          if (that.newuserzone == 1) {
            let shareinfo = JSON.parse(sessionStorage.getItem('newuserzone_shareinfo'))
            fenxiang({
              title: encodeURIComponent(
                shareinfo.sharetitle ? shareinfo.sharetitle : '新人有礼专区'
              ),
              desc: encodeURIComponent(shareinfo.sharedesc ? shareinfo.sharedesc : ''),
              imgx: shareinfo.shareimg ? shareinfo.shareimg : '',
              type: 'newuserzone',
              dataStr: 'type=newuserzone',
              path: 'productdetail'
            })
          } else if (data.isshare == 0) {
            fenxiang({ path: 'productdetail' })
            if (that.changebuytype && that.defectivegood == 1) {
              var arg = isApp()
              if (arg.indexOf('xcx') >= 0) {
                var xcxObj = {
                  type: 'shareFriends'
                }
                wx.miniProgram.postMessage({ data: xcxObj })
              }
            }
          } else if (that.fold) {
            let fenxiangobj = {
              itemid: that.productDateils.itemid,
              shareOpenid: appid,
              fold: that.fold,
              productName: encodeURI(that.title)
            }
            if (that.pathfrom) fenxiangobj.from = that.pathfrom
            fenxiang({
              title: encodeURIComponent(
                data.iteminfo.sharetitle ? data.iteminfo.sharetitle : that.title
              ),
              desc: encodeURIComponent(
                data.iteminfo.sharedesc ? data.iteminfo.sharedesc : item_character
              ),
              imgx: data.iteminfo.shareimg ? data.iteminfo.shareimg : img,
              type: 'foldproduct',
              dataStr: 'type=foldproduct&params=' + base.encode(JSON.stringify(fenxiangobj)),
              path: 'productdetail'
            })
          } else if (that.$route.query.skinType) {
            fenxiang({
              title: encodeURIComponent('皮肤测试'),
              desc: encodeURIComponent('AI皮肤测试，充分了解您你的皮肤状况！'),
              type: 'skinAnalysis',
              path: 'skinAnalysis',
              dataStr: 'type=skinAnalysis&emptybottle=emptybottle',
              imgx: that.staticImgUrl + 'Uploads/share/ndo1.png'
            })
          } else if (item_character) {
            let params = {
              itemid: that.productDateils.itemid,
              shareOpenid: appid,
              productName: encodeURI(that.title)
            }
            if (that.groupbuyid) params.groupbuyid = that.groupbuyid
            if (that.$route.query.actgroupid) params.actgroupid = that.$route.query.actgroupid
            fenxiang({
              title: encodeURIComponent(
                data.iteminfo.sharetitle ? data.iteminfo.sharetitle : that.title
              ),
              desc: encodeURIComponent(
                data.iteminfo.sharedesc ? data.iteminfo.sharedesc : item_character
              ),
              imgx: data.iteminfo.shareimg ? data.iteminfo.shareimg : img,
              type: 'detail',
              dataStr: 'type=detail&params=' + base.encode(JSON.stringify(params)),
              path: 'productdetail'
            })
          } else {
            let params = {
              itemid: that.productDateils.itemid,
              shareOpenid: appid,
              productName: encodeURI(that.title)
            }
            if (that.groupbuyid) params.groupbuyid = that.groupbuyid
            if (that.$route.query.actgroupid) params.actgroupid = that.$route.query.actgroupid
            fenxiang({
              title: encodeURIComponent(
                data.iteminfo.sharetitle ? data.iteminfo.sharetitle : that.title
              ),
              desc: encodeURIComponent(
                data.iteminfo.sharedesc ? data.iteminfo.sharedesc : '好礼已经备好，就差你了'
              ),
              imgx: data.iteminfo.shareimg ? data.iteminfo.shareimg : img,
              type: 'detail',
              dataStr: 'type=detail&params=' + base.encode(JSON.stringify(params)),
              path: 'productdetail'
            })
          }
        }
        var urlEval =
          that.$ajax.getCommentByItem_URL + '?item_base_id=' + that.productDateils.itemid
        that.$customRequestAjax(urlEval).then((res) => {
          if (res.data.code === 200) {
            that.productEvaluate = res.data
            that.tagslist = res.data.taglist
            that.goodcommentsnum = res.data.showswitch == 1 ? res.data.goodcommentsnum : -1
            that.goodcomments = res.data.goodcomments
            that.problemsnum = res.data.problemswitch == 1 ? res.data.problemsnum : -1
            that.problems = res.data.problems
            that.productEvaluate.list.map((item) => {
              item.itemscore = parseInt(item.itemscore)
            })
          }
        })
      }
      // 热销好评推荐品
      function getItemNewRecommend() {
        if (!!that.changebuytype) {
          return
        }
        if (that.productDateils && that.productDateils.itemid) {
          var url =
            that.$ajax.getItemNewRecommend_URL + '?item_base_id=' + that.productDateils.itemid
          that.$customRequestAjax(url).then((res) => {
            if (res.data.code == 200) {
              that.hotSalesGoodsList = res.data.itemlist.map((item) => {
                item.product_detail = 1
                return item
              })
              that.hotSalesGoodsListFormat()
            }
          })
        }
      }
      // 增加弹窗提示校验活动是否开始
      function checkActStatus() {
        if (that.productDateils.actStatus && that.productDateils.actStatus != 1) {
          const text = that.productDateils.actStatus == 2 ? '活动未开始' : '活动已结束'
          that.$dialog
            .alert({
              message: text,
              className: 'percen_button_alert',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '我知道了',
              closeOnPopstate: false
            })
            .then(function () {
              that.$router.replace('/')
            })
        }
      }
    },
    // 热销好评商品数据整理
    hotSalesGoodsListFormat() {
      // 清空目标数组，避免数据累积
      this.hotSalesGoodsListTd = []
      const totalItems = this.hotSalesGoodsList.length
      const itemsPerGroup = 3 // 每组固定3个元素
      // 计算总组数（向上取整）
      const totalGroups = Math.ceil(totalItems / itemsPerGroup)

      // 遍历每组
      for (let groupIndex = 0; groupIndex < totalGroups; groupIndex++) {
        const currentGroup = []
        // 每组填充6个元素
        for (let itemIndex = 0; itemIndex < itemsPerGroup; itemIndex++) {
          // 计算原始数据中的索引位置
          const originalIndex = groupIndex * itemsPerGroup + itemIndex

          if (originalIndex < totalItems) {
            // 存在原始数据，复制并添加index属性
            const item = { ...this.hotSalesGoodsList[originalIndex] }
            item.index = originalIndex
            currentGroup.push(item)
          } else {
            // 数据不足，用空对象填充
            currentGroup.push({})
          }
        }
        // 将当前组添加到目标数组
        this.hotSalesGoodsListTd.push(currentGroup)
        console.log('hotSalesGoodsListTd', this.hotSalesGoodsListTd)
      }
    },
    goHotSalesGoods() {
      this.$router.push({
        path: '/goodslist',
        query: {
          itemid: this.productDateils.itemid
        }
      })
    },
    unitPriceHandle: function ({ price, costPrice, actLabel, actType, item }) {
      this.productDateils.sales_bottom_price = price
      this.productDateils.sales_top_price = price
      this.productDateils.cost_bottom_price = costPrice
      this.productDateils.cost_top_price = costPrice
      if (this.activityUI && actType == 3) {
        if (parseFloat(item.fullDiscountmoney || 0) > 0) {
          this.productDateils.sales_top_price = (
            parseFloat(item.original_price || item.price) - parseFloat(item.fullDiscountmoney || 0)
          ).toFixed(2)
          this.productDateils.sales_bottom_price = (
            parseFloat(item.original_price || item.price) - parseFloat(item.fullDiscountmoney || 0)
          ).toFixed(2)
        }
        this.activityUI.actDesc = actLabel || ''
      }
      if (item.fullNFreeN && Object.keys(item.fullNFreeN).length > 0) {
        this.fullNFreeN = item.fullNFreeN
      }
    },
    // 商品下架倒计时处理、商品待售倒计时处理
    goodsCountDownFn: function ({ item }) {
      this.serverDate = new Date(getServerDate()).getTime()
      if (item.islimit == 1 && item.issale == 1) {
        this.onSaleStatus = 2
        this.updatesaletime = item.surpluschangetime > 0 ? item.surpluschangetime * 1000 : 0
        if (this.zcIndex <= 0 && this.updatesaletime > 0) {
          this.updatesaleendtime =
            item.autochangetime > 0 ? dateFn(item.autochangetime * 1000, 'datetimestr', 1) : ''
        }
      } else if (this.serverDate <= (item.delistTime || 0) * 1000) {
        this.onSaleStatus = 1
        this.updatesaletime = (item.delistTime || 0) * 1000 - this.serverDate
      } else {
        this.onSaleStatus = 0
        this.updatesaletime = 0
      }
    },
    /**满减类活动数据处理整合，UI呈现
     * 活动：满减、n件立减、限时折扣
     * 原型链接：https://lanhuapp.com/web/#/item/project/product?tid=20cf58ef-7da3-4a77-8545-cfae528abfdb&pid=c18eb805-0805-450f-87d6-1cbe5de2c309&versionId=790d2448-8368-4538-8759-d0ffca27e195&docId=9daaf04c-b862-46ba-82bc-bb357d8d36f6&docType=axure&pageId=e0592f20b4c847f0aae369682391d38a&image_id=9daaf04c-b862-46ba-82bc-bb357d8d36f6&parentId=32960b5d-d99c-4ad0-b10b-4763dc948879
     */
    activityUIHandle: function ({ info, actType }) {
      if (actType == 'fullMinus') {
        this.activityUI = {
          ...info,
          bgImg: info.fullMinusBgImg,
          startTime: info.fullMinusStartTime,
          endTime: info.fullMinusEndTime
        }
      } else if (actType == 'fullDiscount') {
        this.activityUI = {
          ...info,
          actName: info.actName,
          actDesc: info.actLabel
        }
        if (info.is24hourClock == 1) {
          this.serverDate = new Date(getServerDate()).getTime()
          if (info.startTime * 1000 <= this.serverDate && info.endTime * 1000 > this.serverDate) {
            const endTimeDate = new Date(info.endTime * 1000)
            const startOfNextDay = new Date(endTimeDate)
            startOfNextDay.setHours(0, 0, 0, 0)
            startOfNextDay.setDate(startOfNextDay.getDate() + 1)
            const endOfDayTimestamp = Math.floor((startOfNextDay.getTime() - 1) / 1000)
            if (info.endTime > endOfDayTimestamp) {
              info.endTime = endOfDayTimestamp
            }
          }
        }
      } else if (actType == 'moreDiscounts') {
        this.activityUI = {
          ...info,
          actName: info.actName,
          actDesc: info.actLabel
        }
      }
      let curtime = Math.floor(new Date(getServerDate()).getTime() / 1000)
      if (this.activityUI.startTime <= curtime && this.activityUI.endTime > curtime) {
        // 活动进行中
        this.activityUI.actstatus = 1
        this.activityUI.timeStr = '距结束'
        this.activityUI.time = (this.activityUI.endTime - curtime) * 1000
      } else if (this.activityUI.startTime > curtime) {
        // 活动即将开始
        this.activityUI.actstatus = 0
        this.activityUI.timeStr = '距开始'
        this.activityUI.time = (this.activityUI.startTime - curtime) * 1000
      }
    },

    homeFn: function (fn) {
      var url = this.$ajax.getDiscountItemForCouponList_URL
      this.$customRequestAjax(url)
        .then((res) => {
          if (res.data.code == 200 && res.data.five_fold_show == 0) {
            location.replace('/?exclusiveid=' + exclusiveidFn() + pointParams('&'))
          } else {
            if (typeof fn === 'function') fn()
          }
        })
        .catch((err) => {
          if (typeof fn === 'function') fn()
        })
    },
    finish: function () {
      this.getData()
    },
    goGroup: function () {
      if (this.productInfo.grouprule && this.productInfo.grouprule.groupstatus == 1) {
        if (this.productInfo.grouprule.groupid) {
          window.location =
            '/static/wx/html/new-group/collage_detail.html?ptid=' +
            this.productInfo.grouprule.groupid +
            (this.productInfo.grouprule.code ? '&code=' + this.productInfo.grouprule.code : '')
        } else {
          window.location =
            '/static/wx/html/new-group/collagelist.html' +
            (this.productInfo.grouprule.code ? '?code=' + this.productInfo.grouprule.code : '')
        }
      }
    },
    couponslistFn: function () {
      if (this.couponslist.length > 0) {
        this.showcoupon = true
      }
    },
    getCoupon: function () {
      if (this.productDateils.itemid) {
        var url = this.$ajax.getCouponByItem_URL + '?itemid=' + this.productDateils.itemid
        this.$customRequestAjax(url).then((res) => {
          if (res.data.code == 200) {
            this.coupontags = res.data.taglist
            res.data.couponslist.map((item) => {
              item.isShow = false
            })
            this.couponslist = res.data.couponslist
          }
        })
      }
    },
    couponDetailClick: function (items, id) {
      items.isShow = !items.isShow
    },
    receive: function (item) {
      var url = this.$ajax.receiveCoupon_URL,
        data = {
          couponid: item.couponid
        }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          item.isreceive = 1
          item.couponid = res.data.couponid
        }
      })
    },
    goCouponproduct: function (item) {
      sessionStorage.setItem('coupon_product', JSON.stringify(item))
      this.$router.push({
        path: '/couponproduct',
        query: {
          itemid: this.productDateils.itemid
        }
      })
    },
    getRecommentDatas: function () {
      var recommentUrl =
        this.$ajax.getRecommendByItemInfo_URL + '?item_base_id=' + this.$route.query.itemid
      var that = this
      that.$customRequestAjax(recommentUrl).then((res) => {
        if (res.data.code === 200) {
          that.productlist = res.data.itemlist
          that.productBannerList = res.data.bannerList
          that.productlist.map((item) => {
            item.product_detail = 1
          })
        }
      })
    },
    followFn: function (data) {
      this.follow = data
    },
    loadvideo: function () {
      var that = this
      setTimeout(function () {
        zymedia('#banner_video', {
          aspectRation: that.productDateils.img_path_width / that.productDateils.img_path_height,
          preload: 'auto',
          hideVideoControlsOnLoad: true
        })
      })
    },
    itemId: function () {
      window.scrollTo(0, 0)
      this.recCount = 0
      this.loading = true
      this.bannerList = []
      this.isActHandleBuy = 0
      this.getData()
    },
    preview(items, index, type) {
      var imgArr, newImgArr
      if (type == 'comment') {
        imgArr = [items.path1, items.path2, items.path3, items.path4, items.path5, items.path6]
        newImgArr = []
        imgArr.map((item) => {
          if (item && item != undefined) {
            newImgArr.push(item)
          }
        })
      } else if (type == 'banner') {
        newImgArr = this.bannerList
      } else if (type == 'description') {
        newImgArr = []
        this.productDateils.descriptions.map((item) => {
          if (item && item != undefined) {
            newImgArr.push(item.path)
          }
        })
      }
      ImagePreview({
        images: newImgArr,
        startPosition: index,
        closeOnPopstate: true
      })
    },
    playTab(num) {
      if (num == 0) {
        if (this.playShow) {
          if (this.icon == 'play') {
            document.querySelectorAll('.zy_media video')[0].play()
            this.icon = 'pause'
          } else {
            document.querySelectorAll('.zy_media video')[0].pause()
            this.icon = 'play'
          }
        }
        this.$nextTick(function () {
          this.playShow = true
          this.imgShow = false
        })
      } else if (num == 1) {
        document.querySelectorAll('.zy_media video')[0].pause()
        this.playShow = false
        this.imgShow = true
      }
    },
    posterDataFlow(poster) {
      var url = this.$ajax.toRedirect_URL + '?path=' + poster[this.posterIndex].posterurl
      var that = this
      that
        .$customRequestAjax(url, {
          responseType: 'blob'
        })
        .then((res) => {
          if (res.status === 200) {
            var blob = res.data
            if (blob.size > 0) {
              var reader = new FileReader()
              reader.readAsDataURL(blob) // 转换为base64，可以直接放入a标签href
              reader.onload = function (e) {
                that.posterUrlBase = e.currentTarget.result
                that.posterUrl.push(that.posterUrlBase)
                that.$dialog.close()
                that.$toast.clear()
                that.posterIndex = 0
                if (that.blindBoxImg) {
                  var url = that.$ajax.toRedirect_URL + '?path=' + that.blindBoxImg
                  that
                    .$customRequestAjax(url, {
                      responseType: 'blob'
                    })
                    .then((res) => {
                      if (res.status === 200) {
                        var blob = res.data
                        if (blob.size > 0) {
                          var reader = new FileReader()
                          reader.readAsDataURL(blob) // 转换为base64，可以直接放入a标签href
                          reader.onload = function (e) {
                            that.blindBoxImgBase = e.currentTarget.result
                            that.$dialog.close()
                            that.$toast.clear()
                            that.posterShow = true
                            that.$nextTick(function () {
                              that.posterImgHeight = that.$refs.poster.offsetWidth
                              setTimeout(() => {
                                that.createPoster()
                              })
                            })
                          }
                        } else {
                          that.posterShow = true
                          that.$nextTick(function () {
                            that.posterImgHeight = that.$refs.poster.offsetWidth
                            setTimeout(() => {
                              that.createPoster()
                            })
                          })
                        }
                      } else {
                        that.posterShow = true
                        that.$nextTick(function () {
                          that.posterImgHeight = that.$refs.poster.offsetWidth
                          setTimeout(() => {
                            that.createPoster()
                          })
                        })
                      }
                    })
                } else {
                  that.posterShow = true
                  that.$nextTick(function () {
                    that.posterImgHeight = that.$refs.poster.offsetWidth
                    setTimeout(() => {
                      that.createPoster()
                    })
                  })
                }
              }
            } else {
              that.posterUrl.push(require('../../assets/images/nopropic.png'))
              that.posterIndex++
              that.$dialog.close()
              that.$toast.clear()
              that.posterIndex = 0
            }
          }
        })
    },
    posterQrCode() {
      var url = this.$ajax.toRedirect_URL + '?path=' + this.productDateils.qrcode
      var that = this
      that
        .$customRequestAjax(url, {
          responseType: 'blob'
        })
        .then((res) => {
          if (res.status === 200) {
            var blob = res.data
            if (blob.size > 0) {
              var reader = new FileReader()
              reader.readAsDataURL(blob) // 转换为base64，可以直接放入a标签href
              reader.onload = function (e) {
                that.qrcode = e.currentTarget.result
                that.$dialog.close()
                that.$toast.clear()
              }
            } else {
              that.qrcode = require('../../assets/images/nopropic.png')
            }
          }
        })
    },
    scrollWatch: function () {
      let scrolled =
        parseInt(document.body.scrollTop) || parseInt(document.documentElement.scrollTop)
      let scrolledHeight = document.documentElement.scrollHeight - scrolled
      let clientHeight = scrolledHeight - document.documentElement.scrollHeight
      if (this.imgShow && clientHeight <= 0) {
        if (this.recCount == 0) {
          this.recCount = 1
          this.getRecommentDatas()
        }
      }
      // 586、1063分别为第二个和第三个锚点对应的距离
      var jump = document.querySelectorAll('.d_jump')
      if (jump[3] && scrolled >= jump[3].offsetTop - 84) {
        this.zIndex = false
        this.ceil = true
        this.navId = 3
      } else if (
        jump[3] &&
        scrolled < jump[3].offsetTop - 84 &&
        jump[2] &&
        scrolled >= jump[2].offsetTop - 84
      ) {
        if (this.recCount == 0) {
          this.recCount = 1
          this.getRecommentDatas()
        }
        this.zIndex = false
        this.ceil = true
        this.navId = 2
      } else if (
        jump[2] &&
        scrolled < jump[2].offsetTop - 84 &&
        jump[1] &&
        scrolled >= jump[1].offsetTop - 84
      ) {
        this.zIndex = false
        this.ceil = true
        this.navId = 1
      } else if (
        jump[1] &&
        scrolled < jump[1].offsetTop - 84 &&
        jump[0] &&
        scrolled >= jump[0].clientHeight / 4
      ) {
        this.zIndex = false
        this.ceil = true
        this.navId = 0
      } else {
        this.ceil = false
        var that = this
        setTimeout(function () {
          that.zIndex = true
        })
        this.navId = 0
      }
    },
    presell() {
      this.showPresale = false
      this.onConfirmClicked()
    },
    // 到货提醒
    AOGRemind: function () {
      var that = this
      if (that.pushmsgId.length) {
        requestSubscribeMessage(
          that.pushmsgId,
          function (res) {
            if (res && res.data.code == 200) {
              that.$dialog
                .alert({
                  title: '设置提醒成功',
                  message: '商品到货后将通过系统消息通知您',
                  className: 'percen_button_alert integral_button_alert text-align-center',
                  confirmButtonColor: '#FFFCFC',
                  confirmButtonText: '我知道了',
                  closeOnPopstate: false
                })
                .then(function () {
                  // on confirm
                })
            }
          },
          'detail',
          that.skuids
        )
      }
    },
    openPreview() {
      this.tempType = this.buyType
      this.changeSkuIndex = this.selectedSkuIndex
      this.$refs.skuPreview.showPreview(this.selectedSkuIndex)
      skufunc.selectedSkuHandle(this.selectedSkuIndex, this)
    },
    closePreview() {
      this.buyType = this.tempType
      this.tempType = null
    },
    changePreview(index) {
      this.changeSkuIndex = index
      skufunc.selectedSkuHandle(index, this)
    },
    previewAddToCart() {
      this.buyType = 0
      skufunc.onConfirmClicked_productdetail(this)
    },
    previewBuyNow() {
      this.buyType = 1
      skufunc.onConfirmClicked_productdetail(this)
    },
    buy(type) {
      /**618引流裂变活动-临时调整 */
      if (this.productDateils.isylGoods == 1 && !this.isActHandleBuy) {
        this.isActHandleBuy = 1
        this.recCount = 0
        this.loading = true
        this.bannerList = []
        this.getData(() => {
          this.buy(type)
        })
        return
      }
      /**618引流裂变活动-临时调整 */
      if (
        this.productDateils.privatePopup &&
        Object.keys(this.productDateils.privatePopup).length &&
        this.isActHandleBuy &&
        !this.actQrcodeShow
      ) {
        this.actQrcodeShow = true
        return
      }
      this.actQrcodeShow = false
      this.isActHandleBuy = 0
      if (this.pathfrom == 'subwayadv') {
        this.$clickburiedPoint({
          data: {
            buttonCode: `metro-buy-${this.productDateils.itemid}`
          },
          callback: () => {
            console.log('购买', `metro-buy-${this.productDateils.itemid}`)
          }
        })
      }
      skufunc.openSku_productdetail(type, this)
    },
    shopcart(type) {
      skufunc.openSku_productdetail(type, this)
    },
    checkedSku(skuValue) {
      skufunc.checkedSku_productdetail(skuValue, this)
    },
    onConfirmClicked() {
      skufunc.onConfirmClicked_productdetail(this)
    },
    // 客服
    keFu: function () {
      var k =
        'card_title=' +
        this.productDateils.name +
        '&card_url=' +
        encodeURIComponent(window.location.href) +
        '&card_note=' +
        this.productDateils.sales_bottom_price +
        '&card_picture=' +
        encodeURIComponent(this.productDateils.img_main_path)
      var Func = () => {
        qrcodeKefuLimits(2).then(() => {
          kefu(null, k)
        })
      }
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$store.commit('PATH_VALUE', JSON.stringify({ itemid: this.productDateils.itemid }))
          this.$router.push({
            path: '/login',
            query: {
              routeval: 'productdetail'
            }
          })
        } else {
          Func()
        }
      } else {
        Func()
      }
    },
    gocart() {
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$store.commit('PATH_VALUE', JSON.stringify({ itemid: this.productDateils.itemid }))
          this.$router.push({
            path: '/login',
            query: {
              routeval: 'productdetail'
            }
          })
        } else {
          this.$router.push('/cart')
        }
      } else {
        this.$router.push('/cart')
      }
    },
    love() {
      var that = this
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$store.commit('PATH_VALUE', JSON.stringify({ itemid: this.productDateils.itemid }))
          this.$router.push({
            path: '/login',
            query: {
              routeval: 'productdetail'
            }
          })
        } else {
          f()
        }
      } else {
        f()
      }
      function f() {
        that.islove = !that.islove
        var urlCollAdd = that.$ajax.addCollection_URL
        var urlCollCancel = that.$ajax.cancelCollection_URL
        var data = {
          itemids: that.productDateils.itemid
        }
        if (that.islove === true) {
          that.$customRequestAjax.post(urlCollAdd, data).then((res) => {
            if (res.data.code === 200) {
              that.dataCollection('collectProduct')
              var fs = require('../../assets/images/succ.png')
              that.$toast({
                message: '收藏成功',
                icon: fs
              })
            }
          })
        } else {
          that.$customRequestAjax.post(urlCollCancel, data).then((res) => {
            if (res.data.code === 200) {
              that.$toast('取消收藏')
            }
          })
        }
      }
    },
    posterFn() {
      this.$nextTick(() => {
        let videoContexts = document.querySelectorAll('.zy_media video')
        let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        videoContexts.forEach((videoContext) => {
          if (isiOS) {
            videoContext.setAttribute('x5-playsinline', 'x5-playsinline')
            videoContext.setAttribute('playsinline', 'playsinline')
            videoContext.setAttribute('webkit-playsinline', 'webkit-playsinline')
          }
          if (!isiOS) {
            let imgElement = document.createElement('img')
            imgElement.style.display = 'block'
            imgElement.style.width = '100%'
            imgElement.src = this.productDateils.video_img_url
            videoContext.parentNode.style.display = 'block'
            videoContext.parentNode.append(imgElement)
            videoContext.addEventListener('play', () => {
              imgElement.style.display = 'none'
              videoContext.style.display = 'block'
              videoContext.parentNode.style.display = 'block'
            })
            videoContext.addEventListener('pause', () => {
              imgElement.style.display = 'block'
              videoContext.style.display = 'none'
              // videoContext.parentNode.style.display = "none";
            })
            videoContext.pause()
            videoContext.dispose()
            videoContext.reset()
          }
        })
      })
      this.posterIndex = 0
      if (!this.posterDataLoading) {
        this.$toast.loading({
          mask: true,
          message: '加载中...',
          duration: 0
        })
        this.posterDataFlow(this.productDateils.poster)
      } else {
        this.posterShow = true
      }
      this.posterDataLoading = true
    },
    posterClick(e, items, idx) {
      if (this.posterIndex != idx) {
        this.posterIndex = idx
      }
    },
    createPoster: function () {
      var that = this
      var type = 'image/png'
      setTimeout(function () {
        var box = document.getElementById('posterbox')
        var canvas = document.createElement('canvas')
        box.appendChild(canvas)
        var w = that.$refs.poster.clientWidth
        var h = that.$refs.poster.clientHeight
        // 将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了
        canvas.width = w * 2
        canvas.height = h * 2
        canvas.style.width = w + 'px'
        canvas.style.height = h + 'px'
        canvas.style.backgroundColor = '#FFFFFF'
        // 可以按照自己的需求，对context的参数修改,translate指的是偏移量
        var ctx = canvas.getContext('2d')
        let bili = (document.documentElement.clientWidth / 375) * 2
        var blindBoxImg = document.getElementById('blindBoxImg') || null,
          blindBoxImgHeight = 0,
          fullNFreeN = document.getElementById('fullNFreeN') || null,
          fullNFreeNHeight = 0
        if (blindBoxImg) blindBoxImgHeight = blindBoxImg.clientHeight
        if (fullNFreeN) fullNFreeNHeight = fullNFreeN.clientHeight

        const grd = ctx.createLinearGradient(0, 0, w * bili, h * bili) // 背景色
        grd.addColorStop(0, '#FFFFFF')
        grd.addColorStop(1, '#FFFFFF')
        ctx.fillStyle = grd
        ctx.fillRect(0, 0, w * bili, h * bili)
        if (that.productDateils.name && that.productDateils.name.length > 13) {
          ctx.fillStyle = '#111' // 文字颜色：111
          ctx.textAlign = 'left' // 文字居中
          ctx.font = '26px Arial' // 文字字号
          ctx.fillText(
            that.productDateils.name.substr(0, 13),
            25 * bili,
            (431 + blindBoxImgHeight) * bili
          )
          if (that.productDateils.name.length > 13) {
            ctx.fillStyle = '#111' // 文字颜色：111
            ctx.textAlign = 'left' // 文字居中
            ctx.font = '26px Arial' // 文字字号
            if (
              that.productDateils.name.length > 21 &&
              that.productDateils.name.substr(13, 8).length >= 8
            ) {
              ctx.fillText(
                that.productDateils.name.substr(13, 8) + '...',
                25 * bili,
                (451 + blindBoxImgHeight) * bili
              )
            } else {
              ctx.fillText(
                that.productDateils.name.substr(13, 8),
                25 * bili,
                (451 + blindBoxImgHeight) * bili
              )
            }
          } else {
            ctx.fillStyle = '#111' // 文字颜色：111
            ctx.textAlign = 'left' // 文字居中
            ctx.font = '26px Arial' // 文字字号
            ctx.fillText(
              that.productDateils.name.substr(13, 13),
              25 * bili,
              (451 + blindBoxImgHeight) * bili
            )
          }
          if (that.productDateils.tags.length) {
            var num = 98
            for (var i = 0; i < that.productDateils.tags.length; i++) {
              ctx.fillStyle = '#888888' // 文字颜色：111
              ctx.textAlign = 'left' // 文字居中
              ctx.font = '22px Arial' // 文字字号
              ctx.fillText(
                that.productDateils.tags[i],
                25 * bili + num * i,
                (469 + blindBoxImgHeight) * bili
              )
            }
          }
        } else {
          ctx.fillStyle = '#111' // 文字颜色：111
          ctx.textAlign = 'left' // 文字居中
          ctx.font = '26px Arial' // 文字字号
          ctx.fillText(that.productDateils.name, 25 * bili, (431 + blindBoxImgHeight) * bili)
          if (that.productDateils.tags.length) {
            var num = 98
            for (var i = 0; i < that.productDateils.tags.length; i++) {
              ctx.fillStyle = '#888888' // 文字颜色：111
              ctx.textAlign = 'left' // 文字居中
              ctx.font = '22px Arial' // 文字字号
              ctx.fillText(
                that.productDateils.tags[i],
                25 * bili + num * i,
                (449 + blindBoxImgHeight) * bili
              )
            }
          }
        }

        ctx.fillStyle = '#FC0324' // 文字颜色：828282
        ctx.font = '30px Arial' // 文字字号
        ctx.fillText('¥', 21 * bili, (509 + blindBoxImgHeight) * bili)

        ctx.fillStyle = '#FC0324' // 文字颜色：828282
        ctx.font = '36px Arial' // 文字字号
        ctx.fillText(
          parseFloat(that.post_sale_price).toFixed(2),
          34 * bili,
          (508 + blindBoxImgHeight) * bili
        )

        var len = parseInt(that.post_sale_price).toString().length + 4 * bili

        ctx.fillStyle = '#828282'
        ctx.fillRect(105 * bili, (503 + blindBoxImgHeight) * bili, len * 10, 1)

        ctx.fillStyle = '#828282' // 文字颜色：828282
        ctx.font = '26px Arial' // 文字字号
        ctx.fillText(
          '¥' + parseFloat(that.post_cost_price).toFixed(2),
          100 * bili,
          (508 + blindBoxImgHeight) * bili
        )

        if (
          that.productDateils.sku_rule_list &&
          that.productDateils.sku_rule_list.length &&
          that.productDateils.sku_rule_list[0].actType == 3
        ) {
          // 在价格上方增加一行文字，背景红色，文字白色，字体11px
          const labelText = that.productDateils.sku_rule_list[0].actLabel // 可根据实际需求修改
          const labelFontSize = 11 * bili
          const labelWidth = ctx.measureText(labelText).width + 5 * bili
          const labelHeight = 19 * bili
          const labelX = 25 * bili
          const labelY = (473 + blindBoxImgHeight) * bili

          // 绘制红色背景
          ctx.fillStyle = '#FC0324'
          ctx.save()
          ctx.beginPath()
          const radius = 12 * bili // 圆角半径，可根据实际需求调整
          ctx.moveTo(labelX + radius, labelY)
          ctx.lineTo(labelX + labelWidth - radius, labelY)
          ctx.quadraticCurveTo(labelX + labelWidth, labelY, labelX + labelWidth, labelY + radius)
          ctx.lineTo(labelX + labelWidth, labelY + labelHeight - radius)
          ctx.quadraticCurveTo(
            labelX + labelWidth,
            labelY + labelHeight,
            labelX + labelWidth - radius,
            labelY + labelHeight
          )
          ctx.lineTo(labelX + radius, labelY + labelHeight)
          ctx.quadraticCurveTo(labelX, labelY + labelHeight, labelX, labelY + labelHeight - radius)
          ctx.lineTo(labelX, labelY + radius)
          ctx.quadraticCurveTo(labelX, labelY, labelX + radius, labelY)
          ctx.closePath()
          ctx.fill()
          ctx.restore()
          // 绘制白色文字
          ctx.font = `${labelFontSize}px Arial`
          ctx.fillStyle = '#fff'
          ctx.textBaseline = 'middle'
          ctx.fillText(labelText, labelX + 10 * bili, labelY + labelHeight / 2)
        }

        ctx.fillStyle = '#B0B0B0' // 文字颜色：B0B0B0
        ctx.font = '20px Arial' // 文字字号
        ctx.fillText('长按二维码购买', 215 * bili, (505 + blindBoxImgHeight) * bili)
        // 圆形头像框
        var posterlogo = document.getElementById('posterlogo')
        var posterurl = document.getElementsByClassName('posterurl')[0]
        var qrcode = document.getElementById('qrcode')
        var posterlogoewm = document.getElementById('posterlogoewm')
        ctx.drawImage(posterlogo, 5 * bili, 10 * bili, 290 * bili, 90 * bili)
        ctx.drawImage(posterurl, 5 * bili, 100 * bili, 290 * bili, 290 * bili)
        if (fullNFreeN)
          ctx.drawImage(
            fullNFreeN,
            5 * bili,
            (390 - fullNFreeNHeight) * bili,
            290 * bili,
            fullNFreeNHeight * bili
          )
        if (blindBoxImg)
          ctx.drawImage(blindBoxImg, 5 * bili, 390 * bili, 290 * bili, blindBoxImgHeight * bili)
        ctx.drawImage(qrcode, 210 * bili, (415 + blindBoxImgHeight) * bili, 80 * bili, 80 * bili)
        ctx.drawImage(
          posterlogoewm,
          240 * bili,
          (445 + blindBoxImgHeight) * bili,
          20 * bili,
          20 * bili
        )
        that.postImgData = canvas.toDataURL(type)
        canvas.style.display = 'none'
      }, 100)
    },
    posterlogoFn: function () {
      console.log('posterlogoFn')
    },
    posterurlFn: function () {
      console.log('posterurlFn')
    },
    qrcodeFn: function () {
      console.log('qrcodeFn')
    },
    posterlogoewmFn: function () {
      console.log('posterlogoewmFn')
    },
    close() {
      this.posterShow = false
    },
    share() {
      if (this.pathfrom == 'subwayadv') {
        this.$clickburiedPoint({
          data: {
            buttonCode: `metro-share-${this.productDateils.itemid}`
          }
        })
      }
      if (!this.isShare) {
        this.$toast('关注【创客村】公众号，惊喜享不停')
        return
      }
      this.showshare = true
      this.dataCollection('shareStepOne')
    },
    // 埋点
    dataCollection(dataType) {
      let params = {
        productId_var: this.productInfo.iteminfo.itemid,
        productName_var: this.productInfo.iteminfo.name,
        firstCat_var: this.productInfo.iteminfo.brand,
        productType_var: '',
        productFormat_var: this.skuId
      }

      if (dataType == 'shareStepOne') {
        delete params.productFormat_var
      }
      gio('track', dataType, params)
    },
    goCommentList() {
      this.$router.push({
        path: '/commentList',
        query: {
          ...this.$route.query,
          itemid: this.productDateils.itemid,
          showbuy: this.newpersondetail == 1 || this.groupbuyid ? '0' : ''
        }
      })
    },
    // 购买数量变化
    stepChange(value) {
      if (this.depositObj.isdeposit) {
        this.depositObj.totalPrice = parseFloat(value * this.depositObj.depositmoney).toFixed(2)
      }
    },
    navClick(id) {
      this.navId = id
      // 用 class="d_jump" 添加锚点
      let jump = document.querySelectorAll('.d_jump')
      let total = jump[id].offsetTop - 84
      let distance =
        parseInt(document.body.scrollTop) ||
        parseInt(document.documentElement.scrollTop) ||
        parseInt(window.pageYOffset)
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 60
      if (total > distance) {
        smoothDown()
      } else {
        let newTotal = distance - total
        step = newTotal / 60
        smoothUp()
      }
      function smoothDown() {
        if (distance < total) {
          distance += step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          // window.pageYOffset = distance
          setTimeout(smoothDown, 10)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
          // window.pageYOffset = total
        }
      }
      function smoothUp() {
        if (distance > total) {
          distance -= step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          // window.pageYOffset = distance
          setTimeout(smoothUp, 10)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
          // window.pageYOffset = total
        }
      }
    },
    commentDetail(items) {
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$store.commit(
            'PATH_VALUE',
            JSON.stringify({ ...this.$route.query, itemid: this.productDateils.itemid })
          )
          this.$router.push({
            path: '/login',
            query: {
              routeval: 'productdetail'
            }
          })
        } else {
          this.$router.push({
            path: '/commentDetail',
            query: {
              ...this.$route.query,
              commentid: items.id,
              showbuy: this.newpersondetail == 1 || this.groupbuyid ? '0' : ''
            }
          })
        }
      } else {
        this.$router.push({
          path: '/commentDetail',
          query: {
            ...this.$route.query,
            commentid: items.id,
            showbuy: this.newpersondetail == 1 || this.groupbuyid ? '0' : ''
          }
        })
      }
    },
    commentLike(items) {
      var that = this
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$store.commit(
            'PATH_VALUE',
            JSON.stringify({
              ...this.$route.query,
              itemid: this.productDateils.itemid
            })
          )
          this.$router.push({
            path: '/login',
            query: {
              routeval: 'productdetail'
            }
          })
        } else {
          f()
        }
      } else {
        f()
      }
      function f() {
        var url = that.$ajax.addCommentLike_URL
        var data = {}
        if (items.islike == 0) {
          data = {
            id: items.id,
            type: 1
          }
        } else if (items.islike == 1) {
          data = {
            id: items.id,
            type: 2
          }
        }
        that.$customRequestAjax.post(url, data).then((res) => {
          if (res.data.code === 200) {
            if (items.islike == 0) {
              items.islike = 1
              items.like_nums = parseInt(items.like_nums) + 1
            } else if (items.islike == 1) {
              items.islike = 0
              items.like_nums = parseInt(items.like_nums) - 1
            }
          }
        })
      }
    },
    productBannerFn(items, name) {
      var ad_type = items.ad_type + ''
      switch (ad_type) {
        case '1': // 跳转链接
          var actid = parseInt(items.activityid) ? '?actid=' + items.activityid : ''
          window.location.href = items.ad_target + actid
          // window.location.href = 'http://192.168.2.187:8081/static/wx/html/group/collagelist.html'
          break
        case '2': // 商品分类
          if (items.ad_target == 0) {
            this.$router.push({
              path: '/classification',
              query: {
                type: 'inside'
              }
            })
          } else {
            this.$store.commit('CATEGORY_ID', items.father_class_id)
            this.$store.commit('CATEGORY_SONID', items.ad_target)
            this.$router.push({
              path: '/productCategory',
              title: encodeURIComponent(items.father_class_name)
            })
          }
          break
        case '3':
          if (name) {
            this.$clickburiedPoint({
              url: 'ckysdatacenter/itemclick/save',
              data: {
                itemid: items.ad_target,
                scenepoint: 'PRODDETAIL',
                scenedesc: name
              }
            })
          }
          this.$router.replace({
            path: 'productdetail',
            query: {
              itemid: items.ad_target
            }
          })
          this.itemId()
          break
        case '4':
          this.$router.push('/')
          break
        case '5':
          this.$router.push('/')
          break
      }
      window.scrollTo(0, 0)
    },
    homeClick: function () {
      var arg = isApp()
      if (this.pathfrom == 'subwayadv') {
        this.$clickburiedPoint({
          data: {
            buttonCode: `metro-index-${this.productDateils.itemid}`
          },
          callback: () => {
            this.$app.goIndex()
          }
        })
      } else {
        this.$app.goIndex()
      }
    },
    goUrl: function (url) {
      if (typeof url == 'string' && url != '') {
        window.location.href = url
      } else {
        window.location.href = this.productInfo.showcouponurl
      }
    },
    // 预售付定金
    payDeposit() {
      if (this.depositObj.actstatus == 0) {
        this.$toast('活动未开始')
      } else if (this.depositObj.actstatus == 1) {
        let skuData, skuids, buynum, url, params, totalPrice

        skuData = this.$refs.sku.getSkuData()
        skuids = skuData.selectedSkuComb.id
        buynum = skuData.selectedNum
        totalPrice = this.depositObj.totalPrice
        url = this.$ajax.addPreItemOrder_URL
        params = {
          skuids: skuids,
          buynum: buynum
        }
        this.$customRequestAjax.post(url, params).then((res) => {
          if (res.data.code === 200) {
            this.$router.push({
              path: '/pay',
              query: {
                id: res.data.djorderid,
                money: totalPrice,
                isdeposit: 1
              }
            })
          } else {
            this.$toast(res.data.msg)
          }
        })
      } else {
        this.$toast('活动已结束')
      }
    },
    goProblemDetails(item) {
      this.$router.push({
        path: '/problemDetails',
        query: {
          ...this.$route.query,
          questionid: item.questionid,
          itemid: this.productDateils.itemid,
          questionName: item.question,
          showbuy: this.newpersondetail == 1 || this.groupbuyid ? '0' : ''
        }
      })
    },
    popularScienceSwitchHandle(){
      this.popularScienceShow = !this.popularScienceShow
      this.$nextTick(()=>{
        if (this.popularScienceShow) this.popularScienceScrollHandle(this.$refs.popularScienceBoxRef)
      })
    },
    popularScienceScrollHandle(e){
      this.$nextTick(()=>{
        console.log(e.target ? e.target.scrollTop : e.scrollTop)
        const scrollTop = e.target ? e.target.scrollTop : e.scrollTop
        // 让scrollTop越大，opacity越小，最大为1，最小为0
        const maxScroll = 406
        let opacity = 1 - (scrollTop / (maxScroll || 1))
        if (opacity < 0) opacity = 0
        if (opacity > 1) opacity = 1
        this.popularScienceOpacity = opacity
      })
    }
  }
}
</script>

<style scoped lang="scss">
.manualbox {
  width: 100%;
  height: 0.66rem;
  .manual {
    position: relative;
  }
}
.slide_cl_xcx {
  position: absolute;
  max-width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border-radius: 0.06rem;
  z-index: 10;
}
.liveWrap {
  z-index: 1000;
  position: fixed;
  right: 0.1rem;
  bottom: 1.48rem;
  width: 1.73rem;
  height: 1.59rem;
  border-radius: 0.06rem;
  &.live {
    right: 0.2rem;
    top: 1.1rem;
    bottom: auto;
    width: 0.45rem;
    height: 0.6rem;
    .mainImg {
      width: 100%;
      height: 100%;
    }
  }
  .titleWrap {
    z-index: 10;
    position: absolute;
    top: 0.1rem;
    left: 0.08rem;
    display: flex;
    align-items: center;
    background: #ffe9e9;
    line-height: 0.16rem;
    font-size: 0.11rem;
    padding-right: 0.08rem;
    border-radius: 0.08rem;
    .titleImg {
      width: 0.16rem;
      height: 0.16rem;
      margin-right: 0.02rem;
    }
  }
  .closeWrap {
    z-index: 10005;
    position: absolute;
    top: 0;
    right: 0;
    width: 0.28rem;
    height: 0.28rem;
    .close-btn {
      position: absolute;
      top: 0.1rem;
      right: 0.1rem;
      width: 0.16rem;
      height: 0.16rem;
    }
  }
  .mainImg {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 0.06rem;
    img {
      position: absolute;
      max-width: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      border-radius: 0.06rem;
    }
  }
}
.recommend {
  position: fixed;
  left: 0;
  top: 77%;
  background: #ffd9d9;
  font-weight: bold;
  padding: 0.04rem 0.08rem;
  border-radius: 0 0.13rem 0.13rem 0;
}
.container {
  background: #f5f5f5;
  padding-bottom: 0.49rem;
  display: flex;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -moz-flex-direction: column;
  -o-flex-direction: column;
  /*overflow: hidden;*/
  height: 100%;
  flex: 0;
  -webkit-flex: 0;
  -moz-flex: 0;
  -ms-flex: 0;
  -o-flex: 0;
  header {
    height: 0.4rem;
    background: #fff;
    opacity: 0;
    transition: all 0.45s;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 10;
    &.ceiling {
      opacity: 1;
    }
    ul {
      display: flex;
      display: -webkit-flex;
      display: -o-flex;
      display: -moz-flex;
      display: -ms-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      -o-justify-content: space-between;
      -moz-justify-content: space-between;
      -ms-justify-content: space-between;
      padding: 0 0.9rem;
      height: 0.37rem;
      li {
        font-size: 0.14rem;
        font-weight: 400;
        color: rgba(41, 41, 41, 1);
        line-height: 0.37rem;
        &.colorLis {
          font-weight: 500;
        }
        &.colorLis:after {
          content: '';
          display: block;
          width: 86%;
          height: 0.025rem;
          background: linear-gradient(90deg, rgba(252, 3, 36, 1), rgba(255, 81, 104, 1));
          background: -webkit-linear-gradient(90deg, rgba(252, 3, 36, 1), rgba(255, 81, 104, 1));
          background: -moz-linear-gradient(90deg, rgba(252, 3, 36, 1), rgba(255, 81, 104, 1));
          background: -ms-linear-gradient(90deg, rgba(252, 3, 36, 1), rgba(255, 81, 104, 1));
          background: -o-linear-gradient(90deg, rgba(252, 3, 36, 1), rgba(255, 81, 104, 1));
          position: relative;
          bottom: 0.065rem;
          margin: 0 7%;
          /*border-bottom: 0.02rem solid #FC0324;*/
        }
      }
    }
  }
  #cup {
    background: #f5f5f5;
    flex: 1;
    -webkit-flex: 1;
    -moz-flex: 1;
    -ms-flex: 1;
    -o-flex: 1;
    /*overflow-y: auto;*/
    /*margin-top: -0.4rem;*/
    margin-bottom: 0.47rem;
    .box-m {
      background: #ffffff;
      border-radius: 0.1rem;
      margin: 0.1rem 0.11rem;
      padding: 0.12rem 0.15rem 0.15rem;
      position: relative;
    }
  }
  .maininfo {
    /*padding-bottom: .15rem;*/
    font-size: 0;
    .swiper-container {
      .swiper-wrapper {
        margin: 0;
        padding: 0;
        /*height: 100%;*/
        &.swiper_banner {
          position: absolute;
          left: 0px;
          top: 0px;
        }
        .swiper-slide {
          padding: 0;
          margin: 0;
          position: relative;
          background: #f5f5f5;
          img {
            width: 100%;
            display: block;
            border: 0;
            object-fit: contain;
            /*position: absolute;
              top: 50%;
              transform: translateY(-50%);*/
          }
        }
      }
      #proSwiperPagination {
        font-size: 0.12rem;
        width: 0.34rem;
        color: #fff;
        position: absolute;
        right: 0.11rem;
        left: auto;
        /*<!--margin-left: -.17rem;-->*/
        bottom: 0.15rem;
        .pro_page {
          /*position: relative;*/
          background: url(../../assets/images/pagebg.png) no-repeat center;
          background-size: 100% 100%;
          padding: 0 0.0385rem 0.01rem;
          white-space: nowrap;
          .swiper-pagination-current {
            width: 0.12rem;
            border-radius: 0.12rem;
            /*position: absolute;*/
            /*top: 0;*/
            /*left: 0;*/
            /*background: #757575;*/
          }
          .swiper-pagination-split {
            margin-left: 0.02rem;
            margin-right: 0.02rem;
            /*position: absolute;*/
            /*top: 0;*/
            left: 0.08rem;
            height: 0.12rem;
            line-height: 0.12rem;
            margin-top: 0.01rem;
            /*background: #757575;*/
            text-align: center;
            font-size: 0.12rem;
            transform: scale(0.8);
          }
          .swiper-pagination-total {
            width: 0.12rem;
            border-radius: 0.12rem;
            /*position: absolute;*/
            /*top: 0;*/
            left: 0.14rem;
            /*background: #757575;*/
          }
        }
      }
      .playTab {
        /*font-size: 0;*/
        text-align: center;
        position: absolute;
        bottom: 0.15rem;
        z-index: 1;
        left: 0;
        right: 0;
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -o-flex;
        display: -ms-flex;
        justify-content: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -o-justify-content: center;
        -ms-justify-content: center;
        span {
          width: 0.47rem;
          height: 0.22rem;
          text-align: center;
          background: rgba(249, 249, 249, 1);
          border-radius: 0.11rem;
          border: 0.01rem solid rgba(224, 225, 224, 1);
          font-size: 0.11rem;
          font-weight: 400;
          color: rgba(53, 53, 53, 1);
          display: flex;
          display: -webkit-flex;
          display: -moz-flex;
          display: -o-flex;
          display: -ms-flex;
          align-items: center;
          -webkit-align-items: center;
          -moz-align-items: center;
          -o-align-items: center;
          -ms-align-items: center;
          justify-content: center;
          -webkit-justify-content: center;
          -moz-justify-content: center;
          -o-justify-content: center;
          -ms-justify-content: center;
          b {
            font-weight: 400;
            transform: scale(0.98);
            -webkit-transform: scale(0.98);
            -moz-transform: scale(0.98);
            -ms-transform: scale(0.98);
            -o-transform: scale(0.98);
          }
          &:first-of-type {
            margin-right: 0.045rem;
          }
          &:last-of-type {
            margin-left: 0.045rem;
          }
        }
      }
    }
    .pro_price {
      /*margin-top: .15rem;*/
      /*margin-left: .15rem;*/
      position: relative;
      .xian {
        color: #fc0324;
        font-size: 0.14rem;
        text-align: left;
        display: flex;
        /*width: 60%;*/
        white-space: nowrap;
        .smallprice {
          font-size: 0;
          display: flex;
          align-items: flex-end;
        }
        b {
          font-size: 0.23rem;
          line-height: 0.23rem;
          font-weight: 500;
        }
        sub {
          font-size: 0.14rem;
          line-height: 0.15rem;
          font-weight: bold;
          vertical-align: baseline;
        }
        sup {
          font-size: 0.14rem;
          vertical-align: baseline;
          line-height: 0.15rem;
          font-weight: 500;
        }
        .bigprice {
          font-size: 0;
          b {
            font-size: 0.23rem;
            line-height: 0.23rem;
            font-weight: 500;
          }
        }
      }
      .tags {
        color: #ffffff;
        font-size: 0.13rem;
        height: 0.22rem;
        line-height: 0.22rem;
        background: linear-gradient(270deg, #f73864 0%, #fc0324 100%);
        padding: 0 0.12rem;
        border-radius: 0.11rem;
        position: relative;
        top: -0.02rem;
        white-space: normal;
        margin-left: 0.08rem;
        margin-top: 0.07rem;
      }
      .limit {
        /*border-radius: 0.11rem;*/
        margin: 0;
        margin-left: 0.04rem;
      }
      .yuan {
        color: #979797;
        text-align: left;
        font-size: 0.12rem;
        text-decoration: line-through;
        margin-left: 0.05rem;
        display: flex;
      }
      .directReduction {
        display: inline-block;
        color: #ffffff;
        background: #fc344f;
        font-size: 0.12rem;
        border-radius: 0.04rem;
        padding: 0.02rem 0.04rem;
        margin-top: 0.03rem;
        margin-bottom: 0.02rem;
      }
    }
    .pro_tit {
      font-size: 0.16rem;
      line-height: 0.24rem;
      color: #292929;
      text-align: left;
      margin-top: 0.12rem;
      font-weight: bold;
      img {
        width: 0.16rem;
        display: inline-block;
        vertical-align: middle;
        margin-left: 0.02rem;
      }
    }
    .limit {
      color: #ffffff;
      font-size: 0.12rem;
      height: 0.22rem;
      line-height: 0.18rem;
      background: linear-gradient(270deg, #f73864 0%, #fc0324 100%);
      padding: 0.02rem 0.08rem;
      margin: 0.07rem 0 0;
      white-space: nowrap;
      display: inline-block;
      border-radius: 0.11rem;
    }
    .depositWrap {
      height: 0.58rem;
      background: #fc0324;
      border-radius: 0.1rem 0.1rem 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.15rem;
      color: #fff;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      padding: 0 0.1rem;
      &.dai {
        background: linear-gradient(97deg, #ffcaca 0%, #ffffff 100%);
        border-radius: 0.04rem;
        color: #fc0324;
        height: 0.38rem;
        .pro_price {
          margin-left: 0;
          margin-top: 0.07rem;
          .smallprice {
            line-height: 0.17rem;
          }
          .xian {
            b {
              font-size: 0.17rem;
              line-height: 0.17rem;
            }
          }
          .yuan {
            font-size: 0.11rem;
            margin-left: 0.06rem;
            margin-top: -0.02rem;
          }
        }
        .endTime {
          display: flex;
          align-items: center;
          font-size: 0.13rem;
          .van-count-down {
            font-size: 0;
            margin-left: 0.06rem;
          }
          .colon {
            display: inline-block;
            margin: 0 0.01rem;
            color: #fc0324;
            font-size: 0.13rem;
          }
          .timeData {
            display: inline-block;
            min-width: 0.16rem;
            height: 0.16rem;
            line-height: 0.16rem;
            color: #fff;
            font-size: 0.1rem;
            text-align: center;
            background-color: #fc0324;
            border-radius: 0.04rem;
            padding: 0 0.015rem;
          }
        }
      }
      &.fullMinus {
        position: static;
        height: 0.67rem;
        background: #000000;
        color: #ffffff;
        padding: 0.1rem 0.15rem 0.1rem 0.26rem;
        border-radius: 0;
        .van-tag--medium {
          font-weight: 600;
        }
        .pro_price {
          margin-left: 0;
          margin-top: 0.07rem;
          .smallprice {
            line-height: 0.17rem;
          }
          .xian {
            color: #ffffff;
            sub,
            sup {
              font-size: 0.14rem;
            }
            b {
              font-size: 0.23rem;
              line-height: 0.2rem;
            }
          }
          .yuan {
            font-size: 0.12rem;
            color: rgba(255, 255, 255, 0.75);
            margin-left: 0.06rem;
            margin-top: 0;
            line-height: 0.15rem;
            span {
              line-height: 0.12rem;
            }
          }
        }
        div > p {
          text-align: center;
          font-size: 0.22rem;
          font-weight: 600;
          color: #ffffff;
        }
        .endTime {
          .van-count-down {
            font-size: 0.13rem;
            color: #ffffff;
            margin-left: 0;
          }
        }
      }
      .label {
        line-height: 0.2rem;
      }
      .integer {
        font-size: 0.24rem;
      }
      .oldPrice {
        font-size: 0.12rem;
      }
    }
    .productNameWrap {
      font-size: 0.16rem;
      font-weight: bold;
      color: #292929;
      margin-top: 0.58rem;
    }
  }

  .noactdesc {
    line-height: 0.18rem;
    background: rgba(0, 0, 0, 0.3);
    color: #ffffff;
    z-index: 1;
    padding: 0.06rem 0.19rem;
    border-radius: 0 0 0.1rem 0.1rem;
  }
  .manual {
    width: 100%;
    img {
      width: 100%;
      padding: 0.12rem 0.11rem 0.1rem;
    }
  }
  .btn-1 {
    margin: 0 0.25rem;
    button {
      background: #ffffff;
      border-width: 0;
      outline: none;
      position: relative;
      margin: 0;
      margin-top: 0.17rem;
      img {
        width: 0.14rem;
        height: 0.14rem;
        margin-right: 0.08rem;
      }
      color: #909090;
    }
  }
  .pro_certifical {
    background: #fffbdd !important;
    color: #fb6e38;
    padding-top: 0.05rem !important;
    margin-bottom: -5% !important;
    border-radius: 0.1rem 0.1rem 0 0 !important;
  }
  .pro_actinfo {
    /*border-top: solid .1rem #F5F5F5;*/
    background: #fff;
    .headers {
      overflow: hidden;
      /*height: .44rem;*/
      /*line-height: .44rem;*/
      position: relative;
      line-height: 0.24rem;
      .tag {
        width: 0.36rem;
        height: 0.17rem;
        display: inline-block;
        color: #909090;
        font-size: 0.13rem;
        border-radius: 0.07rem;
        float: left;
        margin-right: 0.2rem;
        font-weight: bold;
      }
      .title {
        /*margin-right: 0.1rem;*/
        line-height: 0.24rem;
        font-size: 0.13rem;
        margin-right: 0.23rem;
        color: #292929;
        /*float: left;*/
        &.act {
          margin-right: 0;
          .msgitem {
            margin-right: 0.23rem;
          }
          .group {
            margin-right: 0;
          }
        }
        .msgitem {
          .van-tag {
            font-size: 0.1rem;
            padding: 0 0.02rem;
          }
        }
      }
      &.pro_arg .van-icon {
        top: 0.05rem;
      }
      img {
        float: right;
        width: 0.18rem;
      }
      .num {
        font-size: 0.12rem;
        color: #999;
      }
    }
    .con {
      position: relative;
      padding-left: 0.47rem;
      padding-top: 0.05rem;
      font-size: 0.14rem;
      .title {
        width: 100%;
        font-size: 0.12rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
        color: #383333;
        .shortdesc {
          float: right;
          width: 1.02rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .title-multiple {
      position: absolute;
      top: 0;
      right: 0.11rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.14rem;
    }
    &.getcoupon_info {
      /*padding-left: 0.06rem;*/
      /*padding-right: 0.11rem;*/
      margin-right: -0.15rem;
      &.getcoupon_info_border {
        bottom: 0;
        /*border-bottom: solid .1rem #F5F5F5;*/
      }
      .headers {
        padding-top: 0.12rem;
        height: auto;
        line-height: normal;
        .big12 {
          font-size: 0.12rem;
          border-radius: 0.04rem;
          background: #ffe6e6;
          margin-right: 0.08rem;
        }
      }
      .getcoupon {
        background: linear-gradient(270deg, #f73864 0%, #fc0324 100%);
        padding: 0.02rem 0.08rem;
        border-radius: 0.13rem 0 0 0.13rem;
        float: right;
        color: #ffffff;
        display: flex;
        align-items: center;
      }
    }
     .vertical-line::after {
      content: '';
      position: absolute;
      right: 0;
      bottom: 0.05rem;
      display: block;
      width: 0.01rem;
      height: 0.2rem;
      background: var(--g-color-F3);
     }
  }
  .pro_arg {
    background: #fff;
    margin-top: 0.15rem;
    &:first-of-type {
      margin-top: 0;
    }
    .pro_arg_tit {
      font-size: 0.14rem;
      line-height: 0.2rem;
      color: #292929;
      font-weight: 500;
    }
    .pro_arg_list {
      margin: 0 0.15rem;
      font-size: 0.13rem;
      line-height: 0.18rem;
      .pro_arg_item {
        margin-top: 0.2rem;
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        &.certifical_arg_item {
          margin-top: 0.1rem;
          display: block;
        }
        span:nth-child(1) {
          color: #a0a0a0;
          flex-shrink: 0;
          -webkit-flex-shrink: 0;
          -moz-flex-shrink: 0;
          -ms-flex-shrink: 0;
          -o-flex-shrink: 0;
          line-height: 0.18rem;
          &.certifical_title {
            color: #3d3d3d;
          }
        }
        span:nth-child(2) {
          color: #383333;
          line-height: 0.18rem;
          margin-left: 0.2rem;
          &.certifical_desc {
            display: block;
            font-size: 0.12rem;
            margin-left: 0;
            color: #909090;
          }
        }
      }
      .pro_arg_more {
        text-align: center;
        color: #999999;
        margin-top: 0.15rem;
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        align-items: center;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        -o-align-items: center;
        justify-content: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -ms-justify-content: center;
        -o-justify-content: center;
        .van-icon {
          margin-left: 0.04rem;
        }
      }
    }
  }
  .pro_comment {
    border-top: solid 0.1rem #f5f5f5;
    background: #fff;
    padding: 0.2rem 0.11rem;
    .tags {
      ul {
        margin-top: -0.05rem;
        margin-bottom: -0.05rem;
        font-size: 0.12rem;
        li {
          width: 30%;
          height: 0.24rem;
          margin-right: 5%;
          line-height: 0.24rem;
          text-align: center;
          color: #292929;
          font-size: 0.12rem;
          border: 0.01rem solid #fcedeb;
          border-radius: 0.12rem;
          background: #fcedeb;
          margin-top: 0.1rem;
          white-space: nowrap;
          display: inline-block;
          &:last-of-type {
            margin-right: 0;
          }
        }
      }
    }
    .hp {
      color: #fc0324;
      font-size: 0.12rem;
      float: left;
      font-weight: blod;
      margin-left: 0.12rem;
      &.nobold {
        font-weight: 400;
      }
      &.ht {
        font-size: 0.13rem;
        font-weight: bold;
      }
    }
    .pro_comment_tit {
      font-size: 0.14rem;
      color: #292929;
      font-weight: bold;
      position: relative;
      /*margin: 0 0.04rem;*/
      .pro_comment_more {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        display: -webkit-flex;
        display: -o-flex;
        display: -ms-flex;
        display: -moz-flex;
        align-items: center;
        -webkit-align-items: center;
        -o-align-items: center;
        -ms-align-items: center;
        -moz-align-items: center;
        .van-icon-arrow {
          float: left;
        }
      }
    }
    .pro_comment_item {
      margin-top: 0.15rem;
      .comment_head_info {
        position: relative;
        overflow: hidden;
        .sj {
          position: absolute;
          right: 0;
          top: 0;
          z-index: 9;
          font-size: 0.12rem;
          .van-icon-star {
            font-size: 0.13rem;
          }
        }
        .img {
          width: 0.37rem;
          float: left;
          img {
            width: 0.37rem;
            height: 0.37rem;
            border-radius: 0.37rem;
          }
        }
        .info {
          float: left;
          position: relative;
          left: 0.1rem;
          padding-bottom: 0.1rem;
          .name {
            font-size: 0.14rem;
            line-height: 0.2rem;
            /*padding-left: .1rem;*/
            width: 2rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            img {
              width: 0.32rem;
              height: 0.15rem;
              display: inline-block;
              vertical-align: middle;
              // margin-left: -.1rem;
            }
          }

          .time {
            font-size: 0.1rem;
            /*transform: scale(0.95);*/
            color: #afb0af;
            padding-top: 0.03rem;
          }
        }
      }
      .comment_content_info {
        padding-left: 0;
        .comment_txt {
          font-size: 0.14rem;
          line-height: 0.2rem;
          color: #6d6d6d;
          word-break: break-word;
          .isfeedback {
            border-radius: 0.02rem;
            border: 0.01rem solid #fc0324;
            margin-right: 0.02rem;
          }
        }
        .comment_pic {
          .swiper-container {
            width: 100%;
            height: 100%;
            .swiper-slide {
              margin-top: 0.1rem;
              border-radius: 0.08rem;
              overflow: hidden;
              text-align: center;
              font-size: 0.18rem;
              background: #fff;
              height: 0.79rem;
              display: -webkit-box;
              display: -ms-flexbox;
              display: -webkit-flex;
              display: flex;
              -webkit-box-pack: center;
              -ms-flex-pack: center;
              -webkit-justify-content: center;
              justify-content: center;
              -webkit-box-align: center;
              -ms-flex-align: center;
              -webkit-align-items: center;
              align-items: center;
              img {
                width: 100%;
                height: 100%;
                border-radius: 0.04rem;
                overflow: hidden;
                object-fit: cover;
              }
            }
          }
        }
      }
      .comment_oper {
        overflow: hidden;
        .button {
          /*border: solid 1px #606060;*/
          padding: 0.04rem 0.08rem;
          display: inline-block;
          border-radius: 0.15rem;
          font-size: 0.11rem;
          color: #6d6d6d;
          float: right;
          margin-left: 0.15rem;
          margin-top: 0.1rem;
          img {
            width: 0.16rem;
            height: 0.16rem;
            display: block;
            float: left;
            margin-right: 0.05rem;
          }
        }
      }
    }
    .goodcomments {
      position: relative;
      padding-top: 0.15rem;
      margin-top: 0.11rem;
      &:after {
        content: '';
        display: block;
        width: 100%;
        height: 0.01rem;
        background: #d8d8d8;
        position: absolute;
        top: 0;
      }
      .pro_comment_item {
        margin-top: 0.11rem;
        .comment_content_info {
          .comment_pic .swiper-container .swiper-slide {
            margin-top: 0;
          }
        }
      }
      &.problems {
        margin-top: 0.15rem;
        .problemslist {
          > div {
            line-height: 0.17rem;
            margin-top: 0.04rem;
            &:first-of-type {
              margin-top: 0.09rem;
            }
          }
          p {
            line-height: 0.17rem;
            &:before {
              content: '问';
              vertical-align: middle;
              display: inline-block;
              width: 0.12rem;
              height: 0.12rem;
              line-height: 0.12rem;
              text-align: center;
              margin-top: -0.02rem;
              margin-right: 0.04rem;
              color: #ffffff;
              font-size: 0.1rem;
              border-radius: 0.02rem;
              background: linear-gradient(180deg, #fe074a 0%, #fc0324 100%);
              background: -webkit-linear-gradient(180deg, #fe074a 0%, #fc0324 100%);
              background: -moz-linear-gradient(180deg, #fe074a 0%, #fc0324 100%);
              background: -ms-linear-gradient(180deg, #fe074a 0%, #fc0324 100%);
              background: -o-linear-gradient(180deg, #fe074a 0%, #fc0324 100%);
            }
          }
          span {
            margin-left: 0.2rem;
          }
          button {
            border-radius: 0.14rem;
            border: 0.01rem solid #fc0324;
            background: none;
            outline: none;
            padding: 0.02rem 0.12rem;
          }
        }
      }
    }
  }
  .pro_details {
    margin-top: 0.1rem;
    background: #fff;
    /*padding-bottom: .2rem;*/
    .pro_details_tit {
      font-size: 0.14rem;
      color: #292929;
      font-weight: 600;
      padding: 0.2rem 0.11rem;
      padding-bottom: 0.1rem;
    }
    .pro_details_con {
      font-size: 0.14rem;
      img {
        width: 100% !important;
        height: auto !important;
        display: block;
      }
    }
  }

  .pro_related_goods {
    border-top: solid 0.1rem #f5f5f5;
    background: #fff;
    .pro_related_goods_tit {
      width: 50%;
      margin: 0 auto;
    }
    .pro_related_list {
      padding: 0 0.11rem;
      margin-bottom: 0.5rem;
      background: #fff;
      overflow: hidden;
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      flex-wrap: wrap;
      -moz-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      -webkit-flex-wrap: wrap;
      -o-flex-wrap: wrap;
      .pro_item:nth-child(2n) {
        padding-left: 0.035rem;
      }
      .pro_item:nth-child(2n-1) {
        padding-right: 0.035rem;
      }
    }
    .productbanner {
      div {
        border-radius: 0.04rem;
        height: 0.6rem;
        overflow: hidden;
        margin-top: 0.08rem;
        position: relative;
        img {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          -webkit-transform: translateY(-50%);
          -moz-transform: translateY(-50%);
          -ms-transform: translateY(-50%);
          -o-transform: translateY(-50%);
        }
        &:first-of-type {
          margin-top: 0;
        }
      }
    }
  }
  .pro_goods_menu {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0.49rem;
    background: #fff;
    z-index: 99;
    padding: 0 0.11rem;
    .iconbtn {
      width: 40%;
      overflow: hidden;
      padding-top: 0.09rem;
      margin-bottom: 0.07rem;
      padding-right: 0.1rem;
      > div {
        width: 0.32rem;
        margin-right: 0.1rem;
        .txt {
          white-space: nowrap;
        }
      }
      .kefu {
        img {
          width: 0.17rem;
          height: 0.17rem;
          margin: 0 auto;
        }
        .txt {
          font-size: 0.12rem;
          text-align: center;
          transform: scale(0.75);
          color: #222222;
        }
      }
      .cart {
        img {
          width: 0.17rem;
          height: 0.17rem;
          margin: 0 auto;
        }
        .txt {
          font-size: 0.12rem;
          text-align: center;
          transform: scale(0.75);
          color: #222222;
        }
      }
      .comment {
        margin-right: 0;
      }
    }
    .button {
      float: right;
      width: 30%;
      height: 0.38rem;
      color: #fff;
      font-size: 0.16rem;
      line-height: 0.38rem;
      text-align: center;
      border-radius: 0.19rem;
      margin-bottom: 0.07rem;
      &.daiBtn {
        line-height: 0.17rem;
        padding-top: 0.02rem;
        font-size: 0.12rem;
      }
      &.buyBtnWidth {
        width: 63%;
      }
      &.buyBtnWidth1 {
        width: 86%;
      }
      p {
        color: #ffffff;
        font-size: 0.12rem;
      }
    }
    .shopcart {
      background: #222222;
      margin-top: 0.06rem;
      background: linear-gradient(90deg, rgba(255, 167, 0, 1) 0%, rgba(255, 186, 0, 1) 100%);
      background: -webkit-linear-gradient(
        90deg,
        rgba(255, 167, 0, 1) 0%,
        rgba(255, 186, 0, 1) 100%
      );
      background: -moz-linear-gradient(90deg, rgba(255, 167, 0, 1) 0%, rgba(255, 186, 0, 1) 100%);
      background: -ms-linear-gradient(90deg, rgba(255, 167, 0, 1) 0%, rgba(255, 186, 0, 1) 100%);
      background: -o-linear-gradient(90deg, rgba(255, 167, 0, 1) 0%, rgba(255, 186, 0, 1) 100%);
    }
    .buy {
      margin-left: 0.08rem;
      /*margin-right: 0.11rem;*/
      margin-top: 0.06rem;
      background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(255, 20, 79, 1) 100%);
      background: -webkit-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(255, 20, 79, 1) 100%);
      background: -moz-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(255, 20, 79, 1) 100%);
      background: -ms-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(255, 20, 79, 1) 100%);
      background: -o-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(255, 20, 79, 1) 100%);
    }
    .payDeposit {
      margin: 0.025rem 0.11rem 0 0.08rem;
      width: 2.28rem;
      background: #e3e3e3;
      color: #fff;
      &.active {
        background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(255, 20, 79, 1) 100%);
      }
    }
    &.footbtn {
      .iconbtn {
        width: 25%;
      }
      .payDeposit {
        width: 2.58rem;
      }
    }
  }
  .marquee {
    position: fixed;
    left: 0.1rem;
    top: 0.5rem;
    z-index: 1;
    width: 62%;
    height: 0.3rem;
    background: #fc0324;
    opacity: 0.6;
    border-radius: 0.15rem;
    padding: 0.01rem;
    .marqueeitem {
      font-size: 0.13rem;
      color: #ffffff;
      line-height: 0.28rem;
      img {
        width: 0.28rem;
        height: 0.28rem;
        float: left;
        border-radius: 0.14rem;
        margin-right: 0.1rem;
      }
    }
  }
  .sharecontainer {
    position: fixed;
    width: 100%;
    z-index: 100;
    height: 100%;
    left: 0;
    top: 0;
    img {
      position: absolute;
      top: 0;
      right: 0.35rem;
      width: 1.53rem;
    }
    .know {
      width: 1.09rem;
      height: 0.36rem;
      line-height: 0.36rem;
      color: #fff;
      border-color: #fff;
      background: transparent;
      position: absolute;
      bottom: 1.5rem;
      left: 50%;
      margin-left: -0.54rem;
    }
  }
  .sure1 {
    background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
  }
  .sureGray {
    opacity: 0.38;
  }
  .sure {
    background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    height: 0.43rem;
    border-radius: 0.25rem;
    line-height: 0.22rem;
    font-size: 0.16rem;
  }
  .depositTime {
    text-align: center;
    color: #fc0324;
    font-size: 0.12rem;
  }
  .parsetime {
    color: #ffcaca;
    font-size: 0.12rem;
    line-height: 0.14rem;
    /*transform: scale(0.85);*/
  }
  .poster_shadow {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.69);
    padding: 0 0.14rem;
    z-index: 9999;
    .poster_shadow_swiper {
      font-size: 0;
      width: 87%;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      .van-loading--spinner {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -295%);
        -webkit-transform: translate(-50%, -295%);
        -moz-transform: translate(-50%, -295%);
        -ms-transform: translate(-50%, -295%);
        -o-transform: translate(-50%, -295%);
        z-index: 1;
      }
      .poster_swiper {
        background: #ffffff;
        border-radius: 0.04rem;
        padding-top: 0.22rem;
        margin-bottom: 0.1rem;
        overflow: hidden;
        position: relative;
        .swiper-container {
          width: 100%;
          height: 3rem;
          margin-left: auto;
          margin-right: auto;
        }
        .swiper-slide {
          background-size: cover;
          background-position: center;
        }
        .gallery-top {
          /*height: 80%;*/
          width: auto;
          padding-left: 0.12rem;
          padding-right: 0.12rem;
          background: #fff;
          overflow-y: auto;
          &.gallery {
            position: absolute;
            left: 0;
            top: 0.22rem;
            z-index: 1;
          }
          #posterimg {
            -webkit-touch-callout: none; /* iOS Safari */
            -webkit-user-select: none; /* Chrome/Safari/Opera */
            -khtml-user-select: none; /* Konqueror */
            -moz-user-select: none; /* Firefox */
            -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently not supported by any browser */
          }
          .swiper-slide {
            img {
              width: 100%;
              &.imgCls {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                transform: -webkit-translate(-50%, -50%);
                transform: -moz-translate(-50%, -50%);
                transform: -ms-translate(-50%, -50%);
                transform: -o-translate(-50%, -50%);
              }
              /*height: 100%;*/
              /*border-radius: 0.04rem;*/
            }
            .qrcode {
              /*padding-top: 0.06rem;*/
              /*padding-bottom: 0.13rem;*/
              width: 100%;
              padding: 0.26rem 0.2rem 0.26rem 0.2rem;
              display: flex;
              display: -webkit-flex;
              display: -ms-flex;
              display: -moz-flex;
              display: -o-flex;
              justify-content: space-between;
              -webkit-justify-content: space-between;
              -ms-justify-content: space-between;
              -moz-justify-content: space-between;
              -o-justify-content: space-between;
              /*align-items: center;*/
              /*-webkit-align-items: center;*/
              /*-ms-align-items: center;*/
              /*-moz-align-items: center;*/
              /*-o-align-items: center;*/
              img {
                /*margin-right: 0.18rem;*/
              }
              p {
                text-align: left;
                b {
                  margin-top: 0.04rem;
                  font-weight: 400;
                }
              }
              .poster-p {
                display: flex;
                display: -webkit-flex;
                display: -moz-flex;
                display: -ms-flex;
                display: -o-flex;
                align-items: flex-end;
                -webkit-align-items: flex-end;
                -moz-align-items: flex-end;
                -ms-align-items: flex-end;
                -o-align-items: flex-end;
                margin-top: 0.13rem;
                b {
                  margin-top: 0;
                  &:first-of-type {
                    font-size: 0.22rem;
                    font-weight: 600;
                    color: rgba(255, 39, 66, 1);
                    line-height: 0.18rem;
                    &:before {
                      content: '¥';
                      font-size: 0.13rem;
                      font-weight: 400;
                      font-style: normal;
                      color: rgba(255, 39, 66, 1);
                      line-height: 0.13rem;
                    }
                  }
                  &:nth-of-type(2) {
                    font-size: 0.13rem;
                    font-weight: 400;
                    font-style: normal;
                    color: rgba(102, 102, 102, 1);
                    line-height: 0.13rem;
                    position: relative;
                    &:after {
                      content: '';
                      position: absolute;
                      top: 50%;
                      width: 100%;
                      height: 0.01rem;
                      background: rgba(102, 102, 102, 1);
                      display: block;
                    }
                  }
                }
              }
            }
          }
        }
        .gallery-thumbs {
          /*display: none;// 注掉 海报改布局用*/
          padding-top: 0.06rem;
          padding-bottom: 0.13rem;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          position: absolute;
          left: 0.12rem;
          right: 0;
          bottom: 0.52rem;
          background: #fff;
          .swiper-wrapper {
            height: 100%;
          }
        }
        .gallery-thumbs .swiper-slide {
          overflow: hidden;
          height: 0.93rem;
          width: 0.93rem;
          /*opacity: 0.4;*/
          img {
            width: 100%;
            height: 100%;
          }
        }
        .gallery-thumbs .swiper-slide-thumb-active {
          opacity: 1;
          border: 0.02rem solid #bb9773;
        }
        .botton {
          display: block;
          font-size: 0.14rem;
          font-weight: 400;
          color: rgba(41, 41, 41, 1);
          line-height: 0.51rem;
          text-align: center;
          height: 0.51rem;
          border-top: 0.01rem solid #efefef;
          margin-left: 0.14rem;
          margin-right: 0.13rem;
          margin-top: -0.23rem;
          background: #fff;
          z-index: 100;
          position: relative;
          img {
            width: 0.16rem;
            height: 0.16rem;
            display: inline-block;
            vertical-align: sub;
            margin-right: 0.09rem;
          }
        }
      }
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .van-action_model {
    padding-bottom: 0.8rem;
    height: 60vh;
    overflow-y: scroll;
    &.certifical {
      height: auto;
      padding-bottom: 0.5rem;
      border-top: 0.01rem solid #efefef;
    }
    .van-item {
      margin: 0.14rem;
      .tit {
        font-size: 0.14rem;
        color: #262626;
        font-weight: 400;
        line-height: 0.23rem;
      }
      .con {
        padding-top: 0.1rem;
        line-height: 0.23rem;
        font-size: 0.14rem;
        color: #333333;
      }
    }
    .btn {
      padding: 0.14rem;
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      margin: 0;
      .vanbtn {
        color: #ffffff;
        width: 100%;
        height: 0.43rem;
        background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
        border-radius: 0.25rem;
      }
    }
  }
  .van-action-sheet__close {
    background: url('../../assets/images/closex.png') center no-repeat;
    background-size: 0.2rem 0.2rem;
  }
  .presale_info_dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    .dialog {
      width: 79%;
      margin: 0 auto;
      background: #fff;
      border-radius: 0.04rem;
      height: 2.24rem;
      position: relative;
      .header {
        width: 70%;
        margin: 0 auto;
        font-weight: bold;
        .van-divider {
          display: -webkit-box;
          display: -webkit-flex;
          display: flex;
          -webkit-box-align: center;
          -webkit-align-items: center;
          align-items: center;
          margin: 0.2rem 0;
          line-height: 0.24rem;
          border-color: #666666;
          border-style: solid;
          border-width: 0;
          color: #333333;
          font-size: 0.21rem;
        }
        .van-divider::before,
        .van-divider::after {
          content: ' ';
          display: block;
          -webkit-box-flex: 1;
          -webkit-flex: 1;
          flex: 1;
          box-sizing: border-box;
          height: 1px;
          border-color: inherit;
          border-style: inherit;
          border-width: 0 0 0;
          margin-right: 0.16rem;
          margin-left: 0.16rem;
        }
      }
      .content {
        width: 80%;
        margin: 0 auto;
        text-align: center;
        color: #444444;
        font-size: 0.14rem;
        margin-top: 0.02rem;
        line-height: 0.2rem;
        height: 1.2rem;
        overflow-y: auto;
      }
      .btn {
        background: #fc0324;
        width: 50%;
        text-align: center;
        color: #fff;
        font-size: 0.15rem;
        border-radius: 0.16rem;
        height: 0.31rem;
        line-height: 0.31rem;
        position: absolute;
        left: 25%;
        bottom: 0.22rem;
      }
    }
  }
  .homeBtn {
    z-index: 10;
    position: fixed;
    right: 0.17rem;
    bottom: 0.9rem;
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -webkit-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -moz-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -ms-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -o-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -o-flex;
    flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    -webkit-justify-content: center;
    -o-justify-content: center;
    align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;
    img {
      width: 0.4rem;
      height: 0.4rem;
      display: block;
    }
  }
  #img {
    position: relative;
    #posterlogoewm {
      content: '';
      display: block;
      width: 0.2rem;
      height: 0.2rem;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
    }
  }
  .popular-science-bg {
    background: linear-gradient( 180deg, #FFE6E9 0%, #FFFFFF 100%);
    height: 4.06rem;
  }
}
.coupon_list_action_sheet {
  height: 67%;
}
.cart {
  width: 0.24rem;
  margin: 0 auto;
  position: relative;
  i {
    display: flex;
    display: -ms-flex;
    display: -o-flex;
    display: -moz-flex;
    display: -webkit-flex;
    align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    -moz-align-items: center;
    -webkit-align-items: center;
    justify-content: center;
    -ms-justify-content: center;
    -o-justify-content: center;
    -moz-justify-content: center;
    -webkit-justify-content: center;
    font-style: normal;
    position: absolute;
    min-width: 0.15rem;
    height: 0.15rem;
    background: rgba(252, 3, 36, 1);
    font-size: 0.1rem;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    border-radius: 0.15rem;
    right: -20%;
    top: -15%;
  }
}
</style>
<style lang="scss">
.productDetail {
  .pro_actinfo {
    .pro_arg.headers {
      .van-icon {
        top: 0.05rem;
      }
    }
    .headers {
      .title {
        .msgitem .van-tag {
          padding: 0 0.02rem;
        }
      }
      .big12 {
        .van-tag {
          padding: 0.035rem 0.05rem;
        }
      }
    }
  }
  .pro_tit {
    .van-tag {
      padding: 0.035rem 0.05rem;
      margin-right: 0.03rem;
      line-height: 0.12rem;
    }
  }
  .good_sku {
    .van-icon-cross {
      background: url('../../assets/images/close3.png') no-repeat center;
      background-size: 100%;
      color: transparent;
    }
  }
}
.container {
  .good_sku .van-sku-row__item {
    border-radius: 0.15rem;
    font-size: 0.13rem;
    color: #5e5e5e;
    padding: 0 0.1rem;
    border: solid 1px transparent;
  }
  .good_sku .van-sku-row__item::before {
    background: #eeeff4;
  }
  .good_sku .van-sku__goods-price {
    margin-top: 0.2rem;
  }
  .good_sku .van-sku__price-symbol,
  .van-sku__price-num {
    font-size: 0.16rem;
    color: #fc0324;
    font-weight: 600;
  }
  .good_sku .van-sku__costprice-symbol {
    margin-left: 0.05rem;
  }
  .good_sku .van-sku__costprice-symbol,
  .van-sku__costprice-num {
    font-size: 0.12rem;
    color: #979797;
    font-weight: normal;
    line-height: 0.2rem;
    text-decoration: line-through;
  }
  .good_sku .van-sku-row__item--active {
    border: solid 1px #fc0324;
    background-color: #fcedeb;
    color: #fc0324;
  }
  .good_sku .van-sku-row__item-name {
    padding: 0.06rem;
  }
  .good_sku .van-sku-row__item-img {
    width: 0.2rem;
    height: 0.2rem;
  }
  .good_sku.van-popup--bottom.van-popup--round {
    border-radius: 0;
  }
  .good_sku .van-sku-row__title,
  .van-sku__stepper-title {
    padding-bottom: 0.13rem;
    font-size: 0.13rem;
    color: #333333;
    line-height: 0.18rem;
    font-weight: 600;
  }
  .good_sku .van-sku__stepper {
    border-radius: 0.13rem;
    overflow: hidden;
  }
  .good_sku .van-stepper__minus,
  .van-stepper__plus,
  .van-stepper__input {
    height: 0.22rem;
  }
  .good_sku .van-stepper__minus::before,
  .van-stepper__plus::before {
    width: 9px;
  }
  .good_sku .van-stepper__minus::after,
  .van-stepper__plus::after {
    height: 9px;
  }
  .good_sku .van-sku-row__item--disabled {
    background: #fcfcfc;
    border-radius: 0.15rem;
    border: 1px solid #eeeff4;
    color: #dedede;
    &:before {
      background: #fcfcfc;
    }
  }
  .pro_details_con {
    font-size: 0.14rem;
  }
  .pro_details_con img {
    width: 100% !important;
    height: auto !important;
  }
  .pro_details_con .ckeditor-html5-video {
    width: 100%;
  }
  .pro_details_con .ckeditor-html5-video video {
    width: 100%;
  }

  .van-uploader__wrapper,
  .poster-upload .van-uploader__input-wrapper {
    width: 100%;
    height: 0.22rem;
    position: relative;
  }
  .van-uploader__preview {
    display: none !important;
  }
  .van-uploader__upload,
  .van-uploader__preview {
    overflow: hidden !important;
    border-radius: 0.03rem !important;
    border-color: #979797;
    &.fullscreen video {
      position: fixed !important;
      left: 0 !important;
      right: 0 !important;
      top: 0 !important;
      bottom: 0 !important;
      width: 100% !important;
      height: 100% !important;
      border-width: 0 !important;
      z-index: 10000;
      background: #222222;
      .van-uploader__preview-delete:before {
        display: none !important;
      }
    }
    .videofile {
      height: 100%;
      width: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/productdetail/productDetail.vue